import { __decorate, __metadata } from 'tslib';
import * as i0 from '@angular/core';
import { Injectable, EventEmitter, inject, Component, ChangeDetectionStrategy, Input, Output, InjectionToken, NgModule, Inject, ViewEncapsulation, Injector, HostBinding, ViewChild, ElementRef, Directive, makeEnvironmentProviders, importProvidersFrom, isDevMode } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd, provideRouter } from '@angular/router';
import { Actions, ofType, concatLatestFrom, createEffect, provideEffects } from '@ngrx/effects';
import { createAction, props, on, createFeature, Store, createSelector, provideStore, provideState } from '@ngrx/store';
import { BehaviorSubject, tap, of, map, forkJoin, filter, Observable, switchMap, catchError, debounceTime, Subject, combineLatest, take, timer, distinctUntilChanged, delay } from 'rxjs';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { createImmerReducer } from 'ngrx-immer/store';
import * as i1$1 from '@angular/common';
import { NgClass, CommonModule, NgIf } from '@angular/common';
import * as i2 from '@ngneat/transloco';
import { TranslocoService, TRANSLOCO_CONFIG, translocoConfig, TRANSLOCO_LOADER, TranslocoModule } from '@ngneat/transloco';
import * as i1 from '@angular/common/http';
import { HttpClient, HttpParams, HttpClientModule, provideHttpClient, withJsonpSupport } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routerReducer, provideRouterStore } from '@ngrx/router-store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import * as i2$1 from '@angular/google-maps';
import { GoogleMapsModule } from '@angular/google-maps';
import { BreakpointObserver } from '@angular/cdk/layout';
import * as i2$2 from '@angular/forms';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { createCustomElement } from '@angular/elements';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { colors, getRadius, computeDistanceBetween } from '@helsana/shared-maps-utils';
import * as i3 from '@rx-angular/template/let';
import { LetModule } from '@rx-angular/template/let';
import { UiSelectComponent, UiCheckboxComponent, UiAutocompleteComponent, UiOverlayHeaderComponent } from '@helsana/shared-maps-ui';
import * as i2$3 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

var LerbFinderMode;
(function (LerbFinderMode) {
    LerbFinderMode["Provider"] = "Provider";
    LerbFinderMode["Doctor"] = "Doctor";
})(LerbFinderMode || (LerbFinderMode = {}));

const source$f = `[Lerb Finder | Search Component]`;
const onInit$4 = createAction(`${source$f} On Init`);
const onDestroy = createAction(`${source$f} On Destroy`);
const overlayCloseButtonClicked = createAction(`${source$f} Overlay Close Button Clicked`);
const selectProvider$2 = createAction(`${source$f} Select Provider`, props());
const selectResultTab = createAction(`${source$f} Select Result Tab`, props());
const searchButtonClicked = createAction(`${source$f} Search Button Clicked`, props());
const resetFilter = createAction(`${source$f} Reset Filter`);
const detailsBackClicked = createAction(`${source$f} Details Back Clicked`, props());
const locationBackClicked = createAction(`${source$f} Location Back Clicked`);
const resetSearchFields = createAction(`${source$f} Reset Search Fields`);
const adjustSearchButtonClicked$1 = createAction(`${source$f} Adjust Search Button Clicked`);
// !! Google Maps Component
// !! /////////////////////
const mapMarkerClicked = createAction(`${source$f} Map Marker Clicked`, props());
const mapMarkerHovered = createAction(`${source$f} Map Marker Hovered`, props());
const mapClicked = createAction(`${source$f} Map Clicked`);
const mapUpdated = createAction(`${source$f} Map Updated`, props());

var searchComponent_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    adjustSearchButtonClicked: adjustSearchButtonClicked$1,
    detailsBackClicked: detailsBackClicked,
    locationBackClicked: locationBackClicked,
    mapClicked: mapClicked,
    mapMarkerClicked: mapMarkerClicked,
    mapMarkerHovered: mapMarkerHovered,
    mapUpdated: mapUpdated,
    onDestroy: onDestroy,
    onInit: onInit$4,
    overlayCloseButtonClicked: overlayCloseButtonClicked,
    resetFilter: resetFilter,
    resetSearchFields: resetSearchFields,
    searchButtonClicked: searchButtonClicked,
    selectProvider: selectProvider$2,
    selectResultTab: selectResultTab
});

const source$e = `[Lerb Finder | Details Component]`;
const onInit$3 = createAction(`${source$e} On Init`, props());
const chooseProviderClicked = createAction(`${source$e} Choose Provider Clicked`);
const chooseProviderContacted = createAction(`${source$e} Choose Provider Contacted`, props());
const backClicked$1 = createAction(`${source$e} Back Clicked`);
const openGoogleMapsClicked$1 = createAction(`${source$e} Open Google Maps Clicked`, props());
const toolTipClicked = createAction(`${source$e} Tool Tip Clicked`, props());

var detailsComponent_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    backClicked: backClicked$1,
    chooseProviderClicked: chooseProviderClicked,
    chooseProviderContacted: chooseProviderContacted,
    onInit: onInit$3,
    openGoogleMapsClicked: openGoogleMapsClicked$1,
    toolTipClicked: toolTipClicked
});

const source$d = `[Lerb Finder | Location Component]`;
const onInit$2 = createAction(`${source$d} On Init`);
const selectProvider$1 = createAction(`${source$d} Select Provider`, props());
const backClicked = createAction(`${source$d} Back Clicked`);
const openGoogleMapsClicked = createAction(`${source$d} Open Google Maps Clicked`, props());

var locationComponent_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    backClicked: backClicked,
    onInit: onInit$2,
    openGoogleMapsClicked: openGoogleMapsClicked,
    selectProvider: selectProvider$1
});

const source$c = `[Lerb Finder | Map Preview Component]`;
const mapPreviewClicked = createAction(`${source$c} Map Preview Clicked`);

var mapPreviewComponent_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    mapPreviewClicked: mapPreviewClicked
});

const source$b = `[Lerb Finder | Lerb Finder Component]`;
const onInit$1 = createAction(`${source$b} On Init`, props());

var lerbFinderComponent_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    onInit: onInit$1
});

const source$a = `[Lerb Finder]`;
const providerViaInputDropdownResultsSelected = createAction(`${source$a} Provider Via Input Dropdown Results Selected`, props());
const selectProvider = createAction(`${source$a} Select Provider`, props());
const selectProviderFailure = createAction(`${source$a} Select Provider Failure`);
const selectLocation$1 = createAction(`${source$a} Select Location`, props());
const searchInputInvalid = createAction(`${source$a} Search Input Invalid`);
const showMapPreview = createAction(`${source$a} Show Map Preview`, props());
const screenSize = createAction(`${source$a} Screen Size Changed`, props());

var lerbFinder_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    providerViaInputDropdownResultsSelected: providerViaInputDropdownResultsSelected,
    screenSize: screenSize,
    searchInputInvalid: searchInputInvalid,
    selectLocation: selectLocation$1,
    selectProvider: selectProvider,
    selectProviderFailure: selectProviderFailure,
    showMapPreview: showMapPreview
});

/* eslint-disable @typescript-eslint/no-explicit-any */
const source$9 = `[Lerb Finder | API]`;
// !! Zip Search
// !! //////////
const zipSearchProviderSuccess = createAction(`${source$9} Zip Search Provider Success`, props());
const zipSearchProviderFailure = createAction(`${source$9} Zip Search Provider Failure`, props());
const zipSearchDoctorSuccess = createAction(`${source$9} Zip Search Doctor Success`, props());
const zipSearchDoctorFailure = createAction(`${source$9} Zip Search Doctor Failure`, props());
// !! Area Search
// !! ///////////
const areaSearchProviderSuccess = createAction(`${source$9} Area Search Provider Success`, props());
const areaSearchProviderFailure = createAction(`${source$9} Area Search Provider Failure`, props());
const areaSearchDoctorSuccess = createAction(`${source$9} Area Search Doctor Success`, props());
const areaSearchDoctorFailure = createAction(`${source$9} Area Search Doctor Failure`, props());
// !! Location Search
// !! ///////////////
const locationSearchProviderSuccess = createAction(`${source$9} Location Search Provider Success`, props());
const locationSearchProviderFailure = createAction(`${source$9} Location Search Provider Failure`, props());
const locationSearchDoctorSuccess = createAction(`${source$9} Location Search Doctor Success`, props());
const locationSearchDoctorFailure = createAction(`${source$9} Location Search Doctor Failure`, props());
// !!
// !!
// !!
const getProvidersByPlzSuccess = createAction(`${source$9} Get Providers By Plz Success`, props());
const getProvidersByPlzFailure = createAction(`${source$9} Get Providers By Plz Failure`);
const getProvidersByGeolocationSuccess = createAction(`${source$9} Get Providers By Geolocation Success`, props());
const getProvidersByGeolocationFailure = createAction(`${source$9} Get Providers By Geolocation Failure `);
const getProviderSuccess = createAction(`${source$9} Get Provider Success`, props());
const getProviderFailure = createAction(`${source$9} Get Provider Failure`);
const inputDoctorSearchSuccess = createAction(`${source$9} Input Doctor Search Success`, props());
const inputDoctorSearchFailure = createAction(`${source$9} Input Doctor Search Failure`, props());
const inputProviderSearchSuccess = createAction(`${source$9} Input Provider Search Success`, props());
const inputProviderSearchFailure = createAction(`${source$9} Input Provider Search Failure`, props());
const searchFailure = createAction(`${source$9} Search Failure`);
const getMethodsSuccess = createAction(`${source$9} Methods Success`, props());
const getMethodsFailure = createAction(`${source$9} Methods Failure`);

var api_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    areaSearchDoctorFailure: areaSearchDoctorFailure,
    areaSearchDoctorSuccess: areaSearchDoctorSuccess,
    areaSearchProviderFailure: areaSearchProviderFailure,
    areaSearchProviderSuccess: areaSearchProviderSuccess,
    getMethodsFailure: getMethodsFailure,
    getMethodsSuccess: getMethodsSuccess,
    getProviderFailure: getProviderFailure,
    getProviderSuccess: getProviderSuccess,
    getProvidersByGeolocationFailure: getProvidersByGeolocationFailure,
    getProvidersByGeolocationSuccess: getProvidersByGeolocationSuccess,
    getProvidersByPlzFailure: getProvidersByPlzFailure,
    getProvidersByPlzSuccess: getProvidersByPlzSuccess,
    inputDoctorSearchFailure: inputDoctorSearchFailure,
    inputDoctorSearchSuccess: inputDoctorSearchSuccess,
    inputProviderSearchFailure: inputProviderSearchFailure,
    inputProviderSearchSuccess: inputProviderSearchSuccess,
    locationSearchDoctorFailure: locationSearchDoctorFailure,
    locationSearchDoctorSuccess: locationSearchDoctorSuccess,
    locationSearchProviderFailure: locationSearchProviderFailure,
    locationSearchProviderSuccess: locationSearchProviderSuccess,
    searchFailure: searchFailure,
    zipSearchDoctorFailure: zipSearchDoctorFailure,
    zipSearchDoctorSuccess: zipSearchDoctorSuccess,
    zipSearchProviderFailure: zipSearchProviderFailure,
    zipSearchProviderSuccess: zipSearchProviderSuccess
});

const noOp = createAction('[No Op]');

var noOp_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    noOp: noOp
});

const source$8 = '[Lerb Finder | Provider Filter]';
const onInit = createAction(`${source$8} On Init`);
const providerTypeFilterChanged = createAction(`${source$8} Provider Type Filter Changed`, 
// TODO Malvin merge - wanna let the 0 exist?
props());
const methodFilterChanged = createAction(`${source$8} Provider Method Filter Changed`, props());

var providerFilterComponent_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    methodFilterChanged: methodFilterChanged,
    onInit: onInit,
    providerTypeFilterChanged: providerTypeFilterChanged
});

const source$7 = `[Lerb Finder | Quick Access Filter Component]`;
const removeAcceptPatientsButtonClicked = createAction(`${source$7} Remove Accept Patients Button Clicked`, props());
const removeOnlyPediatriciansOnlyButtonClicked = createAction(`${source$7} Remove Only Pediatricians Only Button Clicked`, props());
const removeProviderTypeIdButtonClicked = createAction(`${source$7} Remove Provider Type Id Button Clicked`, props());
const removeMethodButtonClicked = createAction(`${source$7} Remove Method Button Clicked`, props());
const adjustSearchButtonClicked = createAction(`${source$7} Adjust Search Button Clicked`);

var quickAccessFilterComponent_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    adjustSearchButtonClicked: adjustSearchButtonClicked,
    removeAcceptPatientsButtonClicked: removeAcceptPatientsButtonClicked,
    removeMethodButtonClicked: removeMethodButtonClicked,
    removeOnlyPediatriciansOnlyButtonClicked: removeOnlyPediatriciansOnlyButtonClicked,
    removeProviderTypeIdButtonClicked: removeProviderTypeIdButtonClicked
});

const source$6 = `[Lerb Finder | Geo Location Component]`;
const isLocationActiveCheckboxChanged = createAction(`${source$6} Is Location Active Checkbox Changed`, props());

var geoLocationComponent_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    isLocationActiveCheckboxChanged: isLocationActiveCheckboxChanged
});

const source$5 = `[Lerb Finder | Geo Location]`;
const activateLocationSuccess = createAction(`${source$5} Activate Location Success`, props());
const activateLocationFailure = createAction(`${source$5} Activate Location Failure`);
const locationDeactivated = createAction(`${source$5} Location Deactivated`);

var geoLocation_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    activateLocationFailure: activateLocationFailure,
    activateLocationSuccess: activateLocationSuccess,
    locationDeactivated: locationDeactivated
});

const source$4 = `[Lerb Finder | Search Area Button Component]`;
const searchAreabuttonClicked = createAction(`${source$4} Search Area Button Clicked`, props());

var searchAreaButtonComponent_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    searchAreabuttonClicked: searchAreabuttonClicked
});

const source$3 = `[Lerb Finder | List Component]`;
const hoverLocation = createAction(`${source$3} Hovered List Location`, props());
const unhoverLocation = createAction(`${source$3} Unhovered List Location Reset`);

var listComponent_action = /*#__PURE__*/Object.freeze({
    __proto__: null,
    hoverLocation: hoverLocation,
    unhoverLocation: unhoverLocation
});

const source$2 = `[Lerb Finder | Doctor Filter Component]`;
const pediatriciansOnlyCheckboxChanged = createAction(`${source$2} Pediatricians Only Checkbox Changed`, props());
const acceptsNewPatiensCheckboxChanged = createAction(`${source$2} Accepts New Patients Checkbox Changed`, props());

var doctorFilterComponent_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    acceptsNewPatiensCheckboxChanged: acceptsNewPatiensCheckboxChanged,
    pediatriciansOnlyCheckboxChanged: pediatriciansOnlyCheckboxChanged
});

const source$1 = `[Lerb Finder | Input Search Component]`;
const userChangedInput = createAction(`${source$1} User Changed Input`, props());
const inputResetButtonClicked = createAction(`${source$1} Input Reset Button Clicked`);
const blurAutocomplete = createAction(`${source$1} Blur Autocomplete`);

var inputSearchComponent_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    blurAutocomplete: blurAutocomplete,
    inputResetButtonClicked: inputResetButtonClicked,
    userChangedInput: userChangedInput
});

const source = `[Lerb Finder | Tool Tip Component]`;
const closeButtonClicked = createAction(`${source} Close Button Clicked`);

var toolTipComponent_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    closeButtonClicked: closeButtonClicked
});

var Language;
(function (Language) {
    Language["en"] = "en";
    Language["de"] = "de";
    Language["fr"] = "fr";
    Language["it"] = "it";
})(Language || (Language = {}));

// TODO Malvin now rename
function isSearchLerb(toBeDetermined) {
    return !!toBeDetermined?.id;
}
// TODO Malvin now rename
function isZipLocation(toBeDetermined) {
    return !!toBeDetermined?.postalCode;
}
var HostEnvironment;
(function (HostEnvironment) {
    HostEnvironment["PROD"] = "https://portal.helsana.ch";
    HostEnvironment["PREPROD"] = "https://portal.helsana-preprod.ch";
    HostEnvironment["INT"] = "https://portal.helsana-integration.ch";
})(HostEnvironment || (HostEnvironment = {}));

const MAX_SEARCH_RESULTS = 1000;
function getInputOption(result) {
    const label = isSearchLerb(result)
        ? getFormattedInput(result)
        : result.formattedString;
    return { label, value: result };
}
function getFormattedInput(input) {
    if (!input)
        return '';
    if (typeof input === 'string')
        return input;
    return isSearchLerb(input)
        ? input.vorname?.trim()
            ? `${input.vorname} ${input.name} (${input.ort})`
            : `${input.name} (${input.ort})`
        : input.formattedString;
}
var QuickAccessFilterParamEnum;
(function (QuickAccessFilterParamEnum) {
    QuickAccessFilterParamEnum["pediatriciansOnly"] = "pediatriciansOnly";
    QuickAccessFilterParamEnum["acceptsNewPatients"] = "acceptsNewPatients";
    QuickAccessFilterParamEnum["providerTypeId"] = "providerTypeId";
    QuickAccessFilterParamEnum["method"] = "method";
})(QuickAccessFilterParamEnum || (QuickAccessFilterParamEnum = {}));
/**
 * The number for each provider type is defined by the API.
 */
var ProviderTypeId;
(function (ProviderTypeId) {
    ProviderTypeId[ProviderTypeId["ALL"] = 0] = "ALL";
    ProviderTypeId[ProviderTypeId["AVM_OTHER"] = 1] = "AVM_OTHER";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    ProviderTypeId[ProviderTypeId["AVM_GROUP"] = 1] = "AVM_GROUP";
    ProviderTypeId[ProviderTypeId["AVM_PEDIA"] = 2] = "AVM_PEDIA";
    ProviderTypeId[ProviderTypeId["PSY"] = 3] = "PSY";
    ProviderTypeId[ProviderTypeId["EMR"] = 4] = "EMR";
    ProviderTypeId[ProviderTypeId["FIT"] = 5] = "FIT";
    ProviderTypeId[ProviderTypeId["KUR"] = 6] = "KUR";
})(ProviderTypeId || (ProviderTypeId = {}));
var ProviderType;
(function (ProviderType) {
    ProviderType["AVM_OTHER"] = "AVM_OTHER";
    ProviderType["AVM_GROUP"] = "AVM_GROUP";
    ProviderType["AVM_PEDIA"] = "AVM_PEDIA";
    ProviderType["PSY"] = "PSY";
    ProviderType["EMR"] = "EMR";
    ProviderType["FIT"] = "FIT";
    ProviderType["KUR"] = "KUR";
})(ProviderType || (ProviderType = {}));
// TODO Malvin translation check if translated? if not provide
var ProviderCategory;
(function (ProviderCategory) {
    ProviderCategory["Doctors"] = "Haus\u00E4rzte und Gruppenpraxen";
    ProviderCategory["Pediatricians"] = "Kinder\u00E4rzte";
    ProviderCategory["Therapists"] = "Komplement\u00E4rtherapeuten";
    ProviderCategory["Fitness"] = "Fitnesscenter";
    ProviderCategory["Course"] = "Kursleiter";
})(ProviderCategory || (ProviderCategory = {}));
function getProviderTypeIdByProviderType(providerType) {
    switch (providerType) {
        case ProviderType.AVM_OTHER:
            return ProviderTypeId.AVM_OTHER;
        case ProviderType.AVM_GROUP:
            return ProviderTypeId.AVM_GROUP;
        case ProviderType.AVM_PEDIA:
            return ProviderTypeId.AVM_PEDIA;
        case ProviderType.PSY:
            return ProviderTypeId.PSY;
        case ProviderType.EMR:
            return ProviderTypeId.EMR;
        case ProviderType.FIT:
            return ProviderTypeId.FIT;
        case ProviderType.KUR:
            return ProviderTypeId.KUR;
        default:
            return ProviderTypeId.AVM_OTHER;
    }
}
function getProviderTypeById(providerTypeId) {
    switch (providerTypeId) {
        case ProviderTypeId.AVM_GROUP:
            return ProviderType.AVM_GROUP;
        case ProviderTypeId.AVM_PEDIA:
            return ProviderType.AVM_PEDIA;
        case ProviderTypeId.PSY:
            return ProviderType.PSY;
        case ProviderTypeId.EMR:
            return ProviderType.EMR;
        case ProviderTypeId.FIT:
            return ProviderType.FIT;
        case ProviderTypeId.KUR:
            return ProviderType.KUR;
        default:
            return ProviderType.AVM_OTHER;
    }
}
function getProviderTypeByNum(num) {
    switch (num) {
        case ProviderTypeId.AVM_GROUP || ProviderTypeId.AVM_OTHER:
            return ProviderType.AVM_GROUP;
        case ProviderTypeId.AVM_PEDIA:
            return ProviderType.AVM_PEDIA;
        case ProviderTypeId.PSY:
            return ProviderType.PSY;
        case ProviderTypeId.EMR:
            return ProviderType.EMR;
        case ProviderTypeId.FIT:
            return ProviderType.FIT;
        case ProviderTypeId.KUR:
            return ProviderType.KUR;
        default:
            return ProviderType.AVM_OTHER;
    }
}

const doctorsTranslationKey = 'ProviderTypes.hausarztUndGruppenpraxen';
const pediatriciansTranslationKey = 'ProviderTypes.kinderaerzte';
const complementaryTherapistsTranslationKey = 'ProviderTypes.komplementaertherapeuten';
const fitnesscenterTranslationKey = 'ProviderTypes.fitnesscenter';
const teacherTranslationKey = 'ProviderTypes.kursleiter';
function getProviderTypeTranslationByFieldNumber(fieldType) {
    switch (fieldType) {
        case ProviderTypeId.AVM_OTHER:
        case ProviderTypeId.AVM_GROUP:
            return doctorsTranslationKey;
        case ProviderTypeId.AVM_PEDIA:
            return pediatriciansTranslationKey;
        case ProviderTypeId.EMR:
            return complementaryTherapistsTranslationKey;
        case ProviderTypeId.FIT:
            return fitnesscenterTranslationKey;
        case ProviderTypeId.KUR:
            return teacherTranslationKey;
        default:
            return '';
    }
}
function getProviderTypeTranslationByFieldName(type) {
    switch (type) {
        case ProviderType.AVM_OTHER:
        case ProviderType.AVM_GROUP:
            return doctorsTranslationKey;
        case ProviderType.AVM_PEDIA:
            return pediatriciansTranslationKey;
        case ProviderType.EMR:
            return complementaryTherapistsTranslationKey;
        case ProviderType.FIT:
            return fitnesscenterTranslationKey;
        case ProviderType.KUR:
            return teacherTranslationKey;
        default:
            return '';
    }
}

const providerTypeOptions = [
    {
        value: ProviderTypeId.ALL,
        label: 'ProviderFilterComponent.alleLeistungserbringer',
    },
    {
        value: ProviderTypeId.AVM_GROUP || ProviderTypeId.AVM_OTHER,
        label: getProviderTypeTranslationByFieldNumber(ProviderTypeId.AVM_GROUP),
        icon: 'hausarzt',
    },
    {
        value: ProviderTypeId.AVM_PEDIA,
        label: getProviderTypeTranslationByFieldNumber(ProviderTypeId.AVM_PEDIA),
        icon: 'Kinderarzt',
    },
    {
        value: ProviderTypeId.EMR,
        label: getProviderTypeTranslationByFieldNumber(ProviderTypeId.EMR),
        icon: 'leaf',
    },
    {
        value: ProviderTypeId.FIT,
        label: getProviderTypeTranslationByFieldNumber(ProviderTypeId.FIT),
        icon: 'gesundheitsfoerderung',
    },
    {
        value: ProviderTypeId.KUR,
        label: getProviderTypeTranslationByFieldNumber(ProviderTypeId.KUR),
        icon: 'kursleiter',
    },
];

const initialState = {
    lerbFinderMode: LerbFinderMode.Provider,
    avmProduct: null,
    language: Language.de,
    offsetScrolling: 0,
    isLoading: false,
    inputSearch: {
        state: 'init',
        input: null,
        selectedLerb: null,
        selectedZip: null,
        results: null,
        initTimestamp: 0,
        adjustSearch: false,
    },
    search: {
        state: 'init',
        results: null,
        lastSuccessTimestamp: 0,
    },
    area: {
        center: null,
        radius: null,
        hasTooMuchResults: false,
        hideAreaSearchButton: false,
        hasNoResults: false,
    },
    providersInViewport: null,
    submittedDoctorFilterForm: {
        acceptsNewPatients: null,
        pediatriciansOnly: null,
    },
    submittedInput: null,
    submittedProviderFilterForm: {
        method: 0,
        providerTypeId: ProviderTypeId.ALL,
        methods: [],
    },
    doctorFilterForm: {
        pediatriciansOnly: null,
        acceptsNewPatients: null,
    },
    location: null,
    isLocationActive: false,
    isActivatingLocation: false,
    mapUpdate: {
        isDetailsBackClickedEventMapUpdate: false,
        mapPreviewClicked: false,
    },
    providerFilterForm: {
        method: 0,
        providerTypeId: ProviderTypeId.ALL,
        methods: [],
    },
    detailsProvider: null,
    openToolTip: false,
    expertiseGroups: null,
    selectedLocationId: null,
    selectedMapPreviewId: null,
    selectedResultTab: 'map',
    hoveredLocationId: null,
    isDesktop: false,
    isTablet: false,
    isDetailViewActive: false,
    isOverlayMode: false,
    pageOffset: null,
    isSearchComponentDesroyed: false,
};
// TODO Malvin handle errors
const lerbFinderReducer = createImmerReducer(initialState, 
// !! Lerb Finder
// !! ///////////
on(providerViaInputDropdownResultsSelected, (state, { provider }) => {
    state.search.results = [provider];
    state.search.state = 'providerSelectedViaInput';
    state.submittedInput = getFormattedInput(state.inputSearch.input);
    state.pageOffset = { x: window.scrollX, y: window.scrollY };
    state.isDetailViewActive = true;
    return state;
}), on(selectLocation$1, (state, { id }) => {
    state.detailsProvider = null; // prevents any unwanted scrolling in the location list
    state.expertiseGroups = null;
    state.selectedLocationId = id;
    return state;
}), on(showMapPreview, (state, { id }) => {
    state.selectedMapPreviewId = id;
    return state;
}), on(screenSize, (state, action) => {
    state.isDesktop = action.isDesktop;
    state.isTablet = action.isTablet;
    return state;
}), on(selectProvider, (state) => {
    state.pageOffset = { x: window.scrollX, y: window.scrollY };
    return state;
}), on(selectLocation$1, (state) => {
    state.pageOffset = { x: window.scrollX, y: window.scrollY };
    return state;
}), 
// !! Lerb Finder Component
// !! /////////////////////
on(onInit$1, (state, { lerbFinderMode, language, avmProduct, initialType, isOverlayMode, offsetScrolling }) => {
    state.lerbFinderMode = lerbFinderMode || LerbFinderMode.Provider;
    state.language = language || Language.de;
    state.avmProduct = avmProduct || null;
    state.providerFilterForm.providerTypeId = parseInt(initialType || '')
        ? parseInt(initialType || '')
        : 0; // for all provider types filter
    state.isOverlayMode = isOverlayMode;
    state.offsetScrolling = offsetScrolling || 0;
    state.pageOffset = { x: window.scrollX, y: window.scrollY };
    return state;
}), 
// !! Search Component
// !! ////////////////
on(onInit$4, (state) => {
    state.isSearchComponentDesroyed = false;
    return state;
}), on(mapUpdated, (state, { mapUpdate }) => {
    state.area.center = mapUpdate.center;
    state.area.radius = mapUpdate.radius;
    const providersInViewport = [];
    mapUpdate.coordsInViewPort.forEach((coord) => state.search.results?.forEach((provider) => {
        if (coord.lat === provider.lat &&
            coord.lng === provider.lng &&
            !providersInViewport.find((p) => p.id === provider.id))
            providersInViewport.push(provider);
    }));
    const diff = new Date().getTime() - state.search.lastSuccessTimestamp;
    if (diff < 800 || diff > 1000000) {
        state.area.hideAreaSearchButton = true;
    }
    else {
        state.area.hideAreaSearchButton = false;
        state.area.hasTooMuchResults = false;
        state.area.hasNoResults = false;
    }
    // check if the update was triggered by back navigation, if so, hide seach area button
    if (state.mapUpdate.isDetailsBackClickedEventMapUpdate) {
        state.mapUpdate.mapPreviewClicked = false;
        state.mapUpdate.isDetailsBackClickedEventMapUpdate = false;
        state.area.hideAreaSearchButton = true;
    }
    state.providersInViewport = providersInViewport;
    state.isLoading = false;
    return state;
}), on(overlayCloseButtonClicked, (state) => {
    state = {
        ...state,
        isDesktop: state.isDesktop,
        isTablet: state.isTablet,
    };
    return state;
}), on(selectResultTab, (state, { tab }) => {
    state.selectedResultTab = tab;
    return state;
}), on(mapClicked, (state) => {
    state.selectedMapPreviewId = null;
    return state;
}), on(detailsBackClicked, (state) => {
    state.detailsProvider = null;
    state.expertiseGroups = null;
    state.isDetailViewActive = false;
    state.mapUpdate.isDetailsBackClickedEventMapUpdate = true;
    return state;
}), on(locationBackClicked, (state) => {
    state.selectedLocationId = null;
    return state;
}), on(resetSearchFields, (state) => {
    state.inputSearch = { ...initialState.inputSearch };
    state.search = { ...initialState.search };
    state.area = { ...initialState.area };
    state.providersInViewport = [];
    state.selectedResultTab = 'map';
    state.doctorFilterForm.pediatriciansOnly = null;
    state.doctorFilterForm.acceptsNewPatients = null;
    state.providerFilterForm.method = 0;
    state.providerFilterForm.providerTypeId = ProviderTypeId.ALL;
    state.location = null;
    state.isLocationActive = false;
    state.detailsProvider = null;
    state.expertiseGroups = null;
    return state;
}), 
// Set submitted so that we know
on(searchButtonClicked, (state) => {
    state.submittedInput = getFormattedInput(state.inputSearch.input);
    state.submittedDoctorFilterForm = { ...state.doctorFilterForm };
    state.submittedProviderFilterForm = { ...state.providerFilterForm };
    state.detailsProvider = null;
    state.selectedLocationId = null;
    state.isLoading = true;
    return state;
}), on(adjustSearchButtonClicked$1, (state) => {
    state.inputSearch.adjustSearch = true;
    state.isLoading = true;
    return state;
}), on(selectProvider$2, (state) => {
    state.pageOffset = { x: window.scrollX, y: window.scrollY };
    return state;
}), on(onDestroy, (state) => {
    state.isSearchComponentDesroyed = true;
    return state;
}), 
// !! Input Search Component
// !! //////////////////////
on(userChangedInput, (state, { input }) => {
    // String has been typed, either providerSearch or doctorSearch will happen
    if (typeof input === 'string') {
        state.inputSearch.input = input;
        state.inputSearch.state =
            state.lerbFinderMode === LerbFinderMode.Provider
                ? 'provider'
                : 'doctor';
        state.inputSearch.selectedLerb = null;
        state.inputSearch.selectedZip = null;
        state.location = null;
        state.isLocationActive = false;
        return state;
    }
    // Lerb has been selected
    if (isSearchLerb(input)) {
        state.inputSearch.input = getFormattedInput(input);
        state.inputSearch.selectedLerb = input;
        state.inputSearch.state = 'lerbSelected';
        // TODO Malvin now
        // state.listProviders = [
        //   {
        //     ...input,
        //     aufnahme: input.aufnahme === 'Y' ? '1' : '3',
        //     rabatt: input.hrabatt,
        //     field: input.typ === 'AVM_PEDIA' ? 2 : 1,
        //   },
        // ];
        return state;
    }
    // Zip has been selected
    if (isZipLocation(input)) {
        state.inputSearch.input = getFormattedInput(input);
        state.inputSearch.selectedZip = input;
        state.inputSearch.state = 'zipSelected';
    }
    return state;
}), on(inputResetButtonClicked, (state) => {
    return resetToInitState(state, 'init');
}), on(blurAutocomplete, (state) => {
    state.inputSearch.adjustSearch = false;
    return state;
}), 
// !! Doctor Filter Component
// !! ///////////////////////
on(acceptsNewPatiensCheckboxChanged, (state, { acceptsNewPatients }) => {
    state.doctorFilterForm.acceptsNewPatients = acceptsNewPatients;
    return state;
}), on(pediatriciansOnlyCheckboxChanged, (state, { pediatriciansOnly }) => {
    state.doctorFilterForm.pediatriciansOnly = pediatriciansOnly;
    return state;
}), 
// !! Provider Filter Component
// !! /////////////////////////
on(providerTypeFilterChanged, (state, { providerType }) => {
    state.providerFilterForm.providerTypeId = providerType;
    state.providerFilterForm.method = 0;
    return state;
}), on(methodFilterChanged, (state, { method }) => {
    state.providerFilterForm.providerTypeId =
        method && state.providerFilterForm.providerTypeId === ProviderTypeId.ALL
            ? getProviderByMethod(method, state.providerFilterForm.methods)
            : state.providerFilterForm.providerTypeId;
    state.providerFilterForm.method = method;
    return state;
}), 
// !! Geo Location Component
// !! //////////////////////
on(isLocationActiveCheckboxChanged, (state, { isLocationActive }) => {
    if (isLocationActive) {
        state.isActivatingLocation = true;
        // Reset inputSearch while attempting to activate
        // so no other search can happen inbetween
        state.inputSearch.input = null;
        state.inputSearch.results = null;
        state.inputSearch.selectedLerb = null;
        state.inputSearch.selectedZip = null;
        state.inputSearch.state = 'init';
    }
    return state;
}), 
// !! Quick Access Filter Component
// !! /////////////////////////////
on(removeAcceptPatientsButtonClicked, (state) => {
    if (state.inputSearch.state !== 'area')
        state.doctorFilterForm.acceptsNewPatients = false;
    return state;
}), on(removeOnlyPediatriciansOnlyButtonClicked, (state) => {
    if (state.inputSearch.state !== 'area')
        state.doctorFilterForm.pediatriciansOnly = false;
    return state;
}), on(removeProviderTypeIdButtonClicked, (state) => {
    if (state.inputSearch.state !== 'area') {
        state.providerFilterForm.providerTypeId = ProviderTypeId.ALL;
        state.providerFilterForm.method = 0;
    }
    return state;
}), on(removeMethodButtonClicked, (state) => {
    if (state.inputSearch.state !== 'area')
        state.providerFilterForm.method = 0;
    return state;
}), on(adjustSearchButtonClicked, (state) => {
    state.inputSearch.adjustSearch = true;
    return state;
}), 
// !! Geo Location
// !! ////////////
on(activateLocationSuccess, (state, { location, input }) => {
    state.location = location;
    state.isLocationActive = true;
    state.isActivatingLocation = false;
    // Set inputSearch properly
    state.inputSearch.input = input;
    state.inputSearch.state = 'location';
    state.inputSearch.results = null;
    state.inputSearch.selectedLerb = null;
    state.inputSearch.selectedZip = null;
    return state;
}), on(activateLocationFailure, (state) => {
    state.location = null;
    state.isLocationActive = false;
    state.isActivatingLocation = false;
    return state;
}), on(locationDeactivated, (state) => {
    state.location = null;
    state.isLocationActive = false;
    state.isActivatingLocation = false;
    state.inputSearch.input = null;
    state.inputSearch.results = null;
    state.inputSearch.selectedLerb = null;
    state.inputSearch.selectedZip = null;
    state.inputSearch.state = 'init';
    return state;
}), 
// !! Location Component
// !! //////////////////
on(backClicked, (state) => {
    state.selectedLocationId = null;
    state.selectedMapPreviewId = null;
    return state;
}), 
// !! Details Component
// !! /////////////////
on(onInit$3, (state) => {
    state.isDetailViewActive = true;
    return state;
}), on(backClicked$1, (state) => {
    state.mapUpdate.isDetailsBackClickedEventMapUpdate = true;
    state.selectedMapPreviewId = null;
    state.isDetailViewActive = false;
    return state;
}), on(toolTipClicked, (state, { isOpen }) => {
    state.openToolTip = isOpen;
    return state;
}), 
// !! ToolTip Component
// !! /////////////////
on(closeButtonClicked, (state) => {
    state.openToolTip = false;
    return state;
}), 
// !! MapPreview Component
// !! /////////////////
on(mapPreviewClicked, (state) => {
    state.mapUpdate = { ...state.mapUpdate, mapPreviewClicked: true };
    return state;
}), 
// !! List Component
// !! //////////////
on(hoverLocation, (state, { id }) => {
    state.hoveredLocationId = id;
    return state;
}), on(unhoverLocation, (state) => {
    state.hoveredLocationId = null;
    return state;
}), 
// !! Search Area Button Component
// !! ////////////////////////////
on(searchAreabuttonClicked, (state, { input, center, radius }) => {
    // Update inputSearch
    state.inputSearch.input = input;
    state.inputSearch.results = null;
    state.inputSearch.selectedLerb = null;
    state.inputSearch.selectedZip = null;
    state.inputSearch.state = 'area'; // TODO Malvin hier schon setzen?
    state.area.center = center;
    state.area.radius = radius;
    state.submittedInput = getFormattedInput(state.inputSearch.input);
    state.submittedDoctorFilterForm = { ...state.doctorFilterForm };
    state.submittedProviderFilterForm = { ...state.providerFilterForm };
    // Update location
    state.location = null;
    state.isActivatingLocation = false;
    state.isLocationActive = false;
    return state;
}), 
// !! Api
// !! ///
// !! Zip Search
// !! //////////
on(zipSearchProviderSuccess, (state, { providers }) => {
    // Set results
    state.search.results = filterSearchResults(providers, state.avmProduct, state.submittedDoctorFilterForm.acceptsNewPatients);
    state.search.state = 'zipSuccess';
    // TODO Malvin
    state.submittedInput = getFormattedInput(state.inputSearch.input);
    state.submittedProviderFilterForm = { ...state.providerFilterForm };
    state.area.hasTooMuchResults = false;
    state.area.hasNoResults = false;
    state.search.lastSuccessTimestamp = new Date().getTime();
    state.area.hideAreaSearchButton = true;
    state.isLoading = false;
    return state;
}), on(zipSearchProviderFailure, (state) => {
    state.search.state = 'zipFailure';
    state.isLoading = false;
    return state;
}), on(zipSearchDoctorSuccess, (state, { providers }) => {
    state.search.results = filterSearchResults(providers, state.avmProduct, state.doctorFilterForm.acceptsNewPatients);
    state.search.state = 'zipSuccess';
    state.submittedInput = getFormattedInput(state.inputSearch.input);
    state.submittedDoctorFilterForm = { ...state.doctorFilterForm };
    state.area.hasTooMuchResults = false;
    state.area.hasNoResults = false;
    state.search.lastSuccessTimestamp = new Date().getTime();
    state.area.hideAreaSearchButton = true;
    state.isLoading = false;
    return state;
}), on(zipSearchDoctorFailure, (state) => {
    state.search.state = 'zipFailure';
    state.isLoading = false;
    return state;
}), 
// !! Location Search
// !! ///////////////
on(locationSearchProviderSuccess, (state, { providers }) => {
    state.search.results = filterSearchResults(providers, state.avmProduct, state.submittedDoctorFilterForm.acceptsNewPatients);
    state.search.state = 'locationSuccess';
    state.submittedInput = getFormattedInput(state.inputSearch.input);
    state.submittedProviderFilterForm = { ...state.providerFilterForm };
    state.area.hasTooMuchResults = false;
    state.area.hasNoResults = false;
    state.search.lastSuccessTimestamp = new Date().getTime();
    state.area.hideAreaSearchButton = true;
    state.isLoading = false;
    return state;
}), on(locationSearchProviderFailure, (state) => {
    state.search.state = 'locationFailure';
    state.isLoading = false;
    return state;
}), on(locationSearchDoctorSuccess, (state, { providers }) => {
    state.search.results = filterSearchResults(providers, state.avmProduct, state.submittedDoctorFilterForm.acceptsNewPatients);
    state.search.state = 'locationSuccess';
    state.submittedInput = getFormattedInput(state.inputSearch.input);
    state.submittedDoctorFilterForm = { ...state.doctorFilterForm };
    state.area.hasTooMuchResults = false;
    state.area.hasNoResults = false;
    state.search.lastSuccessTimestamp = new Date().getTime();
    state.area.hideAreaSearchButton = true;
    state.isLoading = false;
    return state;
}), on(locationSearchDoctorFailure, (state) => {
    state.search.state = 'locationFailure';
    state.isLoading = false;
    return state;
}), 
// !! Area Search
// !! ///////////
on(areaSearchProviderSuccess, (state, { providers, providerFilterForm }) => {
    if (providers.length > MAX_SEARCH_RESULTS) {
        state.area.hasTooMuchResults = true;
        state.isLoading = false;
        return state;
    }
    if (providers.length === 0) {
        state.area.hasNoResults = true;
        state.isLoading = false;
        return state;
    }
    // Set results
    state.search.results = filterSearchResults(providers, state.avmProduct, state.submittedDoctorFilterForm.acceptsNewPatients);
    state.search.state = 'areaSuccess';
    // Set the real forms
    state.providerFilterForm.providerTypeId =
        providerFilterForm.providerTypeId;
    state.providerFilterForm.method = providerFilterForm.method;
    // Set the submitted forms
    state.submittedProviderFilterForm.providerTypeId =
        providerFilterForm.providerTypeId;
    state.submittedProviderFilterForm.method = providerFilterForm.method;
    state.submittedInput = getFormattedInput(state.inputSearch.input);
    // Not too much results
    state.area.hasTooMuchResults = false;
    state.area.hasNoResults = false;
    // last success
    state.search.lastSuccessTimestamp = new Date().getTime();
    // Hide the button
    state.area.hideAreaSearchButton = true;
    state.isLoading = false;
    return state;
}), on(areaSearchProviderFailure, (state) => {
    state.search.state = 'areaFailure';
    state.isLoading = false;
    return state;
}), on(areaSearchDoctorSuccess, (state, { providers, doctorFilterForm }) => {
    if (providers.length > MAX_SEARCH_RESULTS) {
        state.area.hasTooMuchResults = true;
        return state;
    }
    if (providers.length === 0) {
        state.area.hasNoResults = true;
        return state;
    }
    // Set results
    state.search.results = filterSearchResults(providers, state.avmProduct, state.submittedDoctorFilterForm.acceptsNewPatients);
    state.search.state = 'areaSuccess';
    // Set the real forms
    state.doctorFilterForm.acceptsNewPatients =
        doctorFilterForm.acceptsNewPatients;
    state.doctorFilterForm.pediatriciansOnly =
        doctorFilterForm.pediatriciansOnly;
    // Set the submitted forms
    state.submittedDoctorFilterForm.acceptsNewPatients =
        doctorFilterForm.acceptsNewPatients;
    state.submittedDoctorFilterForm.pediatriciansOnly =
        doctorFilterForm.pediatriciansOnly;
    state.submittedInput = getFormattedInput(state.inputSearch.input);
    // Not too much results
    state.area.hasTooMuchResults = false;
    state.area.hasNoResults = false;
    // last success
    state.search.lastSuccessTimestamp = new Date().getTime();
    // Hide the button
    state.area.hideAreaSearchButton = true;
    state.isLoading = false;
    return state;
}), on(areaSearchDoctorFailure, (state) => {
    state.search.state = 'areaFailure';
    state.isLoading = false;
    return state;
}), on(getProviderSuccess, (state, { provider, expertiseGroups }) => {
    state.detailsProvider = provider;
    state.expertiseGroups = expertiseGroups || null;
    return state;
}), on(inputDoctorSearchSuccess, (state, { results }) => {
    state.inputSearch.results = results;
    state.inputSearch.state = 'doctorSuccess';
    return state;
}), on(inputDoctorSearchFailure, (state) => {
    state.inputSearch.state = 'doctorFailure';
    return state;
}), on(inputProviderSearchSuccess, (state, { results }) => {
    state.inputSearch.results = results;
    state.inputSearch.state = 'providerSuccess';
    return state;
}), on(inputProviderSearchFailure, (state) => {
    state.inputSearch.state = 'providerFailure';
    return state;
}), on(getMethodsSuccess, (state, { methods }) => {
    state.providerFilterForm.methods = methods;
    return state;
}));
function getProviderByMethod(methodId, methods) {
    const method = methods.find((method) => method.id === methodId);
    if (method) {
        const providerType = providerTypeOptions.find((provider) => getProviderTypeByNum(provider.value) === method.typ)?.value ?? ProviderTypeId.ALL;
        return providerType;
    }
    return ProviderTypeId.ALL;
}
function resetToInitState(state, desiredInputSearchState) {
    if (desiredInputSearchState === 'init') {
        state.inputSearch = { ...initialState.inputSearch };
        state.search = { ...initialState.search };
        state.area = { ...initialState.area };
        state.location = null;
        state.isLocationActive = false;
        state.providersInViewport = [];
        state.selectedResultTab = 'map';
        state.detailsProvider = null;
        state.expertiseGroups = null;
    }
    state.inputSearch.state = desiredInputSearchState;
    state.inputSearch.initTimestamp = new Date().getTime();
    return state;
}
function filterSearchResults(providers, avmProduct, acceptsNewPatients) {
    if (avmProduct) {
        return acceptsNewPatients
            ? providers.filter((provider) => provider.products?.some((product) => product.avmdefId === avmProduct && product.aufnahme === '1'))
            : providers.filter((provider) => provider.products?.some((product) => product.avmdefId === avmProduct));
    }
    return providers;
}

const lerbFinderFeature = createFeature({
    name: 'lerb-finder',
    reducer: lerbFinderReducer,
});
const { selectDetailsProvider, selectOpenToolTip, selectExpertiseGroups, selectDoctorFilterForm, selectSelectedLocationId, selectIsActivatingLocation, selectSubmittedDoctorFilterForm, selectSubmittedProviderFilterForm, selectSelectedResultTab, selectArea, selectIsLocationActive, selectLocation, selectSelectedMapPreviewId, selectProviderFilterForm, selectLerbFinderMode, selectAvmProduct, selectHoveredLocationId, selectIsDesktop, selectIsTablet, selectSubmittedInput, selectLanguage, selectSearch, selectProvidersInViewport, selectInputSearch, selectMapUpdate, selectIsDetailViewActive, selectIsOverlayMode, selectIsLoading, selectOffsetScrolling, selectPageOffset, selectIsSearchComponentDesroyed, } = lerbFinderFeature;

class ScrollingService {
    constructor() {
        this.waitingTimeout = 500;
        this.scrollEvent$ = new BehaviorSubject(null);
        this._rootNode = null;
    }
    set rootNode(value) {
        this._rootNode = value;
    }
    async toId(id, behavior = 'smooth') {
        const scrollToElement = await this.isElementLoaded(id);
        if (scrollToElement?.offsetTop !== undefined) {
            this.scrollIntoView(scrollToElement, { behavior });
        }
    }
    async toTopOfId(containerId, behavior = 'smooth') {
        await this.scrollIdIntoView(containerId, { behavior, block: 'start', inline: 'start' });
    }
    async toCenterOfId(containerId, behavior = 'smooth') {
        await this.scrollIdIntoView(containerId, { behavior, block: 'center', inline: 'center' });
    }
    async toBottomOfId(containerId, behavior = 'smooth') {
        await this.scrollIdIntoView(containerId, { behavior, block: 'end', inline: 'end' });
    }
    scrollIntoView(element, options) {
        element.scrollIntoView({ ...options });
    }
    async scrollToOffset(containerId, offset, behavior = 'smooth') {
        if (this._rootNode === null)
            return;
        const element = await this.isElementLoaded(containerId);
        if (element) {
            const { top } = element.getBoundingClientRect();
            const bodyRectTop = this.getBoundeRectTopDocumentBody();
            offset = top - bodyRectTop - offset;
        }
        this.scrollTo({ behavior, top: offset });
    }
    scrollTo(options) {
        window.scrollTo({ ...options });
    }
    async isElementLoaded(id) {
        const startTime = Date.now();
        while ((this._rootNode || document).querySelector(`#${id}`) === null) {
            if (startTime + this.waitingTimeout < Date.now()) {
                break;
            }
            await new Promise((resolve) => requestAnimationFrame(resolve));
        }
        const element = this._rootNode
            ? this._rootNode.querySelector(`#${id}`)
            : document.querySelector(`#${id}`);
        return element;
    }
    getScrollElementEvent$() {
        return this.scrollEvent$;
    }
    // send event to wrapper to allow scrolling in overlays
    setScrollEvent(eventName, element) {
        this.scrollEvent$.next({ eventName, element: element });
    }
    async scrollIdIntoView(containerId, options) {
        if (this._rootNode === null)
            return;
        const scrollToElement = await this.isElementLoaded(containerId);
        scrollToElement && this.scrollIntoView(scrollToElement, options);
    }
    getBoundeRectTopDocumentBody() {
        const { top } = document.body.getBoundingClientRect();
        return top;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ScrollingService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ScrollingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ScrollingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

let LerbFinderComponent = class LerbFinderComponent {
    constructor() {
        this.offsetTop = 0;
        this.isOverlayMode = true;
        this.lerbFinderClose = new EventEmitter();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.doctorSelect = new EventEmitter(); // TODO Malvin: doctor type
        this.scrollEvent = new EventEmitter();
        this.scrollOffset = new EventEmitter();
        this.store = inject(Store);
        this.actions$ = inject(Actions);
        this.scrollingService = inject(ScrollingService);
    }
    ngOnInit() {
        // pass element to scroll to parent wrapper to allow scrolling
        // in case angular app is placed in an overlay
        this.scrollingService
            .getScrollElementEvent$()
            .pipe(untilDestroyed(this))
            .subscribe((event) => {
            if (event) {
                this.scrollEvent.emit(event);
            }
        });
        this.store.dispatch(onInit$1({
            lerbFinderMode: this.mode,
            language: this.language,
            avmProduct: this.product,
            host: this.host,
            initialType: this.initialType,
            isOverlayMode: this.isOverlayMode && LerbFinderMode.Doctor === this.mode,
            offsetScrolling: this.offsetTop
        }));
        this.actions$
            .pipe(untilDestroyed(this), ofType(overlayCloseButtonClicked), tap(() => this.lerbFinderClose.emit(true)))
            .subscribe();
        this.actions$
            .pipe(untilDestroyed(this), ofType(chooseProviderClicked), concatLatestFrom(() => this.store.select(selectDetailsProvider)), tap(([, doctor]) => this.doctorSelect.emit(doctor)))
            .subscribe();
        this.actions$.pipe(untilDestroyed(this), ofType(onDestroy), concatLatestFrom(() => this.store.select(selectIsSearchComponentDesroyed)), tap(([, isSearchComponentDesroyed]) => this.scrollOffset.emit(isSearchComponentDesroyed))).subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LerbFinderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: LerbFinderComponent, isStandalone: true, selector: "helsana-lerb-finder", inputs: { mode: "mode", language: "language", product: "product", host: "host", offsetTop: "offsetTop", initialType: "initialType", isOverlayMode: "isOverlayMode" }, outputs: { lerbFinderClose: "lerbFinderClose", doctorSelect: "doctorSelect", scrollEvent: "scrollEvent", scrollOffset: "scrollOffset" }, ngImport: i0, template: `
    <div class="w-full" [ngClass]="{ 'lg:p-8': isOverlayMode }">
      <router-outlet ></router-outlet>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: RouterOutlet, selector: "router-outlet", inputs: ["name"], outputs: ["activate", "deactivate", "attach", "detach"], exportAs: ["outlet"] }, { kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
};
LerbFinderComponent = __decorate([
    UntilDestroy()
], LerbFinderComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LerbFinderComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'helsana-lerb-finder',
                    imports: [RouterOutlet, NgClass],
                    template: `
    <div class="w-full" [ngClass]="{ 'lg:p-8': isOverlayMode }">
      <router-outlet ></router-outlet>
    </div>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { mode: [{
                type: Input
            }], language: [{
                type: Input
            }], product: [{
                type: Input
            }], host: [{
                type: Input
            }], offsetTop: [{
                type: Input
            }], initialType: [{
                type: Input
            }], isOverlayMode: [{
                type: Input
            }], lerbFinderClose: [{
                type: Output
            }], doctorSelect: [{
                type: Output
            }], scrollEvent: [{
                type: Output
            }], scrollOffset: [{
                type: Output
            }] } });

const getCoordinateId = (coordinate) => {
    return String(coordinate.lat) + String(coordinate.lng);
};

const selectSearchState = createSelector(selectSearch, (search) => search.state);
const selectSearchResults = createSelector(selectSearch, (search) => search.results);

const selectMapPreviewProviders = createSelector(selectSearchResults, selectSelectedMapPreviewId, (searchResults, selectedMapPreviewId) => searchResults?.filter((provider) => selectedMapPreviewId === getCoordinateId(provider)));
const selectLocationProviders = createSelector(selectSearchResults, selectSelectedLocationId, (searchResults, selectedLocationId) => searchResults?.filter((provider) => selectedLocationId === getCoordinateId(provider)));
const selectDetailsBackToken = createSelector(selectSelectedLocationId, (selectedLocationId) => selectedLocationId
    ? 'Selectors.SelectDetailsBackToken.zurueckZuStandort'
    : 'Selectors.SelectDetailsBackToken.zurueckZuResultaten');
const selectActiveMethodName = createSelector(selectSubmittedProviderFilterForm, (providerFilterForm) => providerFilterForm.methods.find((method) => method.id === providerFilterForm.method)?.text);
const selectActiveProviderTypeName = createSelector(selectSubmittedProviderFilterForm, (providerFilterForm) => providerTypeOptions.find((providerType) => {
    return providerType.value === providerFilterForm.providerTypeId;
})?.label);
const selectProviderFilterFormMethods = createSelector(selectSubmittedProviderFilterForm, (lerbFilterForm) => lerbFilterForm?.methods.reduce((acc, method) => ({ [method.id]: method, ...acc }), {}));
const selectListProvidersByAvm = createSelector(selectSearchResults, selectLocationProviders, selectSelectedLocationId, selectAvmProduct, (searchResults, locationProviders, selectedLocationId, avmProduct) => {
    const providers = selectedLocationId ? locationProviders : searchResults;
    return avmProduct && providers
        ? providers.filter((provider) => provider.products?.find((product) => product.avmdefId === avmProduct))
        : providers;
});
const selectProvidersInViewportByAvm = createSelector(selectProvidersInViewport, selectLocationProviders, selectSelectedLocationId, selectAvmProduct, (searchResults, locationProviders, selectedLocationId, avmProduct) => {
    const providers = selectedLocationId ? locationProviders : searchResults;
    return avmProduct && providers
        ? providers.filter((provider) => provider.products?.find((product) => product.avmdefId === avmProduct))
        : providers;
});
const selectIsValidSearchInput = createSelector(selectInputSearch, (inputSearch) => !!inputSearch.selectedLerb ||
    !!inputSearch.selectedZip ||
    inputSearch.state === 'location' ||
    inputSearch.state === 'area');
const selectIsDirectSearchInput = createSelector(selectInputSearch, (inputSearch) => inputSearch.state === 'lerbSelected');

class LerbFinderService {
    constructor() {
        this.httpClient = inject(HttpClient);
        this.translocoService = inject(TranslocoService);
        // TODO Malvin merge
        this.apiHost = 'https://portal.helsana-preprod.ch';
        this.apiBaseUrl = '/helapps/lerb-service/v2';
        this.providerPlzServiceUrl = '/helapps/provider-plz-service/v2';
        this.defaultProviderTypeIds = [1, 2]; // 1: Aerzte und Grupenpraxen/ 2: Kinderaerzte
        this.allProviderTypeIds = [1, 2, 4, 5, 6];
        this.pediatriciansOnlyProviderTypeId = [2];
        this.doctorsAndPediatriciansProviderTypeIds = [1, 2];
        // !! Helper
        // !! //////
        this.filterProvidersByDoctorFilters = ({ providers, pediatriciansOnly, acceptsNewPatients, }) => providers.filter((provider) => {
            // !! Determine types
            const providerTypeIds = pediatriciansOnly
                ? this.pediatriciansOnlyProviderTypeId
                : this.doctorsAndPediatriciansProviderTypeIds;
            // !! Then filter types
            const filterProviderTypeIds = providerTypeIds.includes(provider.field);
            // !! And if provider acceptsNewPatients
            const filterAcceptsNewPatients = (provider.aufnahme === '1' || provider.aufnahme === 'Y') &&
                filterProviderTypeIds;
            return acceptsNewPatients
                ? filterAcceptsNewPatients
                : filterProviderTypeIds;
        });
    }
    setApiHost(host) {
        if (host) {
            this.apiHost = host;
        }
    }
    getLerbServiceUrl() {
        return this.apiHost + this.apiBaseUrl;
    }
    getProviderPlzServiceUrl() {
        return this.apiHost + this.providerPlzServiceUrl;
    }
    // !! Input Search
    // !! ////////////
    inputSearchProvider(input, providerTypeId) {
        if (!input)
            return of({ results: [] });
        let params = new HttpParams().set('limit', 100);
        if (providerTypeId)
            params = params.append('typ', providerTypeId);
        return this.httpClient
            .get(`${this.getLerbServiceUrl()}/search/providerplz/${input}`, {
            params,
        })
            .pipe(map((data) => data.results.filter((results) => this.isProviderOrZipLocation(results))), map((results) => ({ results })));
    }
    inputSearchDoctor(input, pediatriciansOnly, acceptsNewPatients, avmProduct) {
        if (!input)
            return of({ results: [] });
        const typ = pediatriciansOnly
            ? this.pediatriciansOnlyProviderTypeId.toString()
            : this.doctorsAndPediatriciansProviderTypeIds.toString();
        let params = new HttpParams().set('limit', 100).set('typ', typ);
        if (avmProduct)
            params = params.append('product', avmProduct);
        return this.httpClient
            .get(`${this.getLerbServiceUrl()}/search/providerplz/${input}`, {
            params,
        })
            .pipe(map((data) => data.results
            .filter((results) => this.isProviderOrZipLocation(results))
            .filter((results) => acceptsNewPatients ? this.acceptsNewPatients(results) : results)), map((results) => ({ results })));
    }
    // !! Zip Search
    // !! //////////
    zipSearchProvider(zip, providerTypeId, method) {
        const params = new HttpParams({
            fromObject: { plz: zip.postalCode, city: zip.locality },
        });
        // !! If non is provided, fetch all providers
        let url = `${this.getLerbServiceUrl()}/providers`;
        // !! If only providerTypeId is provided, fetch those
        if (providerTypeId && !method)
            url = `${this.getLerbServiceUrl()}/providers/${providerTypeId}`;
        // !! If also method is provided, fetch providers with matching type and method
        if (providerTypeId && method)
            url = `${this.getLerbServiceUrl()}/providers/${providerTypeId}/${method}`;
        return this.httpClient.get(url, { params }).pipe();
    }
    zipSearchDoctor(zip, pediatriciansOnly, acceptsNewPatients, avmProduct) {
        let params = new HttpParams({
            fromObject: {
                plz: zip.postalCode,
                city: zip.locality,
            },
        });
        if (avmProduct)
            params = params.append('product', avmProduct);
        const apiRoute = pediatriciansOnly ? '2' : 'hausarzt';
        return this.httpClient
            .get(`${this.getLerbServiceUrl()}/providers/${apiRoute}`, { params })
            .pipe(map((results) => acceptsNewPatients
            ? results.filter((result) => result.aufnahme === '1')
            : results));
    }
    // !! Location Search
    // !! ///////////////
    locationSearchDoctor(location, radius, pediatriciansOnly, acceptsNewPatients, avmProduct, minResult = true) {
        let paramsDoctor, paramsPedia;
        paramsDoctor = paramsPedia = new HttpParams({
            fromObject: {
                lat: location.lat,
                lng: location.lng,
                maxDistance: radius,
            },
        });
        if (avmProduct) {
            paramsDoctor = paramsDoctor.append('product', avmProduct);
            paramsPedia = paramsPedia.append('product', avmProduct);
        }
        if (minResult) {
            paramsDoctor = paramsDoctor.append('minResult', minResult);
            paramsPedia = paramsPedia.append('minResult', minResult);
        }
        paramsDoctor = paramsDoctor.append('providerField', '1');
        paramsPedia = paramsPedia.append('providerField', '2');
        const doctorResult = this.httpClient
            .get(`${this.getProviderPlzServiceUrl()}/search/providers`, { params: paramsDoctor })
            .pipe(map((providers) => ({
            providers,
            pediatriciansOnly,
            acceptsNewPatients,
        })), map(this.filterProvidersByDoctorFilters));
        const pedResult = this.httpClient
            .get(`${this.getProviderPlzServiceUrl()}/search/providers`, { params: paramsPedia })
            .pipe(map((providers) => ({
            providers,
            pediatriciansOnly,
            acceptsNewPatients,
        })), map(this.filterProvidersByDoctorFilters));
        return forkJoin({ doctorResult, pedResult }).pipe(map((results) => [...results.doctorResult, ...results.pedResult]), map((results) => {
            return results.sort((a, b) => (a.distance ? a.distance : 0) - (b.distance ? b.distance : 0));
        }));
    }
    locationSearchProvider(location, radius, providerTypeId, method, minResult = true) {
        let params = new HttpParams({
            fromObject: {
                lat: location.lat,
                lng: location.lng,
                maxDistance: radius,
            },
        });
        if (minResult)
            params = params.append('minResult', minResult);
        params = providerTypeId
            ? params.append('providerField', providerTypeId)
            : params;
        params = method ? params.append('method', method) : params;
        return this.httpClient.get(`${this.getProviderPlzServiceUrl()}/search/providers`, {
            params,
        });
    }
    // !! Methods
    // !! ///////
    getMethods(language) {
        return this.httpClient.get(`${this.getLerbServiceUrl()}/method/7/${language.toUpperCase().charAt(0)}`);
    }
    getProvider(avmId, type = 1) {
        const language = this.translocoService
            .getActiveLang()
            .charAt(0)
            .toUpperCase();
        return this.httpClient
            .get(`${this.getLerbServiceUrl()}/provider/${type}/${language}/${avmId}`)
            .pipe(map((data) => data));
    }
    isProviderOrZipLocation(result) {
        return isSearchLerb(result) || isZipLocation(result);
    }
    acceptsNewPatients(result) {
        if (isSearchLerb(result)) {
            return result.aufnahme === 'Y';
        }
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LerbFinderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LerbFinderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LerbFinderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

const SEARCH = 'search';
const DETAILS = 'details';
const LOCATION = 'location';

var routeSegments = /*#__PURE__*/Object.freeze({
    __proto__: null,
    DETAILS: DETAILS,
    LOCATION: LOCATION,
    SEARCH: SEARCH
});

class RouterService {
    constructor() {
        this.router = inject(Router);
        this.subscription = this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd && event.id === 1), tap(() => {
            this.routeRelative(SEARCH);
            this.subscription.unsubscribe();
        }))
            .subscribe();
    }
    routeRelative(fragment) {
        this.router.navigate([
            fragment,
        ]);
    }
    search() {
        this.routeRelative(SEARCH);
    }
    details() {
        this.routeRelative(DETAILS);
    }
    location() {
        this.routeRelative(LOCATION);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: RouterService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: RouterService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: RouterService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class GeolocationService {
    getCurrentLocation$() {
        return new Observable((observer) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(({ coords }) => {
                    observer.next({ lat: coords.latitude, lng: coords.longitude });
                    observer.complete();
                }, (error) => {
                    observer.error(error);
                });
            }
            else {
                observer.error('Geolocation is not supported by this browser.');
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: GeolocationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: GeolocationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: GeolocationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

const isType = (value) => value !== null;
const isTypeFilter = (source$) => source$.pipe(filter(isType));

var SearchCategory;
(function (SearchCategory) {
    SearchCategory["LOCATION"] = "location";
    SearchCategory["NAME"] = "name";
    SearchCategory["GPS"] = "gps";
    SearchCategory["AREA"] = "area";
})(SearchCategory || (SearchCategory = {}));
var ContactType;
(function (ContactType) {
    ContactType["PHONE"] = "phone";
    ContactType["MAIL"] = "email";
    ContactType["MAP"] = "map";
    ContactType["WEBSITE"] = "website";
})(ContactType || (ContactType = {}));
var EventTypes;
(function (EventTypes) {
    EventTypes["LERB_SEARCH_INITIATED"] = "lerb_search_initiated";
    EventTypes["LERB_SEARCH_SUGGESTION_SELECTED"] = "lerb_search_suggestion_selected";
    EventTypes["LERB_SEARCH_SUBMITTED"] = "lerb_search_submitted";
    EventTypes["LERB_SEARCH_PROVIDER_SELECTED"] = "lerb_search_provider_selected";
    EventTypes["LERB_SEARCH_PROVIDER_CONTACTED_CLICKED"] = "lerb_search_provider_contacted_clicked";
    EventTypes["LERB_SEARCH_AREA_SUBMITTED"] = "lerb_search_area_submitted";
    EventTypes["LERB_SEARCH_QUICK_ACCESS_FILTER_ADJUSTED"] = "lerb_search_quickaccessfilter_adjusted";
})(EventTypes || (EventTypes = {}));
var ElementDataObjectIdentifier;
(function (ElementDataObjectIdentifier) {
    ElementDataObjectIdentifier["SEARCH_FIELD_INITIATED"] = "searchfield_initiated";
    ElementDataObjectIdentifier["SEARCH_FIELD_AUTOCOMPLETE_SELECTED"] = "searchfield_autocomplete_selected";
    ElementDataObjectIdentifier["SEARCH_BUTTON_CLICKED"] = "searchbutton_clicked";
    ElementDataObjectIdentifier["SEARCH_RESULT_ITEM_DETAIL_SELECTED"] = "searchResultItemDetail_selected";
    ElementDataObjectIdentifier["SEARCH_RESULT_ITEM_DETAIL_CONTACTED"] = "searchResultItemDetail_contacted";
    ElementDataObjectIdentifier["AREA_SEARCH_CLICKED"] = "areaSearch_clicked";
    ElementDataObjectIdentifier["QUICK_ACCESS_FILTER_CLICKED"] = "quickaccessfilter_clicked";
})(ElementDataObjectIdentifier || (ElementDataObjectIdentifier = {}));
var ComponentName;
(function (ComponentName) {
    ComponentName["SEARCH_FIELD"] = "Searchfield";
    ComponentName["SEARCH_FIELD_AUTOCOMPLETE"] = "Searchfield.Autocomplete";
    ComponentName["SEARCH_BUTTON"] = "SearchButton";
    ComponentName["SEARCH_RESULT_ITEM_DETAIL"] = "SearchResultItemDetail";
    ComponentName["AREA_SEARCH"] = "AreaSearch";
    ComponentName["QUICK_ACCESS_FILTER"] = "QuickAccessFilter";
})(ComponentName || (ComponentName = {}));

const WINDOW = new InjectionToken('Global window object', {
    factory: () => window,
});
class DataLayerService {
    constructor() {
        this.window = inject(WINDOW);
        this.window.adobeDataLayer = this.window.adobeDataLayer || [];
    }
    /**
     * Workaround as default language is not available in transloco service in AEM. needs to be fixed in future
     * @param translationToken
     */
    getMasterSpecialityTranslation(translationToken) {
        switch (translationToken) {
            case doctorsTranslationKey:
                return 'Hausärzte und Gruppenpraxen';
            case pediatriciansTranslationKey:
                return 'Kinderärzte';
            case complementaryTherapistsTranslationKey:
                return 'Komplementärtherapeuten';
            case fitnesscenterTranslationKey:
                return 'Fitnesscenter';
            case teacherTranslationKey:
                return 'Kursleiter';
            default:
                return '';
        }
    }
    async trackLerbSearchInitiated(mode) {
        await this.track({
            event: EventTypes.LERB_SEARCH_INITIATED,
            element: {
                componentName: this.getComponentName(ComponentName.SEARCH_FIELD, mode),
                identifier: ElementDataObjectIdentifier.SEARCH_FIELD_INITIATED,
                targetUrl: undefined,
                title: undefined,
            },
        });
    }
    async trackLerbSearchSuggestionSelected(search, mode) {
        await this.track({
            event: EventTypes.LERB_SEARCH_SUGGESTION_SELECTED,
            element: {
                componentName: this.getComponentName(ComponentName.SEARCH_FIELD_AUTOCOMPLETE, mode),
                identifier: ElementDataObjectIdentifier.SEARCH_FIELD_AUTOCOMPLETE_SELECTED,
                targetUrl: undefined,
                title: undefined,
            },
            search,
        });
    }
    async trackLerbSearchProviderSelected(mode, search) {
        return await this.track({
            event: EventTypes.LERB_SEARCH_PROVIDER_SELECTED,
            element: {
                componentName: this.getComponentName(ComponentName.SEARCH_RESULT_ITEM_DETAIL, mode),
                identifier: ElementDataObjectIdentifier.SEARCH_RESULT_ITEM_DETAIL_SELECTED,
                targetUrl: undefined,
                title: undefined,
            },
            search,
        });
    }
    async trackLerbSearchProviderContacted(mode, search) {
        return await this.track({
            event: EventTypes.LERB_SEARCH_PROVIDER_CONTACTED_CLICKED,
            element: {
                componentName: this.getComponentName(ComponentName.SEARCH_RESULT_ITEM_DETAIL, mode),
                identifier: ElementDataObjectIdentifier.SEARCH_RESULT_ITEM_DETAIL_CONTACTED,
                targetUrl: undefined,
                title: undefined,
            },
            search,
        });
    }
    async trackLerbSearchSubmitted(search, mode) {
        await this.track({
            event: EventTypes.LERB_SEARCH_SUBMITTED,
            element: {
                componentName: this.getComponentName(ComponentName.SEARCH_BUTTON, mode),
                identifier: ElementDataObjectIdentifier.SEARCH_BUTTON_CLICKED,
                targetUrl: undefined,
                title: undefined,
            },
            search,
        });
    }
    async trackLerbQuickAccessFilterAdjusted(mode, search) {
        await this.track({
            event: EventTypes.LERB_SEARCH_QUICK_ACCESS_FILTER_ADJUSTED,
            element: {
                componentName: this.getComponentName(ComponentName.QUICK_ACCESS_FILTER, mode),
                identifier: ElementDataObjectIdentifier.QUICK_ACCESS_FILTER_CLICKED,
                targetUrl: undefined,
                title: undefined,
            },
            search,
        });
    }
    async track(datalayerObject) {
        this.window.adobeDataLayer?.push({ ...datalayerObject });
    }
    getState() {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.window.adobeDataLayer?.push((dl) => resolve(dl.getState()));
        });
    }
    /**
     * last category can not be determined properly in any state in the app
     * therefor the init of the details component calls this method and takes the
     * previous state from the last datlayer object
     */
    getLastCategory() {
        const length = this.window.adobeDataLayer?.length ?? 0;
        if (length > 0) {
            const lastObject = this.window.adobeDataLayer &&
                this.window.adobeDataLayer[length - 1];
            return (lastObject?.search?.category ||
                SearchCategory.LOCATION);
        }
        return SearchCategory.LOCATION;
    }
    getComponentName(componentName, mode) {
        return LerbFinderMode.Doctor === mode
            ? `Doctor.${componentName}`
            : `Provider.${componentName}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: DataLayerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: DataLayerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: DataLayerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [] });

var de = {
	"Selectors.SelectDetailsBackToken.zurueckZuStandort": "Zurück zur Standortübersicht",
	"Selectors.SelectDetailsBackToken.zurueckZuResultaten": "Zurück zu den Resultaten",
	"GeoLocationComponentSelector.aktuellerStandortWirdVerwendet": "Aktueller Standort wird verwendet",
	"GeoLocationComponentSelector.aktuellerStandortWirdGeladen": "Aktueller Standort wird geladen",
	"GeoLocationComponentSelector.aktuellerStandortVerwenden": "Aktueller Standort verwenden",
	"LerbFinderEffects.geoLocationComponentSuccess.searchInput": "Aktueller Standort",
	"ProviderTypes.hausarztUndGruppenpraxen": "Hausärzte und Gruppenpraxen",
	"ProviderTypes.kinderaerzte": "Kinderärzte",
	"ProviderTypes.psychotherapeuten": "Psychotherapeuten",
	"ProviderTypes.komplementaertherapeuten": "Komplementärtherapeuten",
	"ProviderTypes.fitnesscenter": "Fitnesscenter",
	"ProviderTypes.kursleiter": "Kursleiter",
	"DetailsComponent.methoden": "Methoden",
	"DetailsComponent.openGoogleMaps": "Auf Google Maps anzeigen",
	"DetailsComponent.nimmtPatientenauf": "Nimmt Patienten auf",
	"DetailsComponent.nachAbspracheMitArzt": "Patientenaufnahme nur nach Absprache mit Arzt möglich",
	"DetailsComponent.netzwerk": "Netzwerk",
	"DetailsComponent.aufGrundversicherung": "auf Grundversicherung",
	"DetailsComponent.hausarztAuswaehlen": "Hausarzt auswählen",
	"DetailsComponent.zurueck": "Zurück",
	"DetailsComponent.schliessen": "Schliessen",
	"DetailsComponent.kursleiter": "Kursleiter",
	"DetailsComponent.produkt": "Mögliche Produkte",
	"DetailsComponent.avmVertrag": "Die Datenbank wird laufend aktualisiert. Die Suchergebnisse beziehen sich auf den Stand des heutigen Tages. Unterjährige Änderungen der Ärzteliste und Anpassungen der Rabatte sind möglich und bleiben ausdrücklich vorbehalten.",
	"ListComponent.aufGrundversicherung": "max. {{rabatt}}% ({{rabattCode}}) auf Grundversicherung",
	"ListComponent.nimmtPatientenauf": "Nimmt Patienten auf",
	"ListComponent.nachAbspracheMitArzt": "Patientenaufnahme nur nach Absprache mit Arzt möglich",
	"ListComponent.produkte": "Mögliche Produkte",
	"LocationComponent.zurueckZuResultaten": "Zurück zu den Resultaten",
	"LocationComponent.zurueck": "Zurück",
	"LocationComponent.schliessen": "Schliessen",
	"LocationComponent.standortuebersicht": "Standortübersicht",
	"LocationComponent.openGoogleMaps": "Auf Google Maps anzeigen",
	"MapPreviewComponent.mehrereLeistungserbringer": "Mehrere Leistungserbringer an diesem Standort.",
	"PrintViewComponent.plz": "PLZ",
	"PrintViewComponent.ort": "Ort",
	"PrintViewComponent.ergebnisse": "Ergebnisse",
	"PrintViewComponent.krankenversicherer": "Krankenversicherer",
	"PrintViewComponent.filter": "Filtern",
	"PrintViewComponent.nimmtPatientenAuf": "Nimmt Patienten auf",
	"PrintViewComponent.nurKinderaerzte": "Nur Kinderärzte",
	"PrintViewComponent.nimmtKeinePatientenAuf": "Nimmt keine neuen Patienten auf",
	"PrintViewComponent.abspracheMitArzt": "Absprache mit Arzt",
	"PrintViewComponent.name": "Name",
	"PrintViewComponent.kategorie": "Kategorie",
	"PrintViewComponent.strasse": "Strasse",
	"PrintViewComponent.phone": "Telefon",
	"PrintViewComponent.grundversicherung": "Grundversicherung",
	"PrintViewComponent.gruppenpraxis": "Hausärzte und Gruppenpraxen",
	"PrintViewComponent.kinderarzt": "Kinderärzte",
	"PrintViewComponent.psychotherapeuten": "Psychotherapeuten",
	"PrintViewComponent.komplementärmedizin": "Komplementärtherapeuten",
	"PrintViewComponent.fitness": "Fitnesscenter",
	"PrintViewComponent.kursleiter": "Kursleiter",
	"SearchComponent.title": "Hausarzt suchen",
	"SearchComponent.plzOrtName": "Nach Name, PLZ oder Ort suchen",
	"SearchComponent.filter": "Filter",
	"SearchComponent.acceptsNewPatients": "Nimmt Patienten auf",
	"SearchComponent.pediatriciansOnly": "Nur Kinderärzte",
	"SearchComponent.suchen": "Suchen",
	"SearchComponent.sucheZuruecksetzen": "Suche zurücksetzen",
	"SearchComponent.zurueckZuResultaten": "Zurück zu den Resultaten",
	"SearchComponent.karte": "Karte",
	"SearchComponent.liste": "Liste",
	"SearchComponent.sucheAnpassen": "Suche anpassen",
	"SearchComponent.sucheHinweis": "Bitte suchen Sie zuerst nach Name, PLZ oder Ort.",
	"SearchComponent.keineErgebnisse": "Leider konnten wir keinen Leistungserbringer finden. Bitte passen Sie ihre Suche an.",
	"SearchComponent.ergebnis": "Ergebnis",
	"SearchComponent.ergebnisse": "Ergebnisse",
	"ProviderFilterComponent.alleLeistungserbringer": "Alle Leistungserbringer",
	"ProviderFilterComponent.leistungserbringerWaehlen": "Leistungserbringer wählen",
	"ProviderFilterComponent.alleMethoden": "Alle Methoden",
	"ProviderFilterComponent.methodeKursWaehlen": "Methode / Kurs wählen",
	"ProviderFilterComponent.keineMethoden": "Keine Auswahl möglich",
	"QuickAccessFilterComponent.nimmtPatientenAuf": "Nimmt Patienten auf",
	"QuickAccessFilterComponent.nurKinderaerzte": "Nur Kinderärzte ",
	"QuickAccessFilterComponent.sucheAnpassen": "Suche anpassen",
	"SearchAreaButtonComponent.inDiesemGebietSuchen": "In diesem Gebiet suchen",
	"SearchAreaButtonComponent.zuVieleErgebnisse": "Suchbereich zu gross",
	"SearchAreaButtonComponent.keineErgebnisse": "Keine Ergebnisse im Bereich",
	"SearchAreaButtonComponent.aktuellerKartenausschnitt": "Aktueller Kartenausschnitt",
	"ToolTipComponent.toolTip": "Der Prämienrabatt ist abhängig vom gewählten Modell und von Ihrer Arztwahl. R1 steht für den grössten Rabattsatz, R4 für den kleinsten.",
	"DetailsComponent.netzwerkUndRabatt": "Netzwerk und Rabatt"
};

var de$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: de
});

const defaultLang = 'de';
const availableLangs = ['de', 'en', 'fr', 'it'];

const mapHeightDesktop = '550px';
const mapHeightMobile = '550px';
const mapHeightMobileWithAdjustSearchButton = '477px';
const listWidthDesktop = '372px';
const mobileBreakpoint = '(max-width: 425px)';
const tabletBreakpoint = '(min-width: 768px)';
const desktopBreakpoint = '(min-width: 1024px)';

class LerbFinderEffects {
    constructor() {
        this.actions$ = inject(Actions);
        this.lerbFinderService = inject(LerbFinderService);
        this.routerService = inject(RouterService);
        this.store = inject(Store);
        this.translocoService = inject(TranslocoService);
        this.breakpointObserver = inject(BreakpointObserver);
        this.geolocationService = inject(GeolocationService);
        this.dataLayerService = inject(DataLayerService);
        this.scrollingService = inject(ScrollingService);
        // !! Lerb Finder Component
        // !! /////////////////////
        this.lerbFinderComponentActionsOnInit$ = createEffect(() => {
            return this.actions$.pipe(ofType(onInit$1), tap(({ language, host }) => {
                this.translocoService.setTranslation(de$1, defaultLang);
                this.translocoService.setActiveLang(language || Language.de);
                this.translocoService.setDefaultLang(Language.de);
                this.lerbFinderService.setApiHost(host);
            }));
        }, { dispatch: false });
        // !! View
        // !! ////
        this.breakpointObserver$ = createEffect(() => {
            return this.breakpointObserver
                .observe([tabletBreakpoint, desktopBreakpoint])
                .pipe(map((result) => screenSize({
                isTablet: result.breakpoints[tabletBreakpoint],
                isDesktop: result.breakpoints[desktopBreakpoint],
            })));
        });
        // !! Search Component
        // !! ////////////////
        this.searchComponentSearchButtonClicked$ = createEffect(() => {
            return this.actions$.pipe(ofType(searchButtonClicked), concatLatestFrom(() => [
                this.store.select(selectLerbFinderMode),
                this.store.select(selectInputSearch),
                this.store.select(selectDoctorFilterForm),
                this.store.select(selectProviderFilterForm),
                this.store.select(selectLocation),
                this.store.select(selectArea),
                this.store.select(selectAvmProduct),
                this.store.select(selectProviderFilterFormMethods),
            ]), switchMap(([, lerbFinderMode, inputSearch, doctorFilterForm, providerFilterForm, location, area, avmProduct, methods,]) => {
                // !! Tracking
                // !! ////////
                let category = SearchCategory.LOCATION;
                if (inputSearch.state === 'area')
                    category = SearchCategory.AREA;
                if (inputSearch.state === 'location')
                    category = SearchCategory.GPS;
                const providerTypeToken = providerFilterForm.providerTypeId
                    ? getProviderTypeTranslationByFieldNumber(providerFilterForm.providerTypeId)
                    : '';
                this.translocoService.setTranslation(de$1, defaultLang);
                const searchData = {
                    masterSpeciality: this.dataLayerService.getMasterSpecialityTranslation(providerTypeToken),
                    speciality: this.translateActiveLang(providerTypeToken),
                    masterSubFilter: methods[providerFilterForm.method || '']?.agnosticText,
                    subFilter: methods[providerFilterForm.method || '']?.text,
                    term: getFormattedInput(inputSearch.input),
                };
                this.dataLayerService.trackLerbSearchSubmitted({ category, ...searchData }, lerbFinderMode);
                if (lerbFinderMode === LerbFinderMode.Provider) {
                    // !! Zip Search Provider
                    // !! ///////////////////
                    if (inputSearch.state === 'zipSelected' &&
                        inputSearch.selectedZip) {
                        return this.lerbFinderService
                            .zipSearchProvider(inputSearch.selectedZip, providerFilterForm.providerTypeId, providerFilterForm.method)
                            .pipe(map((providers) => zipSearchProviderSuccess({ providers })), catchError((error) => of(zipSearchProviderFailure({ error }))));
                    }
                    // !! Location Search Provider
                    // !! ////////////////////////
                    if (inputSearch.state === 'location' && location)
                        // TODO Malvin Go back to the location with the camera
                        return this.lerbFinderService
                            .locationSearchProvider(location, 1, providerFilterForm.providerTypeId, providerFilterForm.method)
                            .pipe(map((providers) => locationSearchProviderSuccess({ providers })), catchError((error) => of(locationSearchProviderFailure({ error }))));
                    // !! Area Search Provider
                    // !! ////////////////////
                    if (inputSearch.state === 'area' && area.center && area.radius)
                        return this.lerbFinderService
                            .locationSearchProvider(area.center, area.radius, providerFilterForm.providerTypeId, providerFilterForm.method, false)
                            .pipe(map((providers) => areaSearchProviderSuccess({
                            providers,
                            providerFilterForm: {
                                providerTypeId: providerFilterForm.providerTypeId,
                                method: providerFilterForm.method,
                                methods: [],
                            },
                        })), catchError((error) => of(areaSearchDoctorFailure({ error }))));
                }
                else {
                    // !! Zip Search Doctor
                    // !! /////////////////
                    if (inputSearch.state === 'zipSelected' && inputSearch.selectedZip)
                        return this.lerbFinderService
                            .zipSearchDoctor(inputSearch.selectedZip, doctorFilterForm.pediatriciansOnly ?? false, doctorFilterForm.acceptsNewPatients ?? false, avmProduct)
                            .pipe(map((providers) => zipSearchDoctorSuccess({ providers })), catchError((error) => of(zipSearchDoctorFailure({ error }))));
                    // !! Location Search Doctor
                    // !! //////////////////////
                    if (inputSearch.state === 'location' && location)
                        // TODO Malvin Go back to the location with the camera
                        return this.lerbFinderService
                            .locationSearchDoctor(location, 1, doctorFilterForm.pediatriciansOnly ?? false, doctorFilterForm.acceptsNewPatients ?? false, avmProduct)
                            .pipe(map((providers) => locationSearchDoctorSuccess({ providers })), catchError((error) => of(locationSearchDoctorFailure({ error }))));
                    // !! Area Search Doctor
                    // !! //////////////////
                    if (inputSearch.state === 'area' && area.center && area.radius)
                        return this.lerbFinderService
                            .locationSearchDoctor(area.center, area.radius, doctorFilterForm.pediatriciansOnly ?? false, doctorFilterForm.acceptsNewPatients ?? false, avmProduct, false)
                            .pipe(map((providers) => areaSearchDoctorSuccess({
                            providers,
                            doctorFilterForm: {
                                pediatriciansOnly: doctorFilterForm.pediatriciansOnly ?? false,
                                acceptsNewPatients: doctorFilterForm.acceptsNewPatients ?? false,
                            },
                        })), catchError((error) => of(areaSearchDoctorFailure({ error }))));
                }
                return of(noOp());
            }));
        });
        this.searchComponentMapMarkerClicked$ = createEffect(() => {
            return this.actions$.pipe(ofType(mapMarkerClicked), concatLatestFrom(() => [
                this.store.select(selectSearchResults), // TODO Malvin also by avm?
                this.store.select(selectIsDesktop),
            ]), map(([{ coordinates }, searchResults, isDesktop]) => {
                const clickedProviders = searchResults?.filter((provider) => provider.lat === coordinates.lat && provider.lng === coordinates.lng);
                if (!clickedProviders?.length) {
                    return noOp();
                }
                const coordinateId = getCoordinateId(clickedProviders[0]);
                if (isDesktop) {
                    // DESKTOP
                    if (clickedProviders?.length === 1) {
                        return selectProvider({
                            id: clickedProviders[0].id,
                        });
                    }
                    else if (clickedProviders?.length > 1) {
                        return selectLocation$1({ id: coordinateId });
                    }
                    else {
                        return noOp();
                    }
                }
                else {
                    // MOBILE
                    return showMapPreview({
                        id: coordinateId,
                    });
                }
            }));
        });
        this.searchComponentMapMarkerHovered$ = createEffect(() => {
            return this.actions$.pipe(ofType(mapMarkerHovered), concatLatestFrom(() => [this.store.select(selectSearchResults)]), map(([{ coordinates }, searchResults]) => {
                if (!coordinates)
                    return unhoverLocation();
                const hoveredProviders = searchResults?.filter((provider) => provider.lat === coordinates.lat && provider.lng === coordinates.lng);
                if (!hoveredProviders?.length) {
                    return noOp();
                }
                else {
                    const coordinateId = getCoordinateId(hoveredProviders[0]);
                    return hoverLocation({
                        id: coordinateId,
                    });
                }
            }));
        });
        // !! Input Search Component
        // !! //////////////////////
        this.inputSearchComponentInputChanged$ = createEffect(() => {
            return this.actions$.pipe(ofType(userChangedInput), debounceTime(400), map(({ input }) => input), isTypeFilter, concatLatestFrom(() => [
                this.store.select(selectLerbFinderMode),
                this.store.select(selectDoctorFilterForm),
                this.store.select(selectProviderFilterForm),
                this.store.select(selectAvmProduct),
            ]), switchMap(([input, lerbFinderMode, 
            // TODO Malvin do not do this, make it objct and use embedded inside for better understanding
            { acceptsNewPatients, pediatriciansOnly }, { providerTypeId }, avmProduct,]) => {
                // !! Tracking
                // !! ////////
                const term = getFormattedInput(input);
                if (typeof input === 'string')
                    this.dataLayerService.trackLerbSearchInitiated(lerbFinderMode);
                if (isZipLocation(input)) {
                    this.dataLayerService.trackLerbSearchSuggestionSelected({ category: SearchCategory.LOCATION, term }, lerbFinderMode);
                }
                if (isSearchLerb(input)) {
                    this.dataLayerService.trackLerbSearchSuggestionSelected({ category: SearchCategory.NAME, term }, lerbFinderMode);
                }
                // When user entered a string, search zips / providers for input autocomplete dropdown
                if (typeof input === 'string') {
                    //
                    // LerbFinderMode.Provider
                    if (lerbFinderMode === LerbFinderMode.Provider) {
                        return this.lerbFinderService
                            .inputSearchProvider(input, providerTypeId)
                            .pipe(map((results) => inputProviderSearchSuccess({ results })), catchError((error) => of(inputProviderSearchFailure({ error }))));
                    }
                    // LerbFinderMode.Doctor
                    return this.lerbFinderService
                        .inputSearchDoctor(input, pediatriciansOnly ?? false, acceptsNewPatients ?? false, avmProduct)
                        .pipe(map((results) => inputDoctorSearchSuccess({ results })), catchError((error) => of(inputDoctorSearchFailure({ error }))));
                }
                if (isSearchLerb(input)) {
                    const provider = {
                        ...input,
                        aufnahme: input.aufnahme === 'Y' ? '1' : '3',
                        rabatt: input.hrabatt,
                        field: getProviderTypeIdByProviderType(input.typ),
                    };
                    return of(providerViaInputDropdownResultsSelected({
                        provider,
                    }));
                }
                // If the user input change comes from a lerb or zip selection,
                // the reducer captures the information, we can stop here, no more side effects
                return of(noOp());
            }));
        });
        // !! Provider Filter Component
        // !! /////////////////////////
        this.providerFilterComponentInit$ = createEffect(() => {
            return this.actions$.pipe(ofType(onInit), switchMap(() => this.lerbFinderService
                .getMethods(this.translocoService.getActiveLang())
                .pipe(map((methods) => getMethodsSuccess({ methods })), catchError(() => of(getMethodsFailure())))));
        });
        // !! Geo Location Component
        // !! //////////////////////
        this.geolocationComponentIsActiveLocationCheckboxChanged$ = createEffect(() => {
            return this.actions$.pipe(ofType(isLocationActiveCheckboxChanged), switchMap(({ isLocationActive }) => {
                if (isLocationActive) {
                    return this.geolocationService.getCurrentLocation$().pipe(map((coords) => activateLocationSuccess({
                        location: coords,
                        input: this.translocoService.translate('LerbFinderEffects.geoLocationComponentSuccess.searchInput'),
                    })), catchError(() => of(activateLocationFailure())));
                }
                return of(locationDeactivated());
            }));
        });
        // !! Search Area Button Component
        // !! ////////////////////////////
        this.searchAreaButtonComponentSearchAreaButtonClicked$ = createEffect(() => {
            return this.actions$.pipe(ofType(searchAreabuttonClicked), concatLatestFrom(() => [
                this.store.select(selectLerbFinderMode),
                this.store.select(selectDoctorFilterForm),
                this.store.select(selectProviderFilterForm),
                this.store.select(selectAvmProduct),
                this.store.select(selectProviderFilterFormMethods),
                this.store.select(selectInputSearch),
            ]), switchMap(([{ center, radius }, lerbFinderMode, doctorFilterForm, providerFilterForm, avmProduct, methods, inputSearch,]) => {
                // !! Tracking
                // !! ////////
                const category = SearchCategory.AREA;
                const providerTypeToken = providerFilterForm.providerTypeId
                    ? getProviderTypeTranslationByFieldNumber(providerFilterForm.providerTypeId)
                    : '';
                this.translocoService.setTranslation(de$1, defaultLang);
                const searchData = {
                    masterSpeciality: this.dataLayerService.getMasterSpecialityTranslation(providerTypeToken),
                    speciality: this.translateActiveLang(providerTypeToken),
                    masterSubFilter: methods[providerFilterForm.method || '']?.agnosticText,
                    subFilter: methods[providerFilterForm.method || '']?.text,
                    term: getFormattedInput(inputSearch.input),
                };
                this.dataLayerService.trackLerbSearchSubmitted({ category, ...searchData }, lerbFinderMode);
                // !! LerbFinderMode.Provider
                if (lerbFinderMode === LerbFinderMode.Provider) {
                    return this.lerbFinderService
                        .locationSearchProvider(center, radius, providerFilterForm.providerTypeId, providerFilterForm.method, false)
                        .pipe(map((providers) => areaSearchProviderSuccess({
                        providers,
                        providerFilterForm: {
                            providerTypeId: providerFilterForm.providerTypeId,
                            method: providerFilterForm.method,
                            methods: [],
                        },
                    })), catchError((error) => of(areaSearchProviderFailure({ error }))));
                }
                // !! LerbFinderMode.Doctor
                return this.lerbFinderService
                    .locationSearchDoctor(center, radius, doctorFilterForm.pediatriciansOnly ?? false, doctorFilterForm.acceptsNewPatients ?? false, avmProduct, false)
                    .pipe(map((providers) => areaSearchDoctorSuccess({
                    providers,
                    doctorFilterForm: {
                        pediatriciansOnly: doctorFilterForm.pediatriciansOnly ?? false,
                        acceptsNewPatients: doctorFilterForm.acceptsNewPatients ?? false,
                    },
                })), catchError((error) => of(areaSearchDoctorFailure({ error }))));
            }));
        });
        // !! Quick Access Filer Component
        // !! ////////////////////////////
        this.quickAccessFilterComponentRemoveDoctorFilterProperty$ = createEffect(() => {
            return this.actions$.pipe(ofType(removeAcceptPatientsButtonClicked, removeOnlyPediatriciansOnlyButtonClicked), concatLatestFrom(() => [
                this.store.select(selectInputSearch),
                this.store.select(selectArea),
                this.store.select(selectDoctorFilterForm),
                this.store.select(selectLocation),
                this.store.select(selectAvmProduct),
                this.store.select(selectLerbFinderMode),
            ]), switchMap(([{ param }, inputSearch, area, doctorFilterForm, location, avmProduct, lerbFinderMode,]) => {
                const pediatriciansOnly = param === QuickAccessFilterParamEnum.pediatriciansOnly
                    ? false
                    : doctorFilterForm.pediatriciansOnly ?? false;
                const acceptsNewPatients = param === QuickAccessFilterParamEnum.acceptsNewPatients
                    ? false
                    : doctorFilterForm.acceptsNewPatients ?? false;
                // !! Tracking
                // !! ////////
                let category = SearchCategory.LOCATION;
                if (inputSearch.state === 'area')
                    category = SearchCategory.AREA;
                if (inputSearch.state === 'location')
                    category = SearchCategory.GPS;
                const searchData = {
                    masterSpeciality: '',
                    speciality: '',
                    masterSubFilter: '',
                    subFilter: '',
                    term: getFormattedInput(inputSearch.input),
                };
                this.dataLayerService.trackLerbQuickAccessFilterAdjusted(lerbFinderMode, { category, ...searchData });
                // !! Area Search
                // !! ///////////
                if (inputSearch.state === 'area' && area.center && area.radius)
                    return this.lerbFinderService
                        .locationSearchDoctor(area.center, area.radius, pediatriciansOnly, acceptsNewPatients, avmProduct, false)
                        .pipe(map((providers) => areaSearchDoctorSuccess({
                        providers,
                        doctorFilterForm: {
                            acceptsNewPatients,
                            pediatriciansOnly,
                        },
                    })), catchError((error) => of(areaSearchDoctorFailure({ error }))));
                // !! Zip Search
                // !! //////////
                if (inputSearch.state === 'zipSelected' && inputSearch.selectedZip)
                    return this.lerbFinderService
                        .zipSearchDoctor(inputSearch.selectedZip, doctorFilterForm.pediatriciansOnly ?? false, doctorFilterForm.acceptsNewPatients ?? false, avmProduct)
                        .pipe(map((providers) => zipSearchDoctorSuccess({ providers })), catchError((error) => of(zipSearchDoctorFailure({ error }))));
                // !! Location Search
                // !! ///////////////
                if (inputSearch.state === 'location' && location)
                    // TODO Malvin Go back to the location with the camera?
                    return this.lerbFinderService
                        .locationSearchDoctor(location, 1, doctorFilterForm.pediatriciansOnly ?? false, doctorFilterForm.acceptsNewPatients ?? false, avmProduct)
                        .pipe(map((providers) => locationSearchDoctorSuccess({ providers })), catchError((error) => of(locationSearchDoctorFailure({ error }))));
                return of(noOp());
            }));
        });
        this.quickAccessFilterComponentRemoveProviderFilterProperty$ = createEffect(() => {
            return this.actions$.pipe(ofType(removeProviderTypeIdButtonClicked, removeMethodButtonClicked), concatLatestFrom(() => [
                this.store.select(selectInputSearch),
                this.store.select(selectArea),
                this.store.select(selectProviderFilterForm),
                this.store.select(selectLocation),
                this.store.select(selectLerbFinderMode),
                this.store.select(selectProviderFilterFormMethods),
            ]), switchMap(([{ param }, inputSearch, area, providerFilterForm, location, lerbFinderMode, methods,]) => {
                let method = param === QuickAccessFilterParamEnum.method
                    ? 0
                    : providerFilterForm.method;
                let providerTypeId = providerFilterForm.providerTypeId;
                if (param === QuickAccessFilterParamEnum.providerTypeId) {
                    method = 0;
                    providerTypeId = ProviderTypeId.ALL;
                }
                // !! Tracking
                // !! ////////
                let category = SearchCategory.LOCATION;
                if (inputSearch.state === 'area')
                    category = SearchCategory.AREA;
                if (inputSearch.state === 'location')
                    category = SearchCategory.GPS;
                const providerTypeToken = providerFilterForm.providerTypeId
                    ? getProviderTypeTranslationByFieldNumber(providerFilterForm.providerTypeId)
                    : '';
                this.translocoService.setTranslation(de$1, defaultLang);
                const searchData = {
                    masterSpeciality: this.dataLayerService.getMasterSpecialityTranslation(providerTypeToken),
                    speciality: this.translateActiveLang(providerTypeToken),
                    masterSubFilter: methods[method || '']?.agnosticText,
                    subFilter: methods[method || '']?.text,
                    term: getFormattedInput(inputSearch.input),
                };
                this.dataLayerService.trackLerbQuickAccessFilterAdjusted(lerbFinderMode, { category, ...searchData });
                // !! Area Search
                // !! ///////////
                if (inputSearch.state === 'area' && area.center && area.radius)
                    return this.lerbFinderService
                        .locationSearchProvider(area.center, area.radius, providerTypeId, method, false)
                        .pipe(map((providers) => areaSearchProviderSuccess({
                        providers,
                        providerFilterForm: {
                            providerTypeId,
                            method,
                            methods: [],
                        },
                    })), catchError((error) => of(areaSearchProviderFailure({ error }))));
                // !! Zip Search
                // !! //////////
                if (inputSearch.state === 'zipSelected' && inputSearch.selectedZip)
                    return this.lerbFinderService
                        .zipSearchProvider(inputSearch.selectedZip, providerTypeId, method)
                        .pipe(map((providers) => zipSearchProviderSuccess({ providers })), catchError((error) => of(zipSearchProviderFailure({ error }))));
                // !! Location Search
                // !! ///////////////
                if (inputSearch.state === 'location' && location)
                    // TODO Malvin Go back to the location with the camera?
                    return this.lerbFinderService
                        .locationSearchProvider(location, 1, providerTypeId, method)
                        .pipe(map((providers) => locationSearchProviderSuccess({ providers })), catchError((error) => of(locationSearchProviderFailure({ error }))));
                return of(noOp());
            }));
        });
        // !! Location Component
        // !! //////////////////
        this.locationComponentBackClicked$ = createEffect(() => {
            return this.actions$.pipe(ofType(backClicked), tap(() => {
                this.routerService.search();
            }));
        }, { dispatch: false });
        // !! Details Component
        // !! /////////////////
        this.detailsComponentInit$ = createEffect(() => {
            return this.actions$.pipe(ofType(onInit$3), concatLatestFrom(() => [
                this.store.select(selectProviderFilterFormMethods),
                this.store.select(selectDetailsProvider),
                this.store.select(selectIsDesktop),
                this.store.select(selectLerbFinderMode),
                this.store.select(selectInputSearch),
                this.store.select(selectProviderFilterForm),
                this.store.select(selectInputSearch),
                this.store.select(selectProvidersInViewport),
            ]), tap(([, methods, detailsProvider, , lerbFinderMode, inputSearch, providerFilterForm, input, providersInViewport,]) => {
                if (!detailsProvider) {
                    // TODO Malvin: Alex fragen
                    // this.routerService.closeOverlay();
                }
                // !! Tracking
                // !! ////////
                const selectedLerbTypByName = input?.selectedLerb?.typ;
                let selectedLerbTranslationToken;
                if (selectedLerbTypByName) {
                    selectedLerbTranslationToken =
                        getProviderTypeTranslationByFieldName(selectedLerbTypByName);
                }
                else {
                    const type = providersInViewport?.find((provider) => provider.id === detailsProvider?.id)?.field;
                    selectedLerbTranslationToken =
                        getProviderTypeTranslationByFieldNumber(type);
                }
                this.translocoService.setTranslation(de$1, defaultLang);
                const searchData = {
                    masterSpeciality: this.dataLayerService.getMasterSpecialityTranslation(selectedLerbTranslationToken),
                    speciality: this.translateActiveLang(selectedLerbTranslationToken),
                    masterSubFilter: methods[providerFilterForm.method || '']?.agnosticText,
                    subFilter: methods[providerFilterForm.method || '']?.text,
                    term: getFormattedInput(inputSearch.input),
                    location: `${detailsProvider?.plz} ${detailsProvider?.ort}`,
                    providerName: `${detailsProvider?.vorname} ${detailsProvider?.name}`,
                    providerId: detailsProvider?.id.toString() || '',
                };
                const category = this.dataLayerService.getLastCategory();
                this.dataLayerService.trackLerbSearchProviderSelected(lerbFinderMode, {
                    category,
                    ...searchData,
                });
            }));
        }, { dispatch: false });
        this.detailComponentChooseProviderContacted$ = createEffect(() => {
            return this.actions$.pipe(ofType(chooseProviderContacted), concatLatestFrom(() => [
                this.store.select(selectProviderFilterFormMethods),
                this.store.select(selectDetailsProvider),
                this.store.select(selectIsDesktop),
                this.store.select(selectLerbFinderMode),
                this.store.select(selectProviderFilterForm),
                this.store.select(selectInputSearch),
                this.store.select(selectProvidersInViewport),
            ]), tap(([{ contactType }, methods, detailsProvider, , lerbFinderMode, providerFilterForm, input, providersInViewport,]) => {
                // !! Tracking
                // !! ////////
                const selectedLerbTypByName = input?.selectedLerb?.typ;
                let selectedLerbTranslationToken;
                if (selectedLerbTypByName) {
                    selectedLerbTranslationToken =
                        getProviderTypeTranslationByFieldName(selectedLerbTypByName);
                }
                else {
                    const type = providersInViewport?.find((provider) => provider.id === detailsProvider?.id)?.field;
                    selectedLerbTranslationToken =
                        getProviderTypeTranslationByFieldNumber(type);
                }
                const searchData = {
                    contactType,
                    masterSpeciality: this.dataLayerService.getMasterSpecialityTranslation(selectedLerbTranslationToken),
                    speciality: this.translateActiveLang(selectedLerbTranslationToken),
                    masterSubFilter: methods[providerFilterForm.method || '']?.agnosticText,
                    subFilter: methods[providerFilterForm.method || '']?.text,
                    location: `${detailsProvider?.plz} ${detailsProvider?.ort}`,
                    providerName: `${detailsProvider?.vorname} ${detailsProvider?.name}`,
                    providerId: detailsProvider?.id.toString() || '',
                };
                const category = this.dataLayerService.getLastCategory();
                this.dataLayerService.trackLerbSearchProviderContacted(lerbFinderMode, {
                    category,
                    ...searchData,
                });
            }));
        }, { dispatch: false });
        this.detailsComponentBackClicked$ = createEffect(() => {
            return this.actions$.pipe(ofType(backClicked$1), concatLatestFrom(() => this.store.select(selectSelectedLocationId)), 
            // TODO Malvin: Check if this works
            tap(([, selectedLocationId]) => {
                if (selectedLocationId) {
                    this.routerService.location();
                    return;
                }
                this.routerService.search();
            }));
        }, { dispatch: false });
        // !! Map Preview Component
        // !! /////////////////////
        this.mapPreviewComponentPreviewClicked$ = createEffect(() => {
            return this.actions$.pipe(ofType(mapPreviewClicked), concatLatestFrom(() => [
                this.store.select(selectMapPreviewProviders),
                this.store.select(selectSelectedMapPreviewId),
            ]), map(([, mapPreviewProviders, selectedMapPreviewId]) => {
                const providers = mapPreviewProviders || [];
                if (providers?.length === 1) {
                    return selectProvider({
                        id: providers[0].id,
                    });
                }
                else if (providers?.length > 1 && selectedMapPreviewId) {
                    return selectLocation$1({ id: selectedMapPreviewId });
                }
                return noOp();
            }));
        });
        // !! Api
        // !! ///
        // TODO Malvin now - LOG ALL FAILURE ACTIONS HERE
        // TODO Malvin error handling
        this.apiInputDoctorSearchFailure$ = createEffect(() => {
            return this.actions$.pipe(ofType(inputDoctorSearchFailure), tap(({ error }) => console.error('ApiActions.inputDoctorSearchFailure', error)));
        }, { dispatch: false });
        // TODO Malvin error handling
        this.apiInputProviderSearchFailure$ = createEffect(() => {
            return this.actions$.pipe(ofType(inputProviderSearchFailure), tap(({ error }) => console.error('ApiActions.inputProviderSearchFailure', error)));
        }, { dispatch: false });
        this.apiGetProviderSuccess$ = createEffect(() => {
            return this.actions$.pipe(ofType(getProviderSuccess), concatLatestFrom(() => this.store.select(selectIsDesktop)), map(([, isDesktop]) => !isDesktop && this.routerService.details()));
        }, {
            dispatch: false,
        });
        // !! Scrolling Buttons
        // !! /////
        this.searchComponentScrollingButtonClicked$ = createEffect(() => {
            return this.actions$.pipe(ofType(searchButtonClicked), concatLatestFrom(() => [
                this.store.select(selectIsLoading),
                this.store.select(selectIsDesktop),
                this.store.select(selectOffsetScrolling),
            ]), filter(([{ isIntersecting }, isLoading]) => isLoading && !isIntersecting), tap(async ([, , isDesktop, offsetScrolling]) => {
                isDesktop
                    ? await this.scrollingService.toCenterOfId('hausarzt-results')
                    : await this.scrollingService.scrollToOffset('hausarzt-results', offsetScrolling);
            }));
        }, {
            dispatch: false,
        });
        this.adjustSearchScrollingButtonClicked$ = createEffect(() => {
            return this.actions$.pipe(ofType(adjustSearchButtonClicked$1, adjustSearchButtonClicked), concatLatestFrom(() => [
                this.store.select(selectIsDesktop),
                this.store.select(selectOffsetScrolling),
            ]), tap(async ([, isDesktop, offsetScrolling]) => {
                isDesktop
                    ? await this.scrollingService.toCenterOfId('overlay-scrollable')
                    : await this.scrollingService.scrollToOffset('overlay-scrollable', offsetScrolling);
            }));
        }, {
            dispatch: false,
        });
        this.detailsComponentScrollingInitIsProviderSelectedViaInpu$ = createEffect(() => {
            return this.actions$.pipe(ofType(onInit$3), concatLatestFrom(() => [this.store.select(selectIsDesktop)]), filter(([{ isProviderSelectedViaInput }, isDesktop]) => isProviderSelectedViaInput && isDesktop), tap(async () => {
                await this.scrollingService.toBottomOfId('hausarzt-results');
            }));
        }, {
            dispatch: false,
        });
        this.mobileOverlayBackClickedScrolling$ = createEffect(() => {
            return this.actions$.pipe(ofType(backClicked$1, backClicked), concatLatestFrom(() => [this.store.select(selectIsDesktop)]), filter(([, isDesktop]) => !isDesktop), concatLatestFrom(() => [this.store.select(selectPageOffset)]), tap(async ([, pageOffset]) => {
                const isElementLoaded = await this.scrollingService.isElementLoaded('hausarzt-results');
                if (isElementLoaded) {
                    const offset = pageOffset?.y || 0;
                    this.scrollingService.scrollTo({ top: offset });
                }
            }));
        }, {
            dispatch: false,
        });
        this.resetSearchFieldsBtnClickedScrolling$ = createEffect(() => {
            return this.actions$.pipe(ofType(resetSearchFields), tap(async () => {
                await this.scrollingService.toCenterOfId('overlay-scrollable');
            }));
        }, {
            dispatch: false,
        });
        // !! Mixed
        // !! /////
        this.mapPreviewComponentSelectLocation$ = createEffect(() => {
            return this.actions$.pipe(ofType(selectLocation$1), concatLatestFrom(() => this.store.select(selectIsDesktop)), filter(([, isDesktop]) => !isDesktop), tap(() => this.routerService.location()));
        }, { dispatch: false });
        this.lerbFinderProviderViaInputDrodownResultsSelected$ = createEffect(() => {
            return this.actions$.pipe(ofType(providerViaInputDropdownResultsSelected), switchMap(({ provider }) => {
                return this.lerbFinderService
                    .getProvider(provider.id, provider.field)
                    .pipe(map((response) => {
                    return response.provider.typ
                        ? getProviderSuccess({
                            provider: response.provider,
                            expertiseGroups: response.fachgebietGruppen,
                        })
                        : getProviderSuccess({
                            provider: {
                                ...response.provider,
                                typ: getProviderTypeByNum(provider.field),
                            },
                            expertiseGroups: response.fachgebietGruppen,
                        });
                }), catchError(() => of(getProviderFailure())));
            }));
        });
        this.searchSelectDoctor$ = createEffect(() => {
            return this.actions$.pipe(ofType(selectProvider$2, selectProvider$1, selectProvider), concatLatestFrom(() => [this.store.select(selectSearchResults)]), // TODO Malvin by avm?
            switchMap(([{ id }, searchResults]) => {
                const provider = searchResults?.find((provider) => provider.id === id);
                if (provider) {
                    return this.lerbFinderService
                        .getProvider(provider.id, provider.field)
                        .pipe(map((response) => {
                        return response.provider.typ
                            ? getProviderSuccess({
                                provider: response.provider,
                                expertiseGroups: response.fachgebietGruppen,
                            })
                            : getProviderSuccess({
                                provider: {
                                    ...response.provider,
                                    typ: getProviderTypeByNum(provider.field),
                                },
                                expertiseGroups: response.fachgebietGruppen,
                            });
                    }), catchError(() => of(getProviderFailure())));
                }
                return of(selectProviderFailure());
            }));
        });
        this.openGoogleMapsClicked$ = createEffect(() => {
            return this.actions$.pipe(ofType(openGoogleMapsClicked, openGoogleMapsClicked$1), map(({ provider }) => {
                if (!provider) {
                    return;
                }
                const query = `${provider.strasse}+${provider.plz}+${provider.ort}`;
                window.open(`https://www.google.com/maps/search/?api=1&query=${query}`, '_blank');
            }));
        }, { dispatch: false });
    }
    translateActiveLang(token) {
        return this.translocoService.translate(token, {}, this.translocoService.getActiveLang());
    }
    translateDefaultLang(token) {
        return this.translocoService.translate(token, {}, this.translocoService.getDefaultLang());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LerbFinderEffects, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LerbFinderEffects, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LerbFinderEffects, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class TranslocoHttpLoader {
    constructor() {
        this.http = inject(HttpClient);
    }
    getTranslation(lang) {
        return this.http.get(`assets/i18n/${lang}.json`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: TranslocoHttpLoader, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: TranslocoHttpLoader, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: TranslocoHttpLoader, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
class I18nModule {
    static forRoot() {
        return {
            ngModule: I18nModule,
            providers: [
                {
                    provide: TRANSLOCO_CONFIG,
                    useValue: translocoConfig({
                        reRenderOnLangChange: true,
                        availableLangs,
                        fallbackLang: defaultLang,
                        defaultLang,
                        prodMode: !window.location.href.includes('localhost'),
                    }),
                },
                { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: I18nModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.3", ngImport: i0, type: I18nModule, imports: [HttpClientModule], exports: [TranslocoModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: I18nModule, imports: [HttpClientModule, TranslocoModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: I18nModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: [TranslocoModule],
                    imports: [HttpClientModule],
                }]
        }] });

class ShellComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ShellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: ShellComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `<router-outlet></router-outlet> `, isInline: true, dependencies: [{ kind: "directive", type: RouterOutlet, selector: "router-outlet", inputs: ["name"], outputs: ["activate", "deactivate", "attach", "detach"], exportAs: ["outlet"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ShellComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    imports: [RouterOutlet],
                    template: `<router-outlet></router-outlet> `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }] });

class GoogleMapsService {
    constructor(httpClient, environment) {
        this.httpClient = httpClient;
        this.environment = environment;
        this.alreadyLoaded = false;
        this.googleapisUrl = 'https://maps.googleapis.com/maps/api/js';
        this.googleapisUrlSuffix = this.environment.googleApiKey;
        this._googleMapsApiLoaded$ = this.httpClient
            .jsonp(this.googleapisUrl + this.googleapisUrlSuffix, 'callback')
            .pipe(map(() => true), tap(() => (this.alreadyLoaded = true)), catchError(() => of(false)));
    }
    get googleMapsApiLoaded$() {
        return this.alreadyLoaded ? of(true) : this._googleMapsApiLoaded$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: GoogleMapsService, deps: [{ token: i1.HttpClient }, { token: 'environment' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: GoogleMapsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: GoogleMapsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['environment']
                }] }] });

const doctor = (fill) => `
<svg width="34pt" height="40pt" viewBox="0 0 40 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="surface1">
    <path style=" stroke:none;fill-rule:nonzero;fill:${colors[fill]};fill-opacity:1;" d="M 25 5.53125 C 16.621094 5.617188 9.863281 12.425781 9.863281 20.816406 C 9.863281 20.855469 9.863281 20.898438 9.863281 20.9375 L 9.863281 20.933594 C 9.863281 30.242188 20.386719 40.847656 23.613281 43.847656 C 23.96875 44.203125 24.457031 44.421875 25 44.421875 C 25.542969 44.421875 26.03125 44.203125 26.386719 43.847656 C 29.613281 40.816406 40.136719 30.234375 40.136719 20.933594 C 40.136719 20.898438 40.136719 20.859375 40.136719 20.816406 C 40.136719 12.425781 33.378906 5.617188 25.011719 5.539062 Z M 25 5.53125 "/>
    <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 18.246094 24.9375 C 18.246094 24.808594 18.144531 24.703125 18.011719 24.703125 L 17.925781 24.703125 C 16.820312 25.125 15.863281 25.664062 15 26.3125 L 15.03125 26.292969 C 14.425781 26.761719 14.039062 27.484375 14.039062 28.300781 C 14.039062 28.3125 14.039062 28.320312 14.039062 28.332031 L 14.039062 29.359375 C 14.039062 29.746094 14.351562 30.058594 14.734375 30.058594 C 15.121094 30.058594 15.433594 29.746094 15.433594 29.359375 L 15.433594 28.332031 C 15.433594 28.324219 15.433594 28.320312 15.433594 28.316406 C 15.433594 27.949219 15.605469 27.621094 15.875 27.414062 L 15.878906 27.414062 C 16.53125 26.917969 17.285156 26.496094 18.085938 26.167969 L 18.15625 26.144531 C 18.203125 26.125 18.242188 26.074219 18.242188 26.015625 C 18.242188 26.015625 18.242188 26.015625 18.242188 26.011719 Z M 35 26.292969 C 33.929688 25.492188 32.6875 24.84375 31.335938 24.417969 L 31.25 24.394531 C 31.152344 24.367188 31.085938 24.277344 31.085938 24.175781 L 31.085938 23.78125 C 31.085938 23.394531 30.773438 23.082031 30.386719 23.082031 C 30 23.082031 29.6875 23.394531 29.6875 23.78125 L 29.6875 26.539062 C 29.6875 26.636719 29.628906 26.71875 29.542969 26.753906 C 28.667969 27.101562 28.058594 27.933594 28.050781 28.914062 L 28.050781 29.382812 C 28.050781 29.769531 28.363281 30.082031 28.75 30.082031 C 29.136719 30.082031 29.449219 29.769531 29.449219 29.382812 L 29.449219 28.914062 C 29.523438 28.464844 29.90625 28.132812 30.371094 28.132812 C 30.835938 28.132812 31.214844 28.472656 31.292969 28.910156 L 31.292969 29.382812 C 31.292969 29.769531 31.605469 30.082031 31.992188 30.082031 C 32.378906 30.082031 32.691406 29.769531 32.691406 29.382812 L 32.691406 28.914062 C 32.683594 27.933594 32.078125 27.097656 31.21875 26.757812 L 31.207031 26.753906 C 31.117188 26.71875 31.058594 26.636719 31.058594 26.539062 L 31.058594 26.191406 C 31.058594 26.0625 31.160156 25.957031 31.292969 25.957031 L 31.371094 25.957031 L 31.839844 26.140625 C 32.710938 26.492188 33.457031 26.921875 34.140625 27.429688 L 34.109375 27.410156 C 34.378906 27.621094 34.554688 27.949219 34.554688 28.316406 C 34.554688 28.320312 34.554688 28.324219 34.554688 28.328125 L 34.554688 29.359375 C 34.554688 29.746094 34.867188 30.058594 35.253906 30.058594 C 35.640625 30.058594 35.953125 29.746094 35.953125 29.359375 L 35.953125 28.320312 C 35.953125 28.308594 35.953125 28.304688 35.953125 28.296875 C 35.953125 27.480469 35.566406 26.757812 34.96875 26.292969 L 34.964844 26.289062 Z M 25.039062 25.625 C 24.878906 25.625 24.722656 25.613281 24.566406 25.589844 L 24.585938 25.589844 C 24.574219 25.589844 24.566406 25.589844 24.554688 25.589844 C 24.429688 25.589844 24.320312 25.691406 24.320312 25.824219 L 24.320312 29.363281 C 24.320312 29.371094 24.320312 29.375 24.320312 29.382812 C 24.320312 29.769531 24.632812 30.085938 25.023438 30.085938 C 25.40625 30.085938 25.710938 29.785156 25.722656 29.402344 C 25.722656 29.402344 25.722656 29.402344 25.722656 29.363281 L 25.722656 25.828125 C 25.707031 25.710938 25.609375 25.621094 25.488281 25.621094 C 25.484375 25.621094 25.484375 25.621094 25.476562 25.621094 C 25.414062 25.625 25.339844 25.625 25.269531 25.625 C 25.195312 25.625 25.121094 25.625 25.046875 25.621094 L 25.058594 25.621094 Z M 30.375 19.796875 C 30.390625 19.714844 30.4375 19.652344 30.507812 19.625 C 31.3125 19.183594 31.855469 18.34375 31.855469 17.378906 C 31.855469 17.371094 31.855469 17.363281 31.855469 17.359375 C 31.855469 17.328125 31.859375 17.289062 31.859375 17.257812 C 31.859375 16.816406 31.71875 16.40625 31.480469 16.074219 L 31.484375 16.078125 C 31.457031 16.039062 31.441406 15.992188 31.441406 15.941406 C 31.441406 15.933594 31.441406 15.917969 31.445312 15.90625 C 31.757812 13.535156 31.445312 11.460938 30.214844 10.070312 C 28.984375 8.675781 27.367188 8.117188 25.039062 8.117188 C 22.710938 8.117188 20.972656 8.773438 19.875 10.070312 C 18.6875 11.46875 18.355469 13.554688 18.644531 15.90625 C 18.644531 15.917969 18.648438 15.929688 18.648438 15.941406 C 18.648438 15.996094 18.632812 16.046875 18.605469 16.078125 C 18.371094 16.40625 18.226562 16.8125 18.226562 17.25 C 18.226562 17.285156 18.226562 17.320312 18.234375 17.351562 L 18.234375 17.347656 C 18.234375 17.359375 18.234375 17.363281 18.234375 17.375 C 18.234375 18.339844 18.769531 19.179688 19.566406 19.613281 L 19.582031 19.617188 C 19.648438 19.652344 19.703125 19.710938 19.71875 19.789062 C 20.195312 22.636719 23.472656 24.453125 25.023438 24.453125 C 26.578125 24.453125 29.859375 22.609375 30.332031 19.789062 Z M 20.171875 18.34375 C 19.851562 18.121094 19.648438 17.753906 19.648438 17.339844 C 19.648438 17.332031 19.648438 17.324219 19.648438 17.320312 L 19.648438 17.195312 C 19.664062 17.078125 19.761719 16.988281 19.882812 16.988281 L 20.03125 16.988281 C 20.820312 16.988281 21.476562 16.425781 21.632812 15.683594 L 21.632812 15.671875 L 21.792969 14.8125 C 21.816406 14.710938 21.898438 14.636719 22.007812 14.628906 C 23.085938 14.617188 24.082031 14.253906 24.875 13.636719 L 24.863281 13.648438 C 24.902344 13.613281 24.957031 13.589844 25.015625 13.589844 C 25.074219 13.589844 25.125 13.609375 25.171875 13.648438 C 25.957031 14.253906 26.953125 14.625 28.039062 14.628906 C 28.144531 14.632812 28.226562 14.710938 28.253906 14.808594 L 28.421875 15.667969 C 28.578125 16.421875 29.238281 16.980469 30.023438 16.980469 L 30.171875 16.980469 C 30.292969 16.980469 30.394531 17.074219 30.40625 17.195312 L 30.40625 17.320312 C 30.40625 17.328125 30.40625 17.34375 30.40625 17.359375 C 30.40625 17.769531 30.199219 18.128906 29.886719 18.34375 L 29.882812 18.347656 C 29.390625 18.578125 29.039062 19.027344 28.949219 19.570312 L 28.949219 19.578125 C 28.597656 21.679688 25.980469 23.070312 25.019531 23.070312 C 24.054688 23.070312 21.445312 21.683594 21.09375 19.578125 C 21.007812 19.027344 20.648438 18.578125 20.164062 18.355469 L 20.15625 18.347656 Z M 20.171875 18.34375 "/>
    <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 23.402344 19.898438 C 23.351562 19.996094 23.316406 20.113281 23.316406 20.238281 C 23.316406 20.503906 23.457031 20.726562 23.671875 20.851562 L 23.675781 20.851562 C 23.808594 20.921875 23.964844 20.992188 24.125 21.039062 L 24.144531 21.046875 C 24.417969 21.132812 24.734375 21.179688 25.070312 21.179688 C 25.394531 21.179688 25.710938 21.132812 26.011719 21.039062 L 25.984375 21.046875 C 26.167969 20.988281 26.316406 20.917969 26.464844 20.835938 L 26.449219 20.839844 C 26.746094 20.757812 26.96875 20.484375 26.96875 20.167969 C 26.96875 19.78125 26.65625 19.46875 26.269531 19.46875 C 26.109375 19.46875 25.957031 19.523438 25.839844 19.613281 L 25.765625 19.652344 C 25.707031 19.6875 25.640625 19.71875 25.566406 19.742188 L 25.554688 19.742188 C 25.410156 19.789062 25.238281 19.816406 25.0625 19.816406 C 25.058594 19.816406 25.046875 19.816406 25.042969 19.816406 C 25.039062 19.816406 25.035156 19.816406 25.03125 19.816406 C 24.851562 19.816406 24.683594 19.785156 24.523438 19.738281 L 24.53125 19.742188 C 24.453125 19.71875 24.378906 19.683594 24.316406 19.648438 L 24.320312 19.652344 C 24.222656 19.601562 24.105469 19.566406 23.980469 19.566406 C 23.714844 19.566406 23.492188 19.707031 23.371094 19.921875 L 23.371094 19.925781 Z M 22.695312 17.546875 C 22.769531 17.503906 22.859375 17.480469 22.953125 17.480469 C 23.050781 17.480469 23.140625 17.503906 23.21875 17.546875 L 23.210938 17.546875 C 23.34375 17.679688 23.523438 17.761719 23.730469 17.761719 C 24.136719 17.761719 24.460938 17.4375 24.460938 17.03125 C 24.460938 16.832031 24.378906 16.644531 24.25 16.511719 C 23.921875 16.230469 23.492188 16.058594 23.015625 16.058594 C 22.542969 16.058594 22.113281 16.230469 21.789062 16.519531 L 21.792969 16.519531 C 21.625 16.644531 21.519531 16.851562 21.519531 17.074219 C 21.519531 17.460938 21.832031 17.773438 22.21875 17.773438 C 22.40625 17.773438 22.582031 17.695312 22.707031 17.574219 L 22.746094 17.542969 Z M 26.351562 17.734375 C 26.351562 17.734375 26.359375 17.734375 26.359375 17.734375 C 26.539062 17.734375 26.710938 17.664062 26.832031 17.546875 C 26.90625 17.503906 26.996094 17.480469 27.089844 17.480469 C 27.183594 17.480469 27.273438 17.503906 27.355469 17.554688 L 27.347656 17.554688 C 27.46875 17.660156 27.632812 17.726562 27.808594 17.726562 C 28.195312 17.726562 28.503906 17.414062 28.503906 17.027344 C 28.503906 16.832031 28.425781 16.65625 28.300781 16.527344 C 27.972656 16.246094 27.542969 16.074219 27.070312 16.074219 C 26.597656 16.074219 26.167969 16.246094 25.839844 16.53125 L 25.84375 16.53125 C 25.699219 16.660156 25.605469 16.851562 25.605469 17.0625 C 25.605469 17.445312 25.917969 17.757812 26.304688 17.757812 C 26.308594 17.757812 26.316406 17.757812 26.324219 17.757812 Z M 20.125 23.144531 C 20.046875 23.109375 19.957031 23.089844 19.859375 23.089844 C 19.851562 23.089844 19.847656 23.089844 19.84375 23.089844 C 19.472656 23.109375 19.183594 23.414062 19.179688 23.785156 L 19.179688 25.859375 C 19.179688 25.957031 19.121094 26.035156 19.039062 26.074219 C 18.289062 26.40625 17.777344 27.144531 17.777344 27.996094 C 17.777344 29.160156 18.71875 30.097656 19.878906 30.097656 C 21.039062 30.097656 21.976562 29.15625 21.976562 27.996094 C 21.976562 27.144531 21.464844 26.40625 20.734375 26.078125 L 20.71875 26.074219 C 20.632812 26.035156 20.578125 25.957031 20.578125 25.859375 L 20.578125 23.785156 C 20.5625 23.511719 20.390625 23.28125 20.15625 23.171875 L 20.152344 23.171875 Z M 19.84375 28.671875 C 19.460938 28.664062 19.160156 28.351562 19.160156 27.972656 C 19.160156 27.589844 19.472656 27.277344 19.859375 27.277344 C 20.238281 27.277344 20.550781 27.582031 20.554688 27.964844 C 20.554688 28.351562 20.242188 28.664062 19.859375 28.664062 Z M 19.84375 28.671875 "/>
    </g>
</svg>`;
const pediatrician = (fill) => `
<svg width="34" height="45" viewBox="0 0 34 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" fill="${colors[fill]}" clip-rule="evenodd" d="M34 15.7355C34 7.05891 26.3738 0 17 0C7.62617 0 0 7.05891 0 15.7355C0 21.412 8.32007 33.796 13.8605 42.0426C14.3485 42.769 14.815 43.4634 15.2523 44.1182C15.2767 44.1408 15.3067 44.1711 15.3421 44.2069C15.7687 44.6388 16.9873 45.8721 18.7477 43.9711C19.3095 43.1451 19.9195 42.2587 20.5616 41.3256C26.0921 33.2885 34 21.7966 34 15.7355Z"/>
    <mask id="mask0_3066_47845" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="3" y="2" width="28" height="28">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17 30C24.732 30 31 23.732 31 16C31 8.26801 24.732 2 17 2C9.26801 2 3 8.26801 3 16C3 23.732 9.26801 30 17 30Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_3066_47845)">
        <path d="M16.5786 22.8672C16.382 22.8681 16.1937 22.9469 16.0552 23.0865C15.9167 23.2261 15.8392 23.4149 15.8398 23.6116V26.59C15.8398 26.7861 15.9177 26.9741 16.0564 27.1127C16.195 27.2513 16.383 27.3292 16.5791 27.3292C16.7751 27.3292 16.9631 27.2513 17.1018 27.1127C17.2404 26.9741 17.3183 26.7861 17.3183 26.59V23.6116C17.3186 23.5141 17.2997 23.4176 17.2627 23.3274C17.2257 23.2373 17.1713 23.1553 17.1026 23.0862C17.0339 23.0171 16.9523 22.9621 16.8624 22.9246C16.7725 22.887 16.676 22.8675 16.5786 22.8672Z" fill="white"/>
        <path d="M19.29 26.5873C19.4376 26.5884 19.5821 26.5457 19.7053 26.4645C19.8286 26.3834 19.9249 26.2674 19.9821 26.1314C20.0394 25.9954 20.0549 25.8455 20.0268 25.7006C19.9987 25.5558 19.9282 25.4225 19.8243 25.3178C19.7204 25.2131 19.5877 25.1416 19.443 25.1124C19.2984 25.0832 19.1483 25.0976 19.0119 25.1538C18.8755 25.21 18.7588 25.3055 18.6767 25.4281C18.5946 25.5507 18.5508 25.6949 18.5508 25.8425C18.5502 26.0392 18.6277 26.2282 18.7663 26.3679C18.9049 26.5075 19.0932 26.5865 19.29 26.5873Z" fill="white"/>
        <path d="M19.29 24.1029C19.4376 24.1041 19.5821 24.0613 19.7053 23.9802C19.8286 23.899 19.9249 23.7831 19.9821 23.6471C20.0394 23.5111 20.0549 23.3611 20.0268 23.2163C19.9987 23.0714 19.9282 22.9382 19.8243 22.8334C19.7204 22.7287 19.5877 22.6572 19.443 22.628C19.2984 22.5988 19.1483 22.6132 19.0119 22.6694C18.8755 22.7256 18.7588 22.8211 18.6767 22.9437C18.5946 23.0663 18.5508 23.2105 18.5508 23.3581C18.5502 23.5549 18.6277 23.7438 18.7663 23.8835C18.9049 24.0231 19.0932 24.1021 19.29 24.1029Z" fill="white"/>
        <path d="M13.8686 25.0954C13.869 24.9979 13.8501 24.9014 13.8132 24.8112C13.7762 24.721 13.7219 24.639 13.6532 24.5699C13.5846 24.5007 13.503 24.4457 13.4131 24.4081C13.3232 24.3705 13.2268 24.3509 13.1294 24.3505H12.6372C12.5716 24.3503 12.5088 24.324 12.4626 24.2776C12.4164 24.2311 12.3905 24.1681 12.3906 24.1026V23.6062C12.3906 23.4102 12.3128 23.2222 12.1742 23.0836C12.0356 22.945 11.8476 22.8672 11.6516 22.8672C11.4556 22.8672 11.2677 22.945 11.1291 23.0836C10.9905 23.2222 10.9126 23.4102 10.9126 23.6062V24.1026C10.9131 24.1354 10.9071 24.168 10.8949 24.1984C10.8828 24.2289 10.8648 24.2567 10.8419 24.2802C10.819 24.3037 10.7917 24.3224 10.7615 24.3352C10.7313 24.348 10.6989 24.3547 10.6661 24.3548H10.1734C9.97918 24.3596 9.79452 24.4402 9.65886 24.5793C9.5232 24.7184 9.44727 24.9051 9.44727 25.0994C9.44727 25.2937 9.5232 25.4803 9.65886 25.6194C9.79452 25.7585 9.97918 25.8391 10.1734 25.844H10.6661C10.7316 25.8442 10.7944 25.8705 10.8407 25.917C10.8869 25.9635 10.9128 26.0264 10.9126 26.092V26.5884C10.9126 26.7843 10.9905 26.9723 11.1291 27.1109C11.2677 27.2495 11.4556 27.3273 11.6516 27.3273C11.8476 27.3273 12.0356 27.2495 12.1742 27.1109C12.3128 26.9723 12.3906 26.7843 12.3906 26.5884V26.0938C12.3905 26.0283 12.4164 25.9653 12.4626 25.9188C12.5088 25.8724 12.5716 25.8461 12.6372 25.8459H13.1298C13.2274 25.8454 13.3238 25.8257 13.4137 25.7878C13.5036 25.7499 13.585 25.6946 13.6534 25.6251C13.7922 25.484 13.8695 25.2937 13.8686 25.0959" fill="white"/>
        <path d="M25.0959 21.6648L22.2333 20.6968C22.1094 20.6517 21.9756 20.6406 21.846 20.6649C21.7163 20.6891 21.5956 20.7478 21.4964 20.8346C21.3968 20.9224 21.3222 21.0351 21.2804 21.1611C21.2386 21.2871 21.2309 21.4219 21.2583 21.5518C21.285 21.6816 21.346 21.8019 21.435 21.9002C21.5239 21.9984 21.6375 22.0711 21.764 22.1106L24.6023 23.0701C25.2132 23.305 25.7386 23.7195 26.1094 24.2588C26.4801 24.7982 26.6789 25.4372 26.6794 26.0917V26.6954C26.6794 26.8915 26.7572 27.0795 26.8959 27.2181C27.0345 27.3568 27.2225 27.4346 27.4186 27.4346C27.6146 27.4346 27.8027 27.3568 27.9413 27.2181C28.0799 27.0795 28.1578 26.8915 28.1578 26.6954V26.0893C28.1558 25.1285 27.862 24.191 27.3153 23.4009C26.7686 22.6108 25.9948 22.0054 25.0964 21.6648" fill="white"/>
        <path d="M11.9108 21.0391C11.8803 20.9463 11.8317 20.8604 11.7679 20.7864C11.7041 20.7124 11.6264 20.6517 11.5391 20.6079C11.4524 20.5648 11.3581 20.5393 11.2616 20.5329C11.165 20.5264 11.0682 20.5392 10.9766 20.5704L8.03797 21.5632C7.14471 21.9064 6.37635 22.5121 5.83406 23.3006C5.29178 24.0891 5.00099 25.0233 5 25.9802V26.5849C5 26.7809 5.07788 26.969 5.21651 27.1076C5.35514 27.2462 5.54317 27.3241 5.73922 27.3241C5.93527 27.3241 6.12329 27.2462 6.26193 27.1076C6.40056 26.969 6.47844 26.7809 6.47844 26.5849V25.9802C6.47757 25.3293 6.6731 24.6933 7.03949 24.1553C7.40587 23.6173 7.92605 23.2024 8.53203 22.9647L11.4453 21.9804C11.6311 21.9165 11.7843 21.782 11.8715 21.6059C11.9587 21.4299 11.973 21.2266 11.9113 21.04" fill="white"/>
        <path d="M17.3591 16.2357C17.2896 16.2743 17.2162 16.3058 17.1402 16.3294C16.7887 16.4355 16.4136 16.4355 16.0621 16.3294C15.9856 16.3056 15.9116 16.2742 15.8413 16.2357C15.6704 16.1474 15.4718 16.1295 15.2879 16.1858C15.1039 16.242 14.9493 16.3679 14.8569 16.5366C14.7649 16.7057 14.7414 16.9037 14.7913 17.0897C14.8412 17.2756 14.9607 17.4352 15.1251 17.5355C15.2818 17.6225 15.4468 17.6936 15.6177 17.7478C16.259 17.9459 16.9452 17.9459 17.5865 17.7478C17.757 17.6935 17.9217 17.6224 18.0782 17.5355C18.2487 17.4372 18.3738 17.2758 18.4264 17.0861C18.4791 16.8965 18.455 16.6937 18.3594 16.5216C18.3125 16.4364 18.2491 16.3613 18.173 16.3007C18.0969 16.2401 18.0095 16.1952 17.9159 16.1686C17.8223 16.1421 17.7244 16.1343 17.6277 16.1458C17.5311 16.1573 17.4378 16.1878 17.353 16.2357H17.3591Z" fill="white"/>
        <path d="M15.7187 13.9609C15.8527 13.816 15.924 13.624 15.917 13.4268C15.91 13.2295 15.8252 13.043 15.6812 12.9081C15.3234 12.6043 14.8694 12.4375 14.4001 12.4375C13.9307 12.4375 13.4767 12.6043 13.119 12.9081C12.9752 13.0433 12.8905 13.2298 12.8833 13.4271C12.8761 13.6243 12.947 13.8165 13.0805 13.9618C13.1464 14.0335 13.2258 14.0913 13.3142 14.132C13.4026 14.1728 13.4982 14.1956 13.5954 14.1991C13.6926 14.2027 13.7896 14.187 13.8808 14.1528C13.9719 14.1187 14.0553 14.0669 14.1263 14.0003C14.2096 13.9519 14.3042 13.9264 14.4005 13.9264C14.4969 13.9264 14.5915 13.9519 14.6747 14.0003C14.7458 14.0665 14.8292 14.118 14.9202 14.1518C15.0112 14.1857 15.108 14.2012 15.205 14.1975C15.302 14.1938 15.3973 14.171 15.4855 14.1303C15.5736 14.0896 15.6529 14.0319 15.7187 13.9604" fill="white"/>
        <path d="M17.4744 12.9087C17.3307 13.0439 17.246 13.2304 17.2388 13.4276C17.2316 13.6249 17.3024 13.8171 17.436 13.9624C17.5018 14.034 17.5812 14.0918 17.6696 14.1326C17.7579 14.1733 17.8534 14.1961 17.9506 14.1997C18.0478 14.2032 18.1448 14.1875 18.2359 14.1534C18.327 14.1193 18.4104 14.0674 18.4813 14.0009C18.5647 13.9526 18.6594 13.9272 18.7558 13.9272C18.8521 13.9272 18.9468 13.9526 19.0302 14.0009C19.1253 14.0899 19.2423 14.1522 19.3692 14.1814C19.4962 14.2106 19.6286 14.2056 19.753 14.1671C19.8774 14.1285 19.9894 14.0577 20.0776 13.9618C20.1658 13.8659 20.227 13.7484 20.2551 13.6212C20.2841 13.4937 20.2793 13.3608 20.2412 13.2357C20.203 13.1107 20.1328 12.9978 20.0376 12.9082C19.6797 12.6043 19.2255 12.4375 18.756 12.4375C18.2865 12.4375 17.8323 12.6043 17.4744 12.9082" fill="white"/>
        <path d="M22.1633 16.4186C22.1697 16.3783 22.1859 16.3401 22.2104 16.3074C22.2349 16.2748 22.267 16.2486 22.3039 16.2311C22.7382 15.9954 23.0999 15.6457 23.35 15.2196C23.6002 14.7936 23.7295 14.3073 23.7238 13.8133C23.7476 13.3303 23.6086 12.8532 23.3291 12.4586C23.2899 12.4064 23.2731 12.3408 23.2822 12.2763C23.6103 9.77781 23.2635 7.5625 22.011 6.07234C20.8503 4.69516 19.0166 4 16.5589 4C14.1013 4 12.2694 4.69516 11.1106 6.07234C9.86986 7.54656 9.50517 9.75109 9.83798 12.2763C9.8426 12.3082 9.84083 12.3408 9.83279 12.3721C9.82474 12.4034 9.81058 12.4328 9.79111 12.4586C9.51127 12.8537 9.37257 13.3316 9.39736 13.8152C9.39155 14.3085 9.52031 14.7942 9.76982 15.2198C10.0193 15.6455 10.3801 15.9951 10.8135 16.2311C10.8505 16.2484 10.8827 16.2745 10.9073 16.3072C10.9318 16.3399 10.9479 16.3782 10.9541 16.4186C11.4538 19.4439 14.9164 21.3784 16.5575 21.3784C18.1986 21.3784 21.658 19.4439 22.1614 16.4209L22.1633 16.4186ZM21.6927 14.8741C21.435 14.9932 21.2104 15.1737 21.0388 15.3999C20.8672 15.626 20.7537 15.8908 20.7083 16.1711C20.3356 18.4042 17.5785 19.8836 16.5603 19.8836C15.5422 19.8836 12.7864 18.4042 12.4147 16.1716C12.3694 15.8912 12.2559 15.6263 12.0843 15.4001C11.9127 15.1738 11.6881 14.9932 11.4303 14.8741C11.2537 14.7534 11.1105 14.5899 11.0142 14.3989C10.9179 14.2079 10.8716 13.9956 10.8795 13.7819V13.6506C10.8865 13.5908 10.9152 13.5357 10.9601 13.4956C11.005 13.4555 11.0631 13.4333 11.1233 13.4331H11.2761C11.6763 13.4305 12.0633 13.2896 12.3715 13.0342C12.6796 12.7789 12.89 12.4248 12.9669 12.032L13.1492 11.1161C13.1596 11.0631 13.1871 11.0149 13.2275 10.979C13.2679 10.9431 13.319 10.9215 13.3728 10.9173C14.4681 10.9104 15.5308 10.5446 16.3981 9.87578C16.4429 9.83674 16.5002 9.81524 16.5596 9.81524C16.619 9.81524 16.6764 9.83674 16.7211 9.87578C17.5883 10.5451 18.651 10.9116 19.7464 10.9192C19.8003 10.9234 19.8513 10.9451 19.8916 10.981C19.932 11.0169 19.9595 11.065 19.97 11.118L20.1519 12.032C20.2291 12.4245 20.4396 12.7783 20.7477 13.0334C21.0558 13.2885 21.4427 13.4292 21.8427 13.4317H22.0241C22.0763 13.4319 22.1268 13.451 22.166 13.4855C22.2053 13.5199 22.2308 13.5674 22.2378 13.6192C22.2443 13.6744 22.247 13.73 22.2458 13.7856C22.2517 13.9979 22.2044 14.2084 22.1082 14.3977C22.012 14.5871 21.87 14.7494 21.695 14.8698" fill="white"/>
    </g>
</svg>
`;
const therapists = (fill) => `
<svg width="34" height="45" viewBox="0 0 34 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" fill="${colors[fill]}" clip-rule="evenodd" d="M34 15.7355C34 7.05891 26.3738 0 17 0C7.62617 0 0 7.05891 0 15.7355C0 21.412 8.32007 33.796 13.8605 42.0426C14.3485 42.769 14.815 43.4634 15.2523 44.1182C15.2767 44.1408 15.3067 44.1711 15.3421 44.2069C15.7687 44.6388 16.9873 45.8721 18.7477 43.9711C19.3095 43.1451 19.9195 42.2587 20.5616 41.3256C26.0921 33.2885 34 21.7966 34 15.7355Z" />
    <mask id="mask0_3066_47987" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="3" y="2" width="28" height="28">
        path fill-rule="evenodd" clip-rule="evenodd" d="M17 30C24.732 30 31 23.732 31 16C31 8.26801 24.732 2 17 2C9.26801 2 3 8.26801 3 16C3 23.732 9.26801 30 17 30Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_3066_47987)"></g>
    <path d="M27.108 7.74375C27.0829 7.59585 27.021 7.45665 26.9279 7.33901C26.8348 7.22136 26.7136 7.12906 26.5754 7.0706C26.4372 7.01215 26.2866 6.98943 26.1373 7.00455C25.9881 7.01966 25.845 7.07212 25.7214 7.15708C23.6832 8.39954 21.3188 9.00109 18.9347 8.88375C13.4547 8.88375 11.168 11.1171 11.1214 11.1704C9.84017 12.1149 8.91093 13.4601 8.48099 14.9926C8.05106 16.5251 8.14504 18.1574 8.74805 19.6304C8.78029 19.7094 8.78926 19.7959 8.7739 19.8798C8.75855 19.9636 8.7195 20.0414 8.66138 20.1038L6.29472 22.6637C6.20717 22.7434 6.13617 22.8396 6.08577 22.9467C6.03538 23.0538 6.00657 23.1698 6.001 23.288C5.99543 23.4062 6.0132 23.5244 6.0533 23.6358C6.0934 23.7472 6.15505 23.8495 6.23472 23.9371C6.39561 24.1139 6.62016 24.2195 6.85896 24.2308C6.9772 24.2364 7.09537 24.2186 7.20675 24.1785C7.31812 24.1384 7.4205 24.0768 7.50805 23.9971C9.02805 22.6171 11.508 18.4437 18.488 15.5304C18.7 15.4699 18.9269 15.49 19.125 15.5867C19.3231 15.6833 19.4785 15.8499 19.5612 16.0542C19.6439 16.2586 19.6482 16.4863 19.5732 16.6936C19.4981 16.9008 19.3491 17.0731 19.1547 17.1771C16.3794 18.312 13.8488 19.9711 11.7014 22.0637L11.4947 22.2838C11.4125 22.3673 11.3664 22.4798 11.3664 22.5971C11.3664 22.7143 11.4125 22.8269 11.4947 22.9104L11.568 22.9638C12.7007 23.6744 14.0109 24.051 15.348 24.0504C17.1461 24.0187 18.908 23.5398 20.4747 22.6571C28.268 18.3904 27.5347 10.1638 27.108 7.74375Z" fill="white"/>
</svg>
`;
const fitness = (fill) => `
<svg width="34" height="45" viewBox="0 0 34 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" fill="${colors[fill]}" clip-rule="evenodd" d="M34 15.7355C34 7.05891 26.3738 0 17 0C7.62617 0 0 7.05891 0 15.7355C0 21.412 8.32007 33.796 13.8605 42.0426C14.3485 42.769 14.815 43.4634 15.2523 44.1182C15.2767 44.1408 15.3067 44.1711 15.3421 44.2069C15.7687 44.6388 16.9873 45.8721 18.7477 43.9711C19.3095 43.1451 19.9195 42.2587 20.5616 41.3256C26.0921 33.2885 34 21.7966 34 15.7355Z"/>
    <mask id="mask0_3066_48013" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="3" y="2" width="28" height="28">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17 30C24.732 30 31 23.732 31 16C31 8.26801 24.732 2 17 2C9.26801 2 3 8.26801 3 16C3 23.732 9.26801 30 17 30Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_3066_48013)">
        <path d="M17.9985 7.0908C17.7277 6.83457 17.3676 6.69412 16.9948 6.69936C16.622 6.7046 16.266 6.8551 16.0025 7.11885C15.739 7.38259 15.5888 7.73875 15.5839 8.11154C15.579 8.48432 15.7198 8.8443 15.9763 9.11487L18.6739 11.813C18.7182 11.8571 18.7532 11.9096 18.7771 11.9673C18.8011 12.025 18.8134 12.0868 18.8134 12.1493C18.8134 12.2118 18.8011 12.2737 18.7771 12.3314C18.7532 12.3891 18.7182 12.4415 18.6739 12.4857L13.4816 17.6841C13.4374 17.7287 13.3848 17.764 13.3268 17.7882C13.2688 17.8123 13.2067 17.8248 13.1439 17.8248C13.0811 17.8248 13.0189 17.8123 12.9609 17.7882C12.903 17.764 12.8504 17.7287 12.8061 17.6841L10.1089 14.9878C9.9761 14.8549 9.81839 14.7495 9.6448 14.6776C9.47121 14.6056 9.28515 14.5685 9.09724 14.5685C8.71775 14.5684 8.35376 14.7191 8.08535 14.9874C7.95245 15.1202 7.84701 15.2779 7.77506 15.4515C7.70311 15.6251 7.66606 15.8112 7.66602 15.9991C7.66593 16.3786 7.8166 16.7426 8.08488 17.011L16.8538 25.7808C17.1241 26.0397 17.4851 26.1824 17.8594 26.1784C18.2337 26.1743 18.5915 26.0239 18.8562 25.7592C19.1209 25.4945 19.2714 25.1367 19.2754 24.7624C19.2795 24.3881 19.1368 24.0271 18.8779 23.7568L16.1802 21.0596C16.0908 20.9701 16.0406 20.8488 16.0406 20.7223C16.0406 20.5958 16.0908 20.4745 16.1802 20.385L21.3725 15.1871C21.4619 15.0977 21.5832 15.0475 21.7096 15.0475C21.836 15.0475 21.9572 15.0977 22.0466 15.1871L24.7452 17.8852C24.8778 18.0195 25.0357 18.1262 25.2097 18.1992C25.3837 18.2722 25.5705 18.3101 25.7592 18.3107C25.9479 18.3112 26.1349 18.2744 26.3094 18.2025C26.4838 18.1305 26.6423 18.0247 26.7757 17.8912C26.9091 17.7577 27.0148 17.5991 27.0867 17.4246C27.1585 17.2501 27.1952 17.0631 27.1945 16.8744C27.1938 16.6856 27.1558 16.4989 27.0827 16.3249C27.0095 16.151 26.9027 15.9932 26.7683 15.8607L17.9985 7.0908Z" fill="white"/>
        <path d="M28.455 11.4727L27.106 10.1274C27.0616 10.083 27.0265 10.0304 27.0025 9.97252C26.9785 9.91461 26.9661 9.85254 26.9661 9.78986C26.9661 9.72718 26.9785 9.66511 27.0025 9.6072C27.0265 9.54929 27.0616 9.49667 27.106 9.45236C27.4638 9.09457 27.6648 8.60929 27.6648 8.1033C27.6648 7.5973 27.4638 7.11203 27.106 6.75424C26.7482 6.39644 26.2629 6.19544 25.7569 6.19544C25.2509 6.19544 24.7656 6.39644 24.4078 6.75424C24.3183 6.84352 24.197 6.89365 24.0706 6.89365C23.9441 6.89365 23.8228 6.84352 23.7333 6.75424L22.3875 5.40424C22.1178 5.14247 21.7559 4.99729 21.3801 5.00004C21.0042 5.00279 20.6445 5.15325 20.3786 5.41894C20.1128 5.68463 19.962 6.04423 19.959 6.42009C19.956 6.79595 20.1009 7.15791 20.3625 7.42783L26.4286 13.5C26.6975 13.7687 27.062 13.9197 27.4422 13.9196C27.8223 13.9195 28.1868 13.7684 28.4555 13.4995C28.7242 13.2307 28.8751 12.8661 28.875 12.486C28.875 12.1059 28.7239 11.7414 28.455 11.4727Z" fill="white"/>
        <path d="M8.42125 19.366C8.15079 19.1072 7.78973 18.9646 7.41544 18.9688C7.04114 18.9731 6.68339 19.1237 6.41883 19.3885C6.15427 19.6533 6.00395 20.0112 6.00008 20.3855C5.99621 20.7598 6.13909 21.1207 6.39812 21.391L7.74812 22.7396C7.83743 22.8292 7.88758 22.9505 7.88758 23.0771C7.88758 23.2036 7.83743 23.3249 7.74812 23.4146C7.39033 23.7723 7.18932 24.2576 7.18932 24.7636C7.18932 25.2696 7.39033 25.7549 7.74812 26.1127C8.10592 26.4705 8.59119 26.6715 9.09719 26.6715C9.60318 26.6715 10.0885 26.4705 10.4462 26.1127C10.5359 26.0233 10.6574 25.9732 10.784 25.9732C10.9106 25.9732 11.032 26.0233 11.1217 26.1127L12.4656 27.458C12.5965 27.5992 12.7545 27.7125 12.9302 27.7912C13.1058 27.8698 13.2956 27.9122 13.4881 27.9158C13.6805 27.9194 13.8717 27.8842 14.0502 27.8121C14.2287 27.7401 14.3909 27.6328 14.5269 27.4966C14.663 27.3604 14.7701 27.1982 14.842 27.0196C14.9139 26.841 14.949 26.6498 14.9452 26.4573C14.9414 26.2649 14.8988 26.0752 14.82 25.8996C14.7412 25.724 14.6277 25.5661 14.4864 25.4353L8.42125 19.366Z" fill="white"/>
    </g>
</svg>
`;
const course = (fill) => `
<svg xmlns="http://www.w3.org/2000/svg" width="34" height="45" viewBox="0 0 34 45" fill="none">
    <path fill-rule="evenodd" fill="${colors[fill]}" clip-rule="evenodd" d="M34 15.7355C34 7.05891 26.3738 0 17 0C7.62617 0 0 7.05891 0 15.7355C0 21.412 8.32007 33.796 13.8605 42.0426C14.3485 42.769 14.815 43.4634 15.2523 44.1182C15.2767 44.1408 15.3067 44.1711 15.3421 44.2069C15.7687 44.6388 16.9873 45.8721 18.7477 43.9711C19.3095 43.1451 19.9195 42.2587 20.5616 41.3256C26.0921 33.2885 34 21.7966 34 15.7355Z"/>
    <mask id="mask0_3066_48045" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="3" y="2" width="28" height="28">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17 30C24.732 30 31 23.732 31 16C31 8.26801 24.732 2 17 2C9.26801 2 3 8.26801 3 16C3 23.732 9.26801 30 17 30Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_3066_48045)">
        <path d="M17.6096 16.116L17.3939 16.2098C17.2205 16.2613 17.0377 16.2895 16.8596 16.2895C16.6767 16.2895 16.4986 16.266 16.3252 16.2098C16.2502 16.1863 16.1799 16.1535 16.1096 16.116C15.7533 15.9191 15.308 16.0457 15.1064 16.402C14.9049 16.7582 15.0361 17.2035 15.3924 17.4051C15.5517 17.4895 15.7158 17.5598 15.8846 17.6113C16.2033 17.7098 16.5361 17.7566 16.8689 17.7566C17.2017 17.7566 17.5346 17.7098 17.8533 17.6113C18.0221 17.5598 18.1908 17.4895 18.3455 17.4051C18.7017 17.2035 18.8283 16.7535 18.6267 16.3973C18.4252 16.041 17.9752 15.9145 17.6189 16.116H17.6096ZM15.9736 13.8613C16.2596 13.5754 16.2596 13.1113 15.9736 12.8254C15.2283 12.1832 14.1267 12.1832 13.3814 12.8254C13.0814 13.102 13.0674 13.566 13.3439 13.866C13.6205 14.166 14.0846 14.1801 14.3846 13.9035C14.5533 13.8051 14.7642 13.8051 14.9377 13.9035C15.2236 14.1941 15.6877 14.1941 15.9736 13.9082L15.9783 13.9035L15.9736 13.8613ZM17.7267 12.816C17.4267 13.0926 17.4127 13.5566 17.6892 13.8566C17.9658 14.1566 18.4299 14.1707 18.7299 13.8941C18.8986 13.7957 19.1096 13.7957 19.283 13.8941C19.583 14.1707 20.0471 14.152 20.3236 13.8566C20.6002 13.5613 20.5814 13.0926 20.2861 12.816C19.5455 12.1973 18.4674 12.1973 17.7267 12.816ZM27.5471 22.852C25.7517 21.5676 23.6799 20.7238 21.5002 20.3723C21.3314 20.3395 21.158 20.4004 21.0408 20.527L19.583 22.177C19.5361 22.2004 19.4939 22.2285 19.4517 22.2613L17.1877 24.6895C16.9486 24.9426 16.5502 24.952 16.2971 24.7129L16.2736 24.6895L14.7267 23.0488L12.4486 20.4566C12.3314 20.3301 12.158 20.2691 11.9892 20.302C9.80956 20.6488 7.74237 21.4973 5.94237 22.7816C5.34237 23.2457 4.99081 23.9676 5.00018 24.727V26.7988C5.00018 27.0707 5.2205 27.291 5.49237 27.291H27.9455C28.2174 27.291 28.4377 27.0707 28.4377 26.7988V24.727C28.4377 24.0004 28.1096 23.3113 27.5471 22.852Z" fill="white"/>
        <path d="M23.7399 10.9891L23.8618 10.9375L24.0071 10.8578C24.7196 10.4125 24.9399 9.47968 24.4946 8.7625C24.2555 8.37344 23.8524 8.11562 23.4024 8.05937H23.2993C23.0883 7.33281 22.7274 6.6625 22.2446 6.08125C21.0868 4.71719 19.2586 4 16.8118 4C14.3649 4 12.4946 4.69375 11.3696 6.05781C11.3086 6.12812 11.2664 6.20312 11.2055 6.27344C10.8868 6.30625 10.5821 6.4375 10.343 6.65312C9.49926 7.42187 9.01176 8.50937 9.00238 9.64843C8.99301 10.0234 9.13832 10.3891 9.40082 10.6609C9.57426 10.8344 9.78051 10.9656 10.0149 11.0406C10.0149 11.4484 10.0664 11.9031 10.1274 12.3016C9.80394 12.7 9.64457 13.2062 9.66801 13.7172C9.65863 14.7156 10.2024 15.6391 11.0836 16.1078C11.1586 16.1406 11.2149 16.2062 11.2289 16.2906C11.7352 19.2859 15.1899 21.1937 16.8211 21.1937C18.4524 21.1937 21.9071 19.2859 22.4086 16.2906C22.4227 16.2109 22.4743 16.1406 22.5446 16.1078C23.4258 15.6344 23.9696 14.7156 23.9602 13.7172C23.9883 13.2062 23.8243 12.7 23.5008 12.3016C23.5618 11.8609 23.5946 11.4391 23.6133 11.05L23.7399 10.9891ZM16.8305 5.47656C18.8274 5.47656 20.2852 5.9875 21.1477 7.00469C21.3446 7.24375 21.5086 7.50156 21.6399 7.78281L13.0899 6.50781C14.1868 5.76719 15.4946 5.40625 16.8118 5.48125H16.8305V5.47656ZM21.9493 14.7719C21.4289 15.0109 21.0633 15.4891 20.9649 16.0516C20.5946 18.2641 17.8383 19.7312 16.8305 19.7312C15.8227 19.7312 13.0664 18.2641 12.6961 16.0516C12.6024 15.4937 12.2414 15.0156 11.7305 14.7719C11.3743 14.5281 11.1633 14.125 11.1774 13.6937C11.1539 13.5437 11.1914 13.3891 11.2805 13.2625C11.5711 13.1172 11.7305 12.8031 11.6789 12.4844C11.6039 12.0344 11.5524 11.5844 11.5243 11.1297H22.1368C22.1133 11.5891 22.0618 12.0437 21.9914 12.4937C21.9399 12.8125 22.1039 13.1266 22.3899 13.2719C22.4789 13.3984 22.5164 13.5531 22.493 13.7031C22.5024 14.1297 22.2961 14.5328 21.9399 14.7719H21.9493Z" fill="white"/>
    </g>
</svg>
`;
const mixed = (fill) => `
<svg width="38" height="48" viewBox="0 0 38 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" fill="${colors[fill]}" clip-rule="evenodd" d="M19 0C29.4766 0 38 7.52951 38 16.7845C38 24.0003 26.9907 38.4319 20.9533 46.9025C18.8224 49.0987 17.4019 47.3731 17.0467 47.0594C11.0093 38.4319 0 23.3728 0 16.7845C0 7.52951 8.52337 0 19 0ZM19.0672 11.7305C22.6525 11.7305 25.7067 14.2862 25.7067 17.539C25.7067 20.7919 22.6525 23.4638 19.0672 23.4638C15.3491 23.4638 12.2949 20.7919 12.2949 17.539C12.2949 14.2862 15.3491 11.7305 19.0672 11.7305Z" />
</svg>
`;
const userLocation = (fill) => `
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <circle cx="16" cy="16" r="16" fill="${colors[fill]}"/>
    <path d="M28 16.0013C27.9993 15.8358 27.9666 15.6723 27.9036 15.5203C27.8407 15.3684 27.749 15.2314 27.6339 15.1173C27.3956 14.8814 27.0792 14.7502 26.7504 14.7513H25.1534C24.587 10.6461 21.3575 7.41762 17.2515 6.85168V5.24946C17.2515 4.55929 16.6906 4 16 4C15.3094 4 14.7485 4.55929 14.7485 5.24946V6.84963C10.6429 7.4171 7.41595 10.644 6.84663 14.7493H5.25006C4.55951 14.7498 4 15.3091 4 15.9997C4 16.6904 4.55951 17.2497 5.25006 17.2497H6.85006C7.41742 21.3549 10.6444 24.5819 14.7519 25.1499V26.75C14.7519 27.4402 15.3114 28 16.002 28C16.6925 28 17.2515 27.4402 17.2515 26.75V25.1499C21.3575 24.5839 24.587 21.357 25.1534 17.2497H26.748C27.4375 17.2497 27.9971 16.6914 27.998 16.0018M17.5583 22.563C17.5216 22.5716 17.4836 22.5718 17.4468 22.5637C17.4101 22.5556 17.3754 22.5393 17.3453 22.516C17.3159 22.493 17.292 22.4633 17.2755 22.4292C17.259 22.395 17.2503 22.3574 17.2501 22.3191V21.2496C17.2515 20.559 16.6906 20.0017 16 20.0017C15.3094 20.0017 14.7485 20.559 14.7485 21.2496V22.3191C14.7482 22.3574 14.7394 22.395 14.7229 22.4291C14.7064 22.4633 14.6826 22.493 14.6533 22.516C14.6231 22.5393 14.5884 22.5556 14.5517 22.5637C14.5149 22.5718 14.4769 22.5716 14.4402 22.563C11.9622 21.9705 10.0275 20.036 9.43411 17.558C9.42563 17.5209 9.42565 17.4822 9.43418 17.445C9.4427 17.4079 9.45949 17.3734 9.48319 17.3443C9.50715 17.3143 9.53718 17.2903 9.57112 17.2738C9.60507 17.2574 9.64208 17.249 9.67951 17.2492H10.7494C11.44 17.2492 11.9995 16.6899 11.9995 15.9992C11.9995 15.3086 11.44 14.7493 10.7494 14.7493H9.67951C9.64145 14.7499 9.60374 14.7416 9.56911 14.7252C9.53447 14.7088 9.50379 14.6845 9.47926 14.6542C9.45584 14.6249 9.43922 14.5904 9.4307 14.5533C9.42219 14.5162 9.42201 14.4776 9.43018 14.4405C10.0231 11.963 11.9578 10.0285 14.4363 9.43547C14.473 9.42674 14.5111 9.42653 14.548 9.43483C14.5848 9.44313 14.6194 9.45976 14.6493 9.48352C14.6798 9.50627 14.7046 9.53629 14.7217 9.57106C14.7388 9.60583 14.7476 9.64436 14.7475 9.68342V10.7534C14.7475 11.4441 15.307 12.0039 15.9975 12.0039C16.6881 12.0039 17.2515 11.4441 17.2515 10.7534V9.67984C17.2518 9.6416 17.2605 9.60394 17.277 9.5698C17.2935 9.53566 17.3174 9.50595 17.3467 9.48301C17.3769 9.45958 17.4115 9.44323 17.4483 9.43511C17.4851 9.42699 17.5231 9.42729 17.5598 9.43598C20.0378 10.029 21.9725 11.9635 22.5659 14.441C22.5741 14.4781 22.5739 14.5168 22.5654 14.5538C22.5569 14.5909 22.5402 14.6254 22.5168 14.6547C22.4923 14.685 22.4616 14.7093 22.427 14.7258C22.3923 14.7422 22.3546 14.7504 22.3166 14.7498H21.2501C20.56 14.7498 20 15.3091 20 15.9997C20 16.6904 20.5595 17.2497 21.2501 17.2497H22.32C22.3574 17.2495 22.3945 17.2579 22.4284 17.2743C22.4624 17.2907 22.4924 17.3148 22.5163 17.3448C22.54 17.3739 22.5568 17.4084 22.5653 17.4456C22.5739 17.4827 22.5739 17.5214 22.5654 17.5585C21.9725 20.0365 20.0378 21.971 17.5593 22.5635" fill="white"/>
</svg>
`;
const cluster = () => `
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 63 63" style="enable-background:new 0 0 63 63;" xml:space="preserve">
  <path fill-rule="evenodd" clip-rule="evenodd" fill="#C26B8D" d="M31.2,63c17.4,0,31.5-14.1,31.5-31.5S48.6,0,31.2,0S-0.2,14.1-0.2,31.5S13.9,63,31.2,63z"/>
  <path fill-rule="evenodd" clip-rule="evenodd" fill="#9A0941" d="M31.2,54c12.4,0,22.5-10.1,22.5-22.5S43.7,9,31.2,9C18.8,9,8.7,19.1,8.7,31.5S18.8,54,31.2,54z"/>
</svg>`;

const MarkerSvgRessources = {
    doctor,
    pediatrician,
    therapists,
    fitness,
    course,
    mixed,
    cluster,
};
const MarkerBase64Ressources = {
    doctor: (color) => 'data:image/svg+xml;base64,' + btoa(doctor(color)),
    pediatrician: (color) => 'data:image/svg+xml;base64,' + btoa(pediatrician(color)),
    therapists: (color) => 'data:image/svg+xml;base64,' + btoa(therapists(color)),
    fitness: (color) => 'data:image/svg+xml;base64,' + btoa(fitness(color)),
    course: (color) => 'data:image/svg+xml;base64,' + btoa(course(color)),
    mixed: (color) => 'data:image/svg+xml;base64,' + btoa(mixed(color)),
    cluster: () => 'data:image/svg+xml;base64,' + btoa(cluster()),
};
const UserLocationMarkerSvgRessource = {
    userLocation,
};
const UserLocationMarkerBase64Ressource = {
    userLocation: (color) => 'data:image/svg+xml;base64,' + btoa(userLocation(color)),
};

function debounce(callback, delay) {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            callback(...args);
        }, delay);
    };
}

const searchAreaButtonComponentVm = createSelector(selectArea, (area) => ({
    hasTooMuchResults: area.hasTooMuchResults,
    hasNoResults: area.hasNoResults,
}));

/**
 * @description
 * This component will be use as a custom web component.
 */
let MapSearchAreaButtonComponent = class MapSearchAreaButtonComponent {
    constructor() {
        this.store = inject(Store);
        this.translocoService = inject(TranslocoService);
        this.vm$ = this.store.select(searchAreaButtonComponentVm);
    }
    static { this.selector = 'helsana-maps-search-area-button'; }
    ngOnInit() {
        this.vm$
            .pipe(untilDestroyed(this), tap((vm) => (this.vm = vm)))
            .subscribe();
        if (typeof this.mapCenter == 'string')
            this.mapCenter = JSON.parse(this.mapCenter);
        if (typeof this.mapBounds == 'string')
            this.mapBounds = JSON.parse(this.mapBounds);
    }
    handleClicked() {
        const radius = getRadius(this.mapBounds, this.mapCenter);
        this.store.dispatch(searchAreabuttonClicked({
            radius,
            center: this.mapCenter,
            input: this.translocoService.translate('SearchAreaButtonComponent.aktuellerKartenausschnitt'),
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: MapSearchAreaButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: MapSearchAreaButtonComponent, isStandalone: true, selector: "ng-component", inputs: { mapCenter: "mapCenter", mapBounds: "mapBounds" }, ngImport: i0, template: `
    <div
      (click)="handleClicked()"
      *transloco="let t"
      class="text-helsana t-label-normal  m-4 cursor-pointer rounded-full  bg-white px-6 py-2"
      [ngClass]="
        vm?.hasTooMuchResults || vm?.hasNoResults ? 'too-much-results' : ''
      "
    >
      {{
        vm?.hasTooMuchResults
          ? t('SearchAreaButtonComponent.zuVieleErgebnisse')
          : vm?.hasNoResults
          ? t('SearchAreaButtonComponent.keineErgebnisse')
          : t('SearchAreaButtonComponent.inDiesemGebietSuchen')
      }}
    </div>
  `, isInline: true, styles: [".too-much-results{border-width:2px;border-color:rgb(154 9 65/var(--tw-border-opacity));animation:zoom-in-zoom-out .7s ease .7}@keyframes zoom-in-zoom-out{0%{transform:scale(1)}50%{transform:scale(1.1)}to{transform:scale(1)}}\n"], dependencies: [{ kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i2.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "ngmodule", type: LetModule }, { kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], encapsulation: i0.ViewEncapsulation.None }); }
};
MapSearchAreaButtonComponent = __decorate([
    UntilDestroy()
], MapSearchAreaButtonComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: MapSearchAreaButtonComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, imports: [TranslocoModule, LetModule, NgClass], template: `
    <div
      (click)="handleClicked()"
      *transloco="let t"
      class="text-helsana t-label-normal  m-4 cursor-pointer rounded-full  bg-white px-6 py-2"
      [ngClass]="
        vm?.hasTooMuchResults || vm?.hasNoResults ? 'too-much-results' : ''
      "
    >
      {{
        vm?.hasTooMuchResults
          ? t('SearchAreaButtonComponent.zuVieleErgebnisse')
          : vm?.hasNoResults
          ? t('SearchAreaButtonComponent.keineErgebnisse')
          : t('SearchAreaButtonComponent.inDiesemGebietSuchen')
      }}
    </div>
  `, encapsulation: ViewEncapsulation.None, styles: [".too-much-results{border-width:2px;border-color:rgb(154 9 65/var(--tw-border-opacity));animation:zoom-in-zoom-out .7s ease .7}@keyframes zoom-in-zoom-out{0%{transform:scale(1)}50%{transform:scale(1.1)}to{transform:scale(1)}}\n"] }]
        }], propDecorators: { mapCenter: [{
                type: Input
            }], mapBounds: [{
                type: Input
            }] } });

const selectGoogleMapsComponentVm = createSelector(selectArea, selectIsLocationActive, selectSearchState, selectLocation, (area, isLocationActive, searchState, location) => ({
    hideSearchAreaButton: area.hideAreaSearchButton,
    hasTooMuchResults: area.hasTooMuchResults,
    showCurrentLocationMarker: isLocationActive && searchState === 'locationSuccess',
    currentLocation: location,
}));

let GoogleMapsComponent = class GoogleMapsComponent {
    constructor() {
        this.googleMapsService = inject(GoogleMapsService);
        this.store = inject(Store);
        this.searchAreaButtonWebComponent = createCustomElement(MapSearchAreaButtonComponent, { injector: inject(Injector) });
        this.vm$ = this.store.select(selectGoogleMapsComponentVm);
        /**
         * The height of the Google Maps
         */
        this.height = '400px';
        this.showZoomControl = true;
        this.activateMarkerOnClick = false;
        this.gestureHandling = true;
        this.showAreaSearchButton = false;
        this.isMapOverlayVisible = false;
        this.isDesktop = false;
        this.coordinates = [];
        this.markerClicked = new EventEmitter();
        this.markerHovered = new EventEmitter();
        this.mapClicked = new EventEmitter();
        this.mapUpdated = new EventEmitter();
        this.hostHeight = this.height;
        this.initialLatLng = { lat: 46.8, lng: 8.4 };
        this.initialZoom = 7;
        this.coordinateCount = {};
        this.options = {
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            maxZoom: 18,
            minZoom: this.initialZoom,
            styles: [
                {
                    featureType: 'poi',
                    stylers: [{ visibility: 'off' }],
                },
            ],
        };
        this.init = true;
        this.markers = [];
        this.clusterIcon = MarkerBase64Ressources.cluster();
        this.googleMapsMarkerOptions = {
            clickable: true,
        };
        this.mapLoaded$ = new Subject();
        this.coordinates$ = new Subject();
        if (!customElements.get(MapSearchAreaButtonComponent.selector)) {
            customElements.define(MapSearchAreaButtonComponent.selector, this.searchAreaButtonWebComponent);
        }
        combineLatest([this.mapLoaded$, this.coordinates$])
            .pipe(untilDestroyed(this))
            .subscribe(([, coordinates]) => this.handleCoordinates(coordinates));
    }
    ngOnInit() {
        this.options.zoomControl = this.showZoomControl;
        this.options.gestureHandling = this.gestureHandling ? 'auto' : 'none';
        this.vm$
            .pipe(untilDestroyed(this), tap((vm) => {
            if (this.vmStringified && this.vmStringified === JSON.stringify(vm))
                return;
            this.vmStringified = JSON.stringify(vm);
            if (vm.hasTooMuchResults)
                this.addButton();
            this.handleCurrentLocationMarker();
        }))
            .subscribe();
    }
    handleCurrentLocationMarker() {
        this.vm$.pipe(take(1)).subscribe((vm) => {
            // Set current location cluster
            this.currentPositionMarkerCluster?.clearMarkers();
            if (vm.showCurrentLocationMarker) {
                this.currentPositionMarkerCluster?.addMarker(new google.maps.Marker({
                    zIndex: google.maps.Marker.MAX_ZINDEX + 1000,
                    position: vm.currentLocation,
                    icon: UserLocationMarkerBase64Ressource.userLocation('signal-pink'),
                }));
                timer(50).subscribe(() => this.handleCoordinates(this.coordinates));
            }
        });
    }
    ngOnChanges(changes) {
        if (JSON.stringify(changes['coordinates']?.currentValue) !==
            JSON.stringify(changes['coordinates']?.previousValue)) {
            this.coordinates$.next(changes['coordinates']?.currentValue);
        }
        this.hostHeight = changes['height']?.currentValue || this.height;
        this.options.zoomControl = changes['showZoomControl']?.currentValue;
        this.vm$.pipe(take(1)).subscribe((vm) => {
            if (!vm.hideSearchAreaButton)
                this.addButton();
        });
    }
    onMapInitialized(map) {
        this.map = map;
        const renderer = {
            render: ({ count, position, }) => new google.maps.Marker({
                label: {
                    text: String(count),
                    color: 'white',
                    fontSize: '14px',
                },
                icon: {
                    url: this.clusterIcon,
                    scaledSize: new google.maps.Size(45, 45),
                },
                position,
                zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
            }),
        };
        this.markerCluster = new MarkerClusterer({
            map,
            markers: [],
            renderer,
        });
        this.currentPositionMarkerCluster = new MarkerClusterer({
            map,
            markers: [],
        });
        this.addMapListener(this.map);
        this.mapLoaded$.next();
    }
    addMapListener(map) {
        map.addListener('click', () => {
            this.resetMarkerIcons();
            this.mapClicked.emit();
        });
        map.addListener('idle', debounce(() => this.updateMap(), 100));
    }
    updateMap() {
        this.map?.controls[google.maps.ControlPosition.TOP_LEFT].clear();
        this.map?.controls[google.maps.ControlPosition.TOP_CENTER].clear();
        const bounds = this.map?.getBounds();
        const center = this.map?.getCenter()?.toJSON();
        const coordsInViewPort = [];
        this.coordinates?.forEach((c) => {
            if (bounds.contains(c))
                coordsInViewPort.push(c);
        });
        this.mapUpdated.next({
            center,
            radius: getRadius(bounds.getNorthEast().toJSON(), center),
            coordsInViewPort,
        });
        this.vm$
            .pipe(take(1), tap((vm) => {
            if (!this.showAreaSearchButton ||
                this.isMapOverlayVisible ||
                vm.hideSearchAreaButton)
                return;
            this.addButton();
        }))
            .subscribe();
    }
    addButton() {
        if (!this.map)
            return;
        const bounds = this.map?.getBounds();
        const center = this.map?.getCenter()?.toJSON();
        this.map?.controls[google.maps.ControlPosition.TOP_LEFT].clear();
        this.map?.controls[google.maps.ControlPosition.TOP_CENTER].clear();
        const control = this.getSearchAreaButton(center, bounds);
        this.isDesktop
            ? this.map?.controls[google.maps.ControlPosition.TOP_LEFT].push(control)
            : this.map?.controls[google.maps.ControlPosition.TOP_CENTER].push(control);
    }
    getSearchAreaButton(center, bounds) {
        const searchAreaButton = document.createElement(MapSearchAreaButtonComponent.selector);
        searchAreaButton.setAttribute('map-center', JSON.stringify(center));
        searchAreaButton.setAttribute('map-bounds', JSON.stringify(bounds?.getNorthEast().toJSON()));
        return searchAreaButton;
    }
    handleCoordinates(coordinates) {
        this.countIdenticalCoordinates(coordinates);
        this.clearAndSetMarkers(coordinates);
        if (!coordinates?.length) {
            if (this.init) {
                this.init = false;
            }
            const timesId = setTimeout(() => {
                this.zoomCenterMapFromCoordinates([this.initialLatLng], this.initialZoom);
                clearTimeout(timesId);
            }, 50);
            return;
        }
        if (coordinates) {
            const zoomCoordinates = [...coordinates];
            this.vm$.pipe(take(1)).subscribe((vm) => {
                if (vm.showCurrentLocationMarker) {
                    zoomCoordinates.push({
                        lat: vm.currentLocation?.lat,
                        lng: vm.currentLocation?.lng,
                    });
                }
                this.zoomCenterMapFromCoordinates(zoomCoordinates);
            });
        }
    }
    zoomCenterMapFromCoordinates(coordinates, zoomForSingle = 17) {
        // avoids flickering on the map that fitBounds() triggers when setting same coords
        if (this.isCenterAlreadySet(coordinates) || !this.map)
            return;
        const uniqueCoordinates = new Set(coordinates.map((c) => getCoordinateId(c)));
        if (uniqueCoordinates.size === 1) {
            // single marker get not handled well by fitBound regarding zoom-behavior
            this.map.setCenter(coordinates[0]);
            this.map.setZoom(zoomForSingle);
            return;
        }
        const bounds = new google.maps.LatLngBounds();
        coordinates
            .filter((coordinates) => coordinates.lat)
            .forEach((coordinates) => bounds.extend(coordinates));
        // If the bounds are the same, we still want to update the map
        // since reducers rely on it
        if (this.bounds && bounds.equals(this.bounds))
            this.updateMap();
        this.bounds = bounds;
        this.map.fitBounds(bounds);
    }
    countIdenticalCoordinates(coordinates) {
        this.coordinateCount = {};
        coordinates?.map((coordinate) => {
            const id = getCoordinateId(coordinate);
            this.coordinateCount[id] = this.coordinateCount[id] || {
                types: new Set(),
                count: 0,
            };
            coordinate.type && this.coordinateCount[id]?.types.add(coordinate.type);
            this.coordinateCount[id].count =
                (this.coordinateCount[id]?.count || 0) + 1;
        });
    }
    clearAndSetMarkers(coordinates) {
        this.markerCluster?.clearMarkers();
        this.markers = [];
        if (!coordinates) {
            return;
        }
        this.markerCluster?.addMarkers(coordinates.map((coordinate) => {
            const { types, count } = this.coordinateCount[getCoordinateId(coordinate)];
            const marker = new google.maps.Marker({
                position: coordinate,
                ...this.getGoogleMapsMarkerOptions(coordinate),
                ...this.googleMapsMultiMarkerOptions(count, types),
            });
            this.addMarkerListener(marker, coordinate);
            this.markers.push(marker);
            return marker;
        }));
    }
    getGoogleMapsMarkerOptions({ isUserLocation, type, }) {
        return {
            icon: isUserLocation
                ? UserLocationMarkerBase64Ressource.userLocation('signal-pink')
                : this.getMarkerIcon(type),
            ...this.googleMapsMarkerOptions,
        };
    }
    addMarkerListener(marker, coordinate) {
        const { type, isUserLocation } = coordinate;
        const { types, count } = this.coordinateCount[getCoordinateId(coordinate)];
        if (!isUserLocation) {
            marker.addListener('click', () => {
                this.markerClicked.emit(marker);
                if (this.activateMarkerOnClick) {
                    this.resetMarkerIcons();
                    const icon = count < 2
                        ? this.getMarkerIcon(type, 'black')
                        : this.getMultiMarkerIcon(types, 'black');
                    marker.setIcon(icon);
                }
            });
            marker.addListener('mouseover', () => {
                const icon = count < 2
                    ? this.getMarkerIcon(type, 'black')
                    : this.getMultiMarkerIcon(types, 'black');
                marker.setIcon(icon);
                this.markerHovered.emit(marker);
            });
            marker.addListener('mouseout', () => {
                const icon = count < 2
                    ? this.getMarkerIcon(type, 'helsana')
                    : this.getMultiMarkerIcon(types, 'helsana');
                marker.setIcon(icon);
                this.markerHovered.emit();
            });
        }
    }
    isCenterAlreadySet(coordinates) {
        const toOneDecimalNumber = (number) => {
            return Number((number ?? 0).toFixed(1));
        };
        return (coordinates.length === 1 &&
            coordinates[0].lat === toOneDecimalNumber(this.map?.getCenter()?.lat()) &&
            coordinates[0].lng === toOneDecimalNumber(this.map?.getCenter()?.lng()));
    }
    googleMapsMultiMarkerOptions(count, types) {
        if (count < 2) {
            return {};
        }
        return {
            label: {
                text: String(count),
                color: 'white',
                fontSize: '12px',
                className: 'marker-cluster-label',
            },
            icon: {
                url: this.getMultiMarkerIcon(types),
            },
        };
    }
    resetMarkerIcons() {
        this.markers.forEach((marker) => {
            const lat = marker.getPosition()?.lat();
            const lng = marker.getPosition()?.lng();
            const { count, types } = this.coordinateCount[getCoordinateId({ lat, lng })];
            const icon = count < 2
                ? this.getIconInHelsanaColorByIcon(marker.getIcon())
                : this.getMultiMarkerIcon(types, 'helsana');
            marker.setIcon(icon);
        });
    }
    getMultiMarkerIcon(types, color = 'helsana') {
        if (types.size === 1) {
            const value = types.values().next().value;
            return this.getMarkerIcon(value, color);
        }
        if (types.size === 2 &&
            types.has(ProviderType.AVM_OTHER) &&
            types.has(ProviderType.AVM_GROUP)) {
            return MarkerBase64Ressources.doctor(color);
        }
        return MarkerBase64Ressources.mixed(color);
    }
    getMarkerIcon(type, color = 'helsana') {
        switch (type) {
            case ProviderType.AVM_OTHER:
            case ProviderType.AVM_GROUP:
                return MarkerBase64Ressources.doctor(color);
            case ProviderType.AVM_PEDIA:
                return MarkerBase64Ressources.pediatrician(color);
            case ProviderType.EMR:
                return MarkerBase64Ressources.therapists(color);
            case ProviderType.FIT:
                return MarkerBase64Ressources.fitness(color);
            case ProviderType.KUR:
                return MarkerBase64Ressources.course(color);
            default:
                return MarkerBase64Ressources.mixed(color);
        }
    }
    getIconInHelsanaColorByIcon(icon) {
        if (icon === MarkerBase64Ressources.doctor('helsana') ||
            icon === MarkerBase64Ressources.doctor('black'))
            return MarkerBase64Ressources.doctor('helsana');
        if (icon === MarkerBase64Ressources.pediatrician('helsana') ||
            icon === MarkerBase64Ressources.pediatrician('black'))
            return MarkerBase64Ressources.pediatrician('helsana');
        if (icon === MarkerBase64Ressources.therapists('helsana') ||
            icon === MarkerBase64Ressources.therapists('black'))
            return MarkerBase64Ressources.therapists('helsana');
        if (icon === MarkerBase64Ressources.fitness('helsana') ||
            icon === MarkerBase64Ressources.fitness('black'))
            return MarkerBase64Ressources.fitness('helsana');
        if (icon === MarkerBase64Ressources.course('helsana') ||
            icon === MarkerBase64Ressources.course('black'))
            return MarkerBase64Ressources.course('helsana');
        if (icon === MarkerBase64Ressources.mixed('helsana') ||
            icon === MarkerBase64Ressources.mixed('black'))
            return MarkerBase64Ressources.mixed('helsana');
        return MarkerBase64Ressources.mixed('helsana');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: GoogleMapsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: GoogleMapsComponent, isStandalone: true, selector: "helsana-google-maps", inputs: { height: "height", showZoomControl: "showZoomControl", activateMarkerOnClick: "activateMarkerOnClick", gestureHandling: "gestureHandling", showAreaSearchButton: "showAreaSearchButton", isMapOverlayVisible: "isMapOverlayVisible", isDesktop: "isDesktop", coordinates: "coordinates" }, outputs: { markerClicked: "markerClicked", markerHovered: "markerHovered", mapClicked: "mapClicked", mapUpdated: "mapUpdated" }, host: { properties: { "style.height": "this.hostHeight" } }, usesOnChanges: true, ngImport: i0, template: `
    <ng-container *ngIf="googleMapsService.googleMapsApiLoaded$ | async">
      <google-map
        width="100%"
        height="100%"
        [options]="options"
        (mapInitialized)="onMapInitialized($event)"
      >
      </google-map>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "ngmodule", type: GoogleMapsModule }, { kind: "component", type: i2$1.GoogleMap, selector: "google-map", inputs: ["height", "width", "mapTypeId", "center", "zoom", "options"], outputs: ["mapInitialized", "authFailure", "boundsChanged", "centerChanged", "mapClick", "mapDblclick", "mapDrag", "mapDragend", "mapDragstart", "headingChanged", "idle", "maptypeidChanged", "mapMousemove", "mapMouseout", "mapMouseover", "projectionChanged", "mapRightclick", "tilesloaded", "tiltChanged", "zoomChanged"], exportAs: ["googleMap"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
};
GoogleMapsComponent = __decorate([
    UntilDestroy(),
    __metadata("design:paramtypes", [])
], GoogleMapsComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: GoogleMapsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'helsana-google-maps',
                    standalone: true,
                    imports: [CommonModule, GoogleMapsModule],
                    template: `
    <ng-container *ngIf="googleMapsService.googleMapsApiLoaded$ | async">
      <google-map
        width="100%"
        height="100%"
        [options]="options"
        (mapInitialized)="onMapInitialized($event)"
      >
      </google-map>
    </ng-container>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: () => [], propDecorators: { height: [{
                type: Input
            }], showZoomControl: [{
                type: Input
            }], activateMarkerOnClick: [{
                type: Input
            }], gestureHandling: [{
                type: Input
            }], showAreaSearchButton: [{
                type: Input
            }], isMapOverlayVisible: [{
                type: Input
            }], isDesktop: [{
                type: Input
            }], coordinates: [{
                type: Input
            }], markerClicked: [{
                type: Output
            }], markerHovered: [{
                type: Output
            }], mapClicked: [{
                type: Output
            }], mapUpdated: [{
                type: Output
            }], hostHeight: [{
                type: HostBinding,
                args: ['style.height']
            }] } });

var AVMProduct;
(function (AVMProduct) {
    AVMProduct["Doctor"] = "AVM_x0BEPH_HEL";
    AVMProduct["Flexmed"] = "AVM_x0BEPF_HEL";
})(AVMProduct || (AVMProduct = {}));
const isFlexmed = (product) => product === AVMProduct.Flexmed;
const isDoctor = (product) => product === AVMProduct.Doctor;
const isFlexmedItem = (prodcut) => isFlexmed(prodcut.avmdefId);
const isDoctorItem = (prodcut) => isDoctor(prodcut.avmdefId);
const isAVMDiscount16Item = (prodcut) => {
    return !!avmRabatte[prodcut.netzRabattGv];
};
const isStatusEqual = (provider) => {
    const aufnahme = provider?.aufnahme ||
        provider?.aufnahmeCode;
    return (provider.products?.every((product) => product.aufnahme === aufnahme) ||
        false);
};
const getAcceptPatientCodeByProduct = (provider, product) => {
    return provider.products?.find((item) => item.avmdefId === product)?.aufnahme;
};
const getConcatenatedProducts = ({ products }) => {
    return products
        ?.reduce((curr, product) => isDoctorItem(product)
        ? [
            `${avmProductName[product.avmdefId]} ${avmRabatte[product.netzRabattGv]}`,
            ...curr,
        ]
        : isFlexmedItem(product) && isAVMDiscount16Item(product)
            ? [...curr, `${avmProductName[product.avmdefId]}`]
            : curr, [])
        .join(', ');
};
const avmProductName = {
    AVM_x0BEPH_HEL: 'Hausarzt',
    AVM_x0BEPF_HEL: 'Flexmed',
};
const avmRabatte = {
    16: 'R1',
    14: 'R2',
    12: 'R3',
    10: 'R4',
};

const selectListComponentVm = createSelector(selectSearchState, selectProvidersInViewportByAvm, selectLocationProviders, selectSelectedLocationId, selectIsLocationActive, selectHoveredLocationId, selectLerbFinderMode, selectAvmProduct, selectIsDesktop, (searchState, searchResults, locationProviders, selectedLocationId, isLocationActive, hoveredLocationId, lerbFinderMode, avmProduct, isDesktop) => ({
    searchResults: selectedLocationId ? locationProviders : searchResults,
    isLocationActive: searchState === 'locationSuccess' && isLocationActive,
    hoveredLocationId: selectedLocationId ? null : hoveredLocationId,
    lerbFinderMode,
    avmProduct,
    isDesktop,
}));

class ListComponent {
    constructor() {
        this.store = inject(Store);
        this.getProviderTypeTranslationByFieldNumber = getProviderTypeTranslationByFieldNumber;
        this.getAVMProducts = getConcatenatedProducts;
        this.getAcceptPatientCodeByProduct = getAcceptPatientCodeByProduct;
        this.isStatusEqual = isStatusEqual;
        this.vm$ = this.store.select(selectListComponentVm);
        this.LerbFinderMode = LerbFinderMode;
        this.providerClicked = new EventEmitter();
        this.avmRabatte = avmRabatte;
    }
    isDoctorType(type) {
        return (type === ProviderTypeId.AVM_GROUP ||
            type === ProviderTypeId.AVM_OTHER ||
            type === ProviderTypeId.AVM_PEDIA);
    }
    getCoordinateId(provider) {
        const { lat, lng } = provider;
        return getCoordinateId({ lat, lng });
    }
    calculateDistance(distance) {
        return (distance / 1000).toFixed(1);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: ListComponent, isStandalone: true, selector: "helsana-list", outputs: { providerClicked: "providerClicked" }, ngImport: i0, template: "<ng-container *transloco=\"let t\">\n  <ng-container *rxLet=\"vm$; let vm\">\n    <div\n      *ngFor=\"let provider of vm.searchResults\"\n      class=\"cursor-pointer border-b border-gray-300 p-4\"\n      [ngClass]=\"{\n        'bg-gray-100': vm.hoveredLocationId === getCoordinateId(provider)\n      }\"\n      id=\"provider-{{ provider.id }}\"\n    >\n      <div\n        data-testid=\"lerb-finder-list-select\"\n        class=\"flex justify-between\"\n        (click)=\"providerClicked.emit(provider)\"\n      >\n        <div>\n          <div class=\"t-p-bold mb-2\">\n            {{ provider.vorname }} {{ provider.name }}\n          </div>\n          <div class=\"t-label-normal\">\n            {{ t(getProviderTypeTranslationByFieldNumber(provider.field)) }}\n            <ng-container *ngIf=\"isDoctorType(provider.field)\">\n              <div class=\"flex py-2\">\n                <ng-container\n                  *ngIf=\"\n                    (vm.lerbFinderMode === LerbFinderMode.Provider && isStatusEqual(provider) && (provider?.aufnahme === '1' || provider?.aufnahme === 'Y')) ||\n                    vm.lerbFinderMode === LerbFinderMode.Doctor && (getAcceptPatientCodeByProduct(provider, vm.avmProduct) === '1' || getAcceptPatientCodeByProduct(provider, vm.avmProduct) === 'Y');\n                  then nimmtPatientenAuf, else nachAbspracheMitArzt\"\n                >\n                </ng-container>\n                <ng-template #nimmtPatientenAuf>\n                  <div class=\"mr-8 flex items-center\">\n                    <span class=\"ico--tick ico--24 mr-2\"></span>\n                    {{ t('ListComponent.nimmtPatientenauf') }}\n                  </div>\n                </ng-template>\n                <ng-template #nachAbspracheMitArzt>\n                  <div class=\"flex w-3/4\">\n                    <span class=\"ico--info-serif ico--24 mr-2\"></span>\n                    {{ t('ListComponent.nachAbspracheMitArzt') }}\n                  </div>\n                </ng-template>\n                <ng-container\n                  *ngIf=\"\n                    vm.isLocationActive && provider.distance && vm.isDesktop\n                  \"\n                >\n                  <div class=\"flex\">\n                    <span class=\"ico--distance ico--24\"></span>\n                    {{ calculateDistance(provider.distance) }} km\n                  </div>\n                </ng-container>\n              </div>\n              <ng-container *ngIf=\"provider.products?.length\">\n                <div class=\"flex items-center py-2\">\n                  <span class=\"ico--stetoskop ico--24 mr-2\"></span>\n                  {{\n                    t('ListComponent.produkte') +\n                      ': ' +\n                      getAVMProducts(provider)\n                  }}\n                </div>\n              </ng-container>\n            </ng-container>\n          </div>\n        </div>\n        <div class=\"flex\">\n          <ng-container *ngIf=\"!vm.isDesktop || !isDoctorType(provider.field)\">\n            <div\n              class=\"mr-4 flex self-end\"\n              *ngIf=\"vm.isLocationActive && provider.distance\"\n              [ngClass]=\"{\n                'self-end': !isDoctorType(provider.field),\n                'self-center': isDoctorType(provider.field)\n              }\"\n            >\n              <span class=\"ico--distance ico--24\"></span>\n              <span class=\"t-label-normal self-end\"\n                >{{ calculateDistance(provider.distance) }} km</span\n              >\n            </div>\n          </ng-container>\n          <div class=\"self-center\">\n            <div class=\"ico--chevron-right ico--24\"></div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </ng-container>\n</ng-container>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i2.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "ngmodule", type: LetModule }, { kind: "directive", type: i3.LetDirective, selector: "[rxLet]", inputs: ["rxLet", "rxLetStrategy", "rxLetComplete", "rxLetError", "rxLetSuspense", "rxLetContextTrigger", "rxLetCompleteTrigger", "rxLetErrorTrigger", "rxLetSuspenseTrigger", "rxLetNextTrigger", "rxLetRenderCallback", "rxLetParent", "rxLetPatchZone"], outputs: ["rendered"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'helsana-list', standalone: true, imports: [CommonModule, TranslocoModule, LetModule], changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *transloco=\"let t\">\n  <ng-container *rxLet=\"vm$; let vm\">\n    <div\n      *ngFor=\"let provider of vm.searchResults\"\n      class=\"cursor-pointer border-b border-gray-300 p-4\"\n      [ngClass]=\"{\n        'bg-gray-100': vm.hoveredLocationId === getCoordinateId(provider)\n      }\"\n      id=\"provider-{{ provider.id }}\"\n    >\n      <div\n        data-testid=\"lerb-finder-list-select\"\n        class=\"flex justify-between\"\n        (click)=\"providerClicked.emit(provider)\"\n      >\n        <div>\n          <div class=\"t-p-bold mb-2\">\n            {{ provider.vorname }} {{ provider.name }}\n          </div>\n          <div class=\"t-label-normal\">\n            {{ t(getProviderTypeTranslationByFieldNumber(provider.field)) }}\n            <ng-container *ngIf=\"isDoctorType(provider.field)\">\n              <div class=\"flex py-2\">\n                <ng-container\n                  *ngIf=\"\n                    (vm.lerbFinderMode === LerbFinderMode.Provider && isStatusEqual(provider) && (provider?.aufnahme === '1' || provider?.aufnahme === 'Y')) ||\n                    vm.lerbFinderMode === LerbFinderMode.Doctor && (getAcceptPatientCodeByProduct(provider, vm.avmProduct) === '1' || getAcceptPatientCodeByProduct(provider, vm.avmProduct) === 'Y');\n                  then nimmtPatientenAuf, else nachAbspracheMitArzt\"\n                >\n                </ng-container>\n                <ng-template #nimmtPatientenAuf>\n                  <div class=\"mr-8 flex items-center\">\n                    <span class=\"ico--tick ico--24 mr-2\"></span>\n                    {{ t('ListComponent.nimmtPatientenauf') }}\n                  </div>\n                </ng-template>\n                <ng-template #nachAbspracheMitArzt>\n                  <div class=\"flex w-3/4\">\n                    <span class=\"ico--info-serif ico--24 mr-2\"></span>\n                    {{ t('ListComponent.nachAbspracheMitArzt') }}\n                  </div>\n                </ng-template>\n                <ng-container\n                  *ngIf=\"\n                    vm.isLocationActive && provider.distance && vm.isDesktop\n                  \"\n                >\n                  <div class=\"flex\">\n                    <span class=\"ico--distance ico--24\"></span>\n                    {{ calculateDistance(provider.distance) }} km\n                  </div>\n                </ng-container>\n              </div>\n              <ng-container *ngIf=\"provider.products?.length\">\n                <div class=\"flex items-center py-2\">\n                  <span class=\"ico--stetoskop ico--24 mr-2\"></span>\n                  {{\n                    t('ListComponent.produkte') +\n                      ': ' +\n                      getAVMProducts(provider)\n                  }}\n                </div>\n              </ng-container>\n            </ng-container>\n          </div>\n        </div>\n        <div class=\"flex\">\n          <ng-container *ngIf=\"!vm.isDesktop || !isDoctorType(provider.field)\">\n            <div\n              class=\"mr-4 flex self-end\"\n              *ngIf=\"vm.isLocationActive && provider.distance\"\n              [ngClass]=\"{\n                'self-end': !isDoctorType(provider.field),\n                'self-center': isDoctorType(provider.field)\n              }\"\n            >\n              <span class=\"ico--distance ico--24\"></span>\n              <span class=\"t-label-normal self-end\"\n                >{{ calculateDistance(provider.distance) }} km</span\n              >\n            </div>\n          </ng-container>\n          <div class=\"self-center\">\n            <div class=\"ico--chevron-right ico--24\"></div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </ng-container>\n</ng-container>\n" }]
        }], propDecorators: { providerClicked: [{
                type: Output
            }] } });

const selectDetailCoordinates = createSelector(selectDetailsProvider, selectLerbFinderMode, selectIsLocationActive, selectLocation, selectSearchState, (detailsProvider, lerbFinderMode, isLocationActiv, currentUserLocation, searchState) => {
    const isCurrentUserLocationChoosed = searchState === 'locationSuccess' &&
        isLocationActiv &&
        currentUserLocation;
    const detailsMapMarker = {
        type: lerbFinderMode === LerbFinderMode.Doctor
            ? ProviderType.AVM_GROUP
            : detailsProvider?.typ,
        lat: detailsProvider?.lat,
        lng: detailsProvider?.lng,
    }; // TODO Malvin no as cast
    return isCurrentUserLocationChoosed
        ? [
            {
                // TODO Thilo: change type to ProviderListType.USER_LOCATION (?)
                type: ProviderType.EMR,
                isUserLocation: isLocationActiv,
                ...currentUserLocation,
            },
            { ...detailsMapMarker },
        ]
        : [detailsMapMarker];
});
const selectDetailsDistance = createSelector(selectDetailsProvider, selectIsLocationActive, selectLocation, (detailsProvider, isCurrentUserLocationActiv, currentUserLocation) => isCurrentUserLocationActiv && currentUserLocation && detailsProvider
    ? computeDistanceBetween(currentUserLocation, detailsProvider)
    : null);
const selectExpertise = createSelector(selectExpertiseGroups, (expertiseGroups) => {
    const expertise = [];
    if (!expertiseGroups) {
        return expertise;
    }
    Object.keys(expertiseGroups).forEach((key) => {
        const sortedExpertise = [...expertiseGroups[key]];
        sortedExpertise.forEach((expertiseItem, index) => {
            if (sortedExpertise.findIndex((item) => item.text === expertiseItem.text) === index) {
                expertise.push(expertiseItem);
            }
        });
    });
    expertise.sort((a, b) => a.text.localeCompare(b.text));
    return expertise;
});
const selectDetailsComponentVm = createSelector(selectSearchState, selectDetailsProvider, selectOpenToolTip, selectExpertise, selectSelectedLocationId, selectDetailsDistance, selectDetailCoordinates, selectIsLocationActive, selectDetailsBackToken, selectLerbFinderMode, selectAvmProduct, selectIsDesktop, selectSelectedLocationId, selectIsOverlayMode, (searchState, detailsProvider, openToolTip, expertise, locationId, detailDistance, detailCoordinates, isLocationActiv, backToken, lerbFinderMode, avmProduct, isDesktop, selectedLocationId, isOverlayMode) => ({
    detailsProvider,
    openToolTip,
    expertise,
    hasCloseButton: !locationId,
    detailDistance,
    detailCoordinates,
    isCurrentUserLocationActiv: searchState === 'locationSuccess' && isLocationActiv,
    backToken,
    lerbFinderMode,
    avmProduct,
    isDesktop,
    selectedLocationId,
    isProviderSelectedViaInput: searchState === 'providerSelectedViaInput',
    isDetailsViewClickedOnDesktop: searchState === 'zipSuccess' && !!detailsProvider && isDesktop,
    isOverlayMode,
}));

const selectToolTipComponentVm = createSelector(selectOpenToolTip, (openToolTip) => ({
    openToolTip,
}));

class ToolTipComponent {
    constructor() {
        this.store = inject(Store);
        this.vm$ = this.store.select(selectToolTipComponentVm);
    }
    handleClicked() {
        this.store.dispatch(closeButtonClicked());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ToolTipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: ToolTipComponent, isStandalone: true, selector: "helsana-tool-tip", ngImport: i0, template: `
    <ng-container *rxLet="vm$; let vm">
      <div
        *transloco="let t"
        class="absolute -top-10 z-30 ml-5 opacity-0 transition-opacity "
        [ngClass]="{ 'opacity-100': vm.openToolTip }"
      >
        <span class="tool-tip__wrapper">
          <span class="tool-tip t-label-small flex bg-white py-3 pl-6 pr-2">
            {{ t('ToolTipComponent.toolTip') }}
            <span
              (click)="handleClicked()"
              class="ico--close ico--12 cursor-pointer"
            ></span>
          </span>
        </span>
      </div>
    </ng-container>
  `, isInline: true, styles: [".tool-tip{max-width:300px;-webkit-clip-path:polygon(5% 35%,5% 0,100% 0,100% 100%,5% 100%,5% 65%,0 50%);clip-path:polygon(5% 35%,5% 0,100% 0,100% 100%,5% 100%,5% 65%,0 50%)}.tool-tip__wrapper{filter:drop-shadow(-1px 6px 3px rgba(50,50,0,.5))}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i2.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "ngmodule", type: LetModule }, { kind: "directive", type: i3.LetDirective, selector: "[rxLet]", inputs: ["rxLet", "rxLetStrategy", "rxLetComplete", "rxLetError", "rxLetSuspense", "rxLetContextTrigger", "rxLetCompleteTrigger", "rxLetErrorTrigger", "rxLetSuspenseTrigger", "rxLetNextTrigger", "rxLetRenderCallback", "rxLetParent", "rxLetPatchZone"], outputs: ["rendered"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ToolTipComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'helsana-tool-tip', imports: [CommonModule, TranslocoModule, LetModule], template: `
    <ng-container *rxLet="vm$; let vm">
      <div
        *transloco="let t"
        class="absolute -top-10 z-30 ml-5 opacity-0 transition-opacity "
        [ngClass]="{ 'opacity-100': vm.openToolTip }"
      >
        <span class="tool-tip__wrapper">
          <span class="tool-tip t-label-small flex bg-white py-3 pl-6 pr-2">
            {{ t('ToolTipComponent.toolTip') }}
            <span
              (click)="handleClicked()"
              class="ico--close ico--12 cursor-pointer"
            ></span>
          </span>
        </span>
      </div>
    </ng-container>
  `, encapsulation: ViewEncapsulation.None, styles: [".tool-tip{max-width:300px;-webkit-clip-path:polygon(5% 35%,5% 0,100% 0,100% 100%,5% 100%,5% 65%,0 50%);clip-path:polygon(5% 35%,5% 0,100% 0,100% 100%,5% 100%,5% 65%,0 50%)}.tool-tip__wrapper{filter:drop-shadow(-1px 6px 3px rgba(50,50,0,.5))}\n"] }]
        }] });

var ScrollingClickEvent;
(function (ScrollingClickEvent) {
    ScrollingClickEvent["AdjustSearchButtonClickedEvent"] = "AdjustSearchButtonClickedEvent";
    ScrollingClickEvent["SearchButtonClickedEvent"] = "SearchButtonClickedEvent";
    ScrollingClickEvent["DetailsComponentInitEvent"] = "DetailsComponentInitEvent";
    ScrollingClickEvent["MobileOverlayBackClickedEvent"] = "MobileOverlayBackClickedEvent";
})(ScrollingClickEvent || (ScrollingClickEvent = {}));

let DetailsViewComponent = class DetailsViewComponent {
    constructor() {
        this.store = inject(Store);
        this.scrollingService = inject(ScrollingService);
        this.hausarztResults = 'hausarzt-results';
        this.mapHeightDesktop = mapHeightDesktop;
        this.listWidthDesktop = listWidthDesktop;
        this.getProviderTypeTranslationByFieldName = getProviderTypeTranslationByFieldName;
        this.getAVMProducts = getConcatenatedProducts;
        this.isStatusEqual = isStatusEqual;
        this.getAcceptPatientCodeByProduct = getAcceptPatientCodeByProduct;
        this.vm$ = this.store.select(selectDetailsComponentVm);
        this.LerbFinderMode = LerbFinderMode;
        this.avmRabatte = avmRabatte;
        this.ContactType = ContactType;
        this.ProviderType = ProviderType;
        this.isProviderSelectedViaInput = false;
        this.isDetailsViewClickedOnDesktop = false;
        this.isDesktop = true;
    }
    async ngOnInit() {
        this.vm$
            .pipe(untilDestroyed(this), tap((vm) => {
            this.isProviderSelectedViaInput = vm.isProviderSelectedViaInput;
            this.isDetailsViewClickedOnDesktop = vm.isDetailsViewClickedOnDesktop;
            this.isDesktop = vm.isDesktop;
        }))
            .subscribe();
        this.store.dispatch(onInit$3({
            isProviderSelectedViaInput: this.isProviderSelectedViaInput && !this.isDetailsViewClickedOnDesktop,
        }));
        //For  AEM Overlay
        const element = await this.scrollingService.isElementLoaded(this.hausarztResults);
        const isTrigger = this.isDesktop && this.isProviderSelectedViaInput && element;
        if (isTrigger) {
            this.scrollingService.setScrollEvent(ScrollingClickEvent.DetailsComponentInitEvent, element);
        }
    }
    async closeButtonClicked() {
        this.store.dispatch(backClicked$1());
        await this.handleBackClicked();
    }
    async backClicked() {
        this.store.dispatch(backClicked$1());
        await this.handleBackClicked();
    }
    chooseProviderContacted(contactType) {
        this.store.dispatch(chooseProviderContacted({ contactType }));
    }
    chooseProviderClicked() {
        this.store.dispatch(chooseProviderClicked());
    }
    openGoogleMaps(provider) {
        this.store.dispatch(openGoogleMapsClicked$1({ provider }));
        this.store.dispatch(chooseProviderContacted({
            contactType: ContactType.MAP,
        }));
    }
    openToolTip(isOpen) {
        this.store.dispatch(toolTipClicked({ isOpen }));
    }
    isScrollable(id) {
        const element = document.getElementById(id);
        return element && element.scrollHeight > element.clientHeight;
    }
    calculteDistance(distance) {
        return (distance / 1000).toFixed(1);
    }
    appendProtocolToUrl(url) {
        const protocolPattern = /^(https?|http):\/\//i;
        if (!protocolPattern.test(url)) {
            url = 'https://' + url;
        }
        return url;
    }
    removeBrackets(value = '') {
        return value.replace(/(\(\d*\))/g, '');
    }
    getIcon(fieldType) {
        if (fieldType === ProviderType.KUR) {
            return 'ico--kursleiter';
        }
        return 'ico--leaf';
    }
    /**
     * @description pass element to scroll to parent wrapper to allow scrolling
     * in case angular app is placed in an overlay
     */
    async handleBackClicked() {
        const isMobile = !this.isDesktop;
        const element = await this.scrollingService.isElementLoaded(this.hausarztResults);
        if (element && isMobile) {
            this.scrollingService.setScrollEvent(ScrollingClickEvent.MobileOverlayBackClickedEvent, element);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: DetailsViewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: DetailsViewComponent, isStandalone: true, selector: "helsana-details-view", ngImport: i0, template: "<ng-container *transloco=\"let t\">\n  <ng-container *rxLet=\"vm$; let vm\">\n    <!--MOBILE-->\n    <ng-container *ngIf=\"!vm.isDesktop && vm.detailsProvider as provider\">\n      <div\n        [ngClass]=\"{\n        'fixed bottom-0 left-0 right-0 top-0 z-[999] w-full overflow-x-auto bg-white': vm.lerbFinderMode === LerbFinderMode.Provider,\n      }\"\n      >\n        <div class=\"mb-2 p-4\">\n          <div\n            class=\"flex\"\n            [ngClass]=\"{\n              'justify-end': vm.hasCloseButton,\n              'justify-between':\n                vm.lerbFinderMode === LerbFinderMode.Doctor ||\n                !vm.hasCloseButton\n            }\"\n          >\n            <a\n              class=\"link-back\"\n              (click)=\"backClicked()\"\n              *ngIf=\"\n                vm.lerbFinderMode === LerbFinderMode.Doctor ||\n                (vm.backToken && !vm.hasCloseButton)\n              \"\n            >\n              {{ t(vm.backToken) }}\n            </a>\n            <button\n              *ngIf=\"\n                vm.lerbFinderMode === LerbFinderMode.Provider &&\n                vm.hasCloseButton\n              \"\n              class=\"close-x\"\n              (click)=\"closeButtonClicked()\"\n            >\n              <div class=\"ico--close ico--20\"></div>\n            </button>\n          </div>\n          <ng-container\n            [ngTemplateOutlet]=\"nameAndType\"\n            [ngTemplateOutletContext]=\"{ provider: provider }\"\n          ></ng-container>\n        </div>\n        <ng-container\n          [ngTemplateOutlet]=\"mapWithButton\"\n          [ngTemplateOutletContext]=\"{ provider: provider }\"\n        ></ng-container>\n        <ng-container\n          [ngTemplateOutlet]=\"details\"\n          [ngTemplateOutletContext]=\"{ provider: provider }\"\n        ></ng-container>\n        <ng-container\n          *ngIf=\"!vm.isDesktop\"\n          [ngTemplateOutlet]=\"button\"\n        ></ng-container>\n      </div>\n    </ng-container>\n\n    <!--DESKTOP-->\n    <div\n      *ngIf=\"vm.isDesktop && vm.detailsProvider as provider\"\n      class=\"provider-details-desktop flex pb-4\"\n    >\n      <div\n        id=\"hausarzt-details-scrollable\"\n        class=\"overflow-auto\"\n        [style.height]=\"mapHeightDesktop\"\n        [style.min-width]=\"listWidthDesktop\"\n        [style.max-width]=\"listWidthDesktop\"\n      >\n        <ng-container\n          [ngTemplateOutlet]=\"nameAndType\"\n          [ngTemplateOutletContext]=\"{ provider: provider }\"\n        ></ng-container>\n        <ng-container\n          [ngTemplateOutlet]=\"details\"\n          [ngTemplateOutletContext]=\"{ provider: provider }\"\n        ></ng-container>\n        <ng-container\n          *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Doctor\"\n          [ngTemplateOutlet]=\"button\"\n        ></ng-container>\n      </div>\n      <div class=\"w-full\">\n        <ng-container\n          [ngTemplateOutlet]=\"mapWithButton\"\n          [ngTemplateOutletContext]=\"{ provider: provider }\"\n        ></ng-container>\n      </div>\n    </div>\n\n    <!--TEMPLATES-->\n    <ng-template #nameAndType let-provider=\"provider\">\n      <h2 class=\"t-h2 lg:t-h4 mt-8 lg:ml-[51px]\">\n        {{ provider.vorname }} {{ provider.name }}\n      </h2>\n      <div class=\"lg:ml-[51px]\">\n        {{ t(getProviderTypeTranslationByFieldName(provider.typ)) }}\n      </div>\n    </ng-template>\n    <ng-template #mapWithButton let-provider=\"provider\">\n      <div class=\"relative\">\n        <helsana-google-maps\n          [height]=\"vm.isDesktop ? mapHeightDesktop : '220px'\"\n          [coordinates]=\"vm.detailCoordinates\"\n          [showZoomControl]=\"vm.isDesktop\"\n          [gestureHandling]=\"false\"\n        ></helsana-google-maps>\n        <div class=\"absolute left-4 top-4\" *ngIf=\"vm.isDesktop\">\n          <button\n            data-testid=\"lerb-finder-details-openGoogleMaps\"\n            class=\"btn black\"\n            (click)=\"openGoogleMaps(provider)\"\n          >\n            <span class=\"ico--link-external ico--24 mr-3\"></span>\n            {{ t('DetailsComponent.openGoogleMaps') }}\n          </button>\n        </div>\n        <div class=\"absolute bottom-4 w-full p-4\" *ngIf=\"!vm.isDesktop\">\n          <button\n            data-testid=\"lerb-finder-details-openGoogleMaps\"\n            class=\"btn black\"\n            (click)=\"openGoogleMaps(provider)\"\n          >\n            <span class=\"ico--link-external ico--24 mr-3\"></span>\n            {{ t('DetailsComponent.openGoogleMaps') }}\n          </button>\n        </div>\n      </div>\n    </ng-template>\n\n    <ng-template #details let-provider=\"provider\">\n      <div class=\"details-with-icons\">\n        <div class=\"border-b border-gray-200 p-4 lg:mt-4\">\n          <div class=\"flex justify-between\">\n            <div class=\"flex\">\n              <span class=\"ico--location ico--28\"></span>\n              <div>\n                <p>{{ provider.strasse }}</p>\n                <p>{{ provider.plz }} {{ provider.ort }}</p>\n              </div>\n            </div>\n            <!-- Distance -->\n            <div *ngIf=\"vm.isCurrentUserLocationActiv\" class=\"flex\">\n              <span class=\"ico--distance ico--24 ml-2\"></span>\n              {{ vm.detailDistance?.toFixed(1) }} km\n            </div>\n          </div>\n          <!-- Phone  -->\n          <ng-container *ngIf=\"provider.telefon || provider.mobile\">\n            <p class=\"mb-2 mt-4 flex\">\n              <span class=\"ico--phone ico--28\"></span>\n              <a\n                (click)=\"chooseProviderContacted(ContactType.PHONE)\"\n                class=\"underline\"\n                href=\"tel:{{ provider.telefon || provider.mobile }}\"\n                >{{ provider.telefon || provider.mobile }}</a\n              >\n            </p>\n          </ng-container>\n          <!-- Email -->\n          <ng-container\n            *ngIf=\"\n              vm.lerbFinderMode === LerbFinderMode.Provider &&\n              provider.email\n            \"\n          >\n            <p class=\"mb-2 mt-4 flex\">\n              <span class=\"ico--mail ico--28\"></span>\n              <a\n                (click)=\"chooseProviderContacted(ContactType.MAIL)\"\n                class=\"underline\"\n                href=\"mailto:{{ provider.email }}\"\n                >{{ provider.email }}</a\n              >\n            </p>\n          </ng-container>\n          <!-- Website  -->\n          <ng-container\n            *ngIf=\"\n              vm.lerbFinderMode === LerbFinderMode.Provider &&\n              provider.website\n            \"\n          >\n            <p class=\"mb-2 mt-4 flex\">\n              <span class=\"ico--ausland ico--28\"></span>\n              <a\n                (click)=\"chooseProviderContacted(ContactType.WEBSITE)\"\n                target=\"_blank\"\n                rel=\"noopener\"\n                class=\"underline\"\n                href=\"{{ appendProtocolToUrl(provider.website) }}\"\n                >{{ appendProtocolToUrl(provider.website) }}</a\n              >\n            </p>\n          </ng-container>\n          <!-- Methods  -->\n          <ng-container\n            *ngIf=\"\n              vm.lerbFinderMode === LerbFinderMode.Provider &&\n              vm.expertise &&\n              vm.expertise.length > 0\n            \"\n          >\n            <div\n              class=\"mb-2 mt-4\"\n            >\n              <p class=\"t-p-bold flex\">\n                <span class=\"ico--28\" [ngClass]=\"getIcon(provider.typ)\"></span>\n                {{ t('DetailsComponent.methoden') }}\n              </p>\n              <div class=\"mt-4 pl-9\">\n                <ul class=\"flex list-disc flex-col\">\n                  <li *ngFor=\"let method of vm.expertise\">\n                    {{ removeBrackets(method.text) }}\n                  </li>\n                </ul>\n              </div>\n            </div>\n          </ng-container>\n        </div>\n\n        <div class=\"border-b border-gray-200 p-4\"  *ngIf=\"provider.typ === ProviderType.AVM_PEDIA || provider.typ === ProviderType.AVM_GROUP || provider.typ === ProviderType.AVM_OTHER\">\n          <!-- Status  -->\n          <ng-container\n            *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Provider && provider.aufnahmeCode === '1' && isStatusEqual(provider) ||\n            vm.lerbFinderMode === LerbFinderMode.Doctor && getAcceptPatientCodeByProduct(provider, vm.avmProduct) === '1';\n            then nimmtPatientenAuf, else nachAbspracheMitArzt\"\n          >\n          </ng-container>\n          <ng-template #nimmtPatientenAuf>\n            <p class=\"flex py-2\">\n              <span class=\"ico--tick ico--24\"></span>\n              {{ t('DetailsComponent.nimmtPatientenauf') }}\n            </p>\n          </ng-template>\n          <ng-template #nachAbspracheMitArzt>\n            <p class=\"flex py-2\">\n              <span class=\"ico--info-serif ico--24\"></span>\n              {{ t('DetailsComponent.nachAbspracheMitArzt') }}\n            </p>\n          </ng-template>\n          <!-- Products  -->\n          <ng-container *ngIf=\"provider.products?.length\">\n            <div class=\"my-2 flex\">\n              <span class=\"ico--stetoskop ico--24 mr-2\"></span>\n              <div class=\"flex w-full flex-col\">\n                <div class=\"flex items-center\">\n                  <div class=\"t-p-bold mr-2 min-w-fit\">\n                    {{ t('DetailsComponent.produkt') }}\n                  </div>\n                  <div class=\"group relative flex w-full flex-col\">\n                    <span\n                      (click)=\"openToolTip(!vm.openToolTip)\"\n                      class=\"ico--info ico--18 mr-2 cursor-pointer text-gray-400\"\n                    ></span>\n                    <helsana-tool-tip />\n                  </div>\n                </div>\n                <span class=\"t-label-normal\">{{\n                  getAVMProducts(provider)\n                }}</span>\n              </div>\n            </div>\n          </ng-container>\n          <!-- netzWwwHomepage -->\n          <ng-container *ngIf=\"provider.netzWwwHomepage\">\n            <div class=\"my-2 flex\">\n              <span class=\"ico--rabatt ico--24\"></span>\n              <div>\n                <p class=\"t-p-bold\">\n                  {{ t('DetailsComponent.netzwerk') }}\n                </p>\n                <p>{{ provider.netzName }}</p>\n                <p>{{ provider.netzWwwHomepage }}</p>\n              </div>\n            </div>\n          </ng-container>\n          <!-- avmVertrag -->\n          <div >\n            <p class=\"flex py-2\">\n              <span class=\"ico--info-serif ico--24\"></span>\n              <span class=\"t-label-normal\">{{\n                t('DetailsComponent.avmVertrag')\n              }}</span>\n            </p>\n          </div>\n        </div>\n      </div>\n    </ng-template>\n\n    <ng-template #button>\n      <div\n        class=\"sticky bottom-0 z-30 w-full bg-white p-4\"\n        [ngClass]=\"{\n          'nova-shadow-top border-t  border-gray-200': isScrollable(\n            vm.isDesktop ? 'hausarzt-details-scrollable' : 'overlay-scrollable'\n          )\n        }\"\n      >\n        <button\n          *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Doctor && vm.isOverlayMode\"\n          class=\"btn primary md:w-full\"\n          (click)=\"chooseProviderClicked()\"\n        >\n          {{ t('DetailsComponent.hausarztAuswaehlen') }}\n        </button>\n        <button\n          *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Provider\"\n          class=\"btn primary md:w-full\"\n          (click)=\"closeButtonClicked()\"\n        >\n          {{\n            vm.selectedLocationId\n              ? t('DetailsComponent.zurueck')\n              : t('DetailsComponent.schliessen')\n          }}\n        </button>\n      </div>\n    </ng-template>\n  </ng-container>\n</ng-container>\n", styles: [".details-with-icons span[class^=ico--]{margin-right:8px}.provider-details-desktop{font-family:AkkuratHelsanaTT Regular Web,Helvetica,Arial,sans-serif}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: GoogleMapsComponent, selector: "helsana-google-maps", inputs: ["height", "showZoomControl", "activateMarkerOnClick", "gestureHandling", "showAreaSearchButton", "isMapOverlayVisible", "isDesktop", "coordinates"], outputs: ["markerClicked", "markerHovered", "mapClicked", "mapUpdated"] }, { kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i2.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "ngmodule", type: LetModule }, { kind: "directive", type: i3.LetDirective, selector: "[rxLet]", inputs: ["rxLet", "rxLetStrategy", "rxLetComplete", "rxLetError", "rxLetSuspense", "rxLetContextTrigger", "rxLetCompleteTrigger", "rxLetErrorTrigger", "rxLetSuspenseTrigger", "rxLetNextTrigger", "rxLetRenderCallback", "rxLetParent", "rxLetPatchZone"], outputs: ["rendered"] }, { kind: "component", type: ToolTipComponent, selector: "helsana-tool-tip" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
};
DetailsViewComponent = __decorate([
    UntilDestroy()
], DetailsViewComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: DetailsViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'helsana-details-view', standalone: true, imports: [
                        CommonModule,
                        GoogleMapsComponent,
                        TranslocoModule,
                        LetModule,
                        ToolTipComponent,
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *transloco=\"let t\">\n  <ng-container *rxLet=\"vm$; let vm\">\n    <!--MOBILE-->\n    <ng-container *ngIf=\"!vm.isDesktop && vm.detailsProvider as provider\">\n      <div\n        [ngClass]=\"{\n        'fixed bottom-0 left-0 right-0 top-0 z-[999] w-full overflow-x-auto bg-white': vm.lerbFinderMode === LerbFinderMode.Provider,\n      }\"\n      >\n        <div class=\"mb-2 p-4\">\n          <div\n            class=\"flex\"\n            [ngClass]=\"{\n              'justify-end': vm.hasCloseButton,\n              'justify-between':\n                vm.lerbFinderMode === LerbFinderMode.Doctor ||\n                !vm.hasCloseButton\n            }\"\n          >\n            <a\n              class=\"link-back\"\n              (click)=\"backClicked()\"\n              *ngIf=\"\n                vm.lerbFinderMode === LerbFinderMode.Doctor ||\n                (vm.backToken && !vm.hasCloseButton)\n              \"\n            >\n              {{ t(vm.backToken) }}\n            </a>\n            <button\n              *ngIf=\"\n                vm.lerbFinderMode === LerbFinderMode.Provider &&\n                vm.hasCloseButton\n              \"\n              class=\"close-x\"\n              (click)=\"closeButtonClicked()\"\n            >\n              <div class=\"ico--close ico--20\"></div>\n            </button>\n          </div>\n          <ng-container\n            [ngTemplateOutlet]=\"nameAndType\"\n            [ngTemplateOutletContext]=\"{ provider: provider }\"\n          ></ng-container>\n        </div>\n        <ng-container\n          [ngTemplateOutlet]=\"mapWithButton\"\n          [ngTemplateOutletContext]=\"{ provider: provider }\"\n        ></ng-container>\n        <ng-container\n          [ngTemplateOutlet]=\"details\"\n          [ngTemplateOutletContext]=\"{ provider: provider }\"\n        ></ng-container>\n        <ng-container\n          *ngIf=\"!vm.isDesktop\"\n          [ngTemplateOutlet]=\"button\"\n        ></ng-container>\n      </div>\n    </ng-container>\n\n    <!--DESKTOP-->\n    <div\n      *ngIf=\"vm.isDesktop && vm.detailsProvider as provider\"\n      class=\"provider-details-desktop flex pb-4\"\n    >\n      <div\n        id=\"hausarzt-details-scrollable\"\n        class=\"overflow-auto\"\n        [style.height]=\"mapHeightDesktop\"\n        [style.min-width]=\"listWidthDesktop\"\n        [style.max-width]=\"listWidthDesktop\"\n      >\n        <ng-container\n          [ngTemplateOutlet]=\"nameAndType\"\n          [ngTemplateOutletContext]=\"{ provider: provider }\"\n        ></ng-container>\n        <ng-container\n          [ngTemplateOutlet]=\"details\"\n          [ngTemplateOutletContext]=\"{ provider: provider }\"\n        ></ng-container>\n        <ng-container\n          *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Doctor\"\n          [ngTemplateOutlet]=\"button\"\n        ></ng-container>\n      </div>\n      <div class=\"w-full\">\n        <ng-container\n          [ngTemplateOutlet]=\"mapWithButton\"\n          [ngTemplateOutletContext]=\"{ provider: provider }\"\n        ></ng-container>\n      </div>\n    </div>\n\n    <!--TEMPLATES-->\n    <ng-template #nameAndType let-provider=\"provider\">\n      <h2 class=\"t-h2 lg:t-h4 mt-8 lg:ml-[51px]\">\n        {{ provider.vorname }} {{ provider.name }}\n      </h2>\n      <div class=\"lg:ml-[51px]\">\n        {{ t(getProviderTypeTranslationByFieldName(provider.typ)) }}\n      </div>\n    </ng-template>\n    <ng-template #mapWithButton let-provider=\"provider\">\n      <div class=\"relative\">\n        <helsana-google-maps\n          [height]=\"vm.isDesktop ? mapHeightDesktop : '220px'\"\n          [coordinates]=\"vm.detailCoordinates\"\n          [showZoomControl]=\"vm.isDesktop\"\n          [gestureHandling]=\"false\"\n        ></helsana-google-maps>\n        <div class=\"absolute left-4 top-4\" *ngIf=\"vm.isDesktop\">\n          <button\n            data-testid=\"lerb-finder-details-openGoogleMaps\"\n            class=\"btn black\"\n            (click)=\"openGoogleMaps(provider)\"\n          >\n            <span class=\"ico--link-external ico--24 mr-3\"></span>\n            {{ t('DetailsComponent.openGoogleMaps') }}\n          </button>\n        </div>\n        <div class=\"absolute bottom-4 w-full p-4\" *ngIf=\"!vm.isDesktop\">\n          <button\n            data-testid=\"lerb-finder-details-openGoogleMaps\"\n            class=\"btn black\"\n            (click)=\"openGoogleMaps(provider)\"\n          >\n            <span class=\"ico--link-external ico--24 mr-3\"></span>\n            {{ t('DetailsComponent.openGoogleMaps') }}\n          </button>\n        </div>\n      </div>\n    </ng-template>\n\n    <ng-template #details let-provider=\"provider\">\n      <div class=\"details-with-icons\">\n        <div class=\"border-b border-gray-200 p-4 lg:mt-4\">\n          <div class=\"flex justify-between\">\n            <div class=\"flex\">\n              <span class=\"ico--location ico--28\"></span>\n              <div>\n                <p>{{ provider.strasse }}</p>\n                <p>{{ provider.plz }} {{ provider.ort }}</p>\n              </div>\n            </div>\n            <!-- Distance -->\n            <div *ngIf=\"vm.isCurrentUserLocationActiv\" class=\"flex\">\n              <span class=\"ico--distance ico--24 ml-2\"></span>\n              {{ vm.detailDistance?.toFixed(1) }} km\n            </div>\n          </div>\n          <!-- Phone  -->\n          <ng-container *ngIf=\"provider.telefon || provider.mobile\">\n            <p class=\"mb-2 mt-4 flex\">\n              <span class=\"ico--phone ico--28\"></span>\n              <a\n                (click)=\"chooseProviderContacted(ContactType.PHONE)\"\n                class=\"underline\"\n                href=\"tel:{{ provider.telefon || provider.mobile }}\"\n                >{{ provider.telefon || provider.mobile }}</a\n              >\n            </p>\n          </ng-container>\n          <!-- Email -->\n          <ng-container\n            *ngIf=\"\n              vm.lerbFinderMode === LerbFinderMode.Provider &&\n              provider.email\n            \"\n          >\n            <p class=\"mb-2 mt-4 flex\">\n              <span class=\"ico--mail ico--28\"></span>\n              <a\n                (click)=\"chooseProviderContacted(ContactType.MAIL)\"\n                class=\"underline\"\n                href=\"mailto:{{ provider.email }}\"\n                >{{ provider.email }}</a\n              >\n            </p>\n          </ng-container>\n          <!-- Website  -->\n          <ng-container\n            *ngIf=\"\n              vm.lerbFinderMode === LerbFinderMode.Provider &&\n              provider.website\n            \"\n          >\n            <p class=\"mb-2 mt-4 flex\">\n              <span class=\"ico--ausland ico--28\"></span>\n              <a\n                (click)=\"chooseProviderContacted(ContactType.WEBSITE)\"\n                target=\"_blank\"\n                rel=\"noopener\"\n                class=\"underline\"\n                href=\"{{ appendProtocolToUrl(provider.website) }}\"\n                >{{ appendProtocolToUrl(provider.website) }}</a\n              >\n            </p>\n          </ng-container>\n          <!-- Methods  -->\n          <ng-container\n            *ngIf=\"\n              vm.lerbFinderMode === LerbFinderMode.Provider &&\n              vm.expertise &&\n              vm.expertise.length > 0\n            \"\n          >\n            <div\n              class=\"mb-2 mt-4\"\n            >\n              <p class=\"t-p-bold flex\">\n                <span class=\"ico--28\" [ngClass]=\"getIcon(provider.typ)\"></span>\n                {{ t('DetailsComponent.methoden') }}\n              </p>\n              <div class=\"mt-4 pl-9\">\n                <ul class=\"flex list-disc flex-col\">\n                  <li *ngFor=\"let method of vm.expertise\">\n                    {{ removeBrackets(method.text) }}\n                  </li>\n                </ul>\n              </div>\n            </div>\n          </ng-container>\n        </div>\n\n        <div class=\"border-b border-gray-200 p-4\"  *ngIf=\"provider.typ === ProviderType.AVM_PEDIA || provider.typ === ProviderType.AVM_GROUP || provider.typ === ProviderType.AVM_OTHER\">\n          <!-- Status  -->\n          <ng-container\n            *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Provider && provider.aufnahmeCode === '1' && isStatusEqual(provider) ||\n            vm.lerbFinderMode === LerbFinderMode.Doctor && getAcceptPatientCodeByProduct(provider, vm.avmProduct) === '1';\n            then nimmtPatientenAuf, else nachAbspracheMitArzt\"\n          >\n          </ng-container>\n          <ng-template #nimmtPatientenAuf>\n            <p class=\"flex py-2\">\n              <span class=\"ico--tick ico--24\"></span>\n              {{ t('DetailsComponent.nimmtPatientenauf') }}\n            </p>\n          </ng-template>\n          <ng-template #nachAbspracheMitArzt>\n            <p class=\"flex py-2\">\n              <span class=\"ico--info-serif ico--24\"></span>\n              {{ t('DetailsComponent.nachAbspracheMitArzt') }}\n            </p>\n          </ng-template>\n          <!-- Products  -->\n          <ng-container *ngIf=\"provider.products?.length\">\n            <div class=\"my-2 flex\">\n              <span class=\"ico--stetoskop ico--24 mr-2\"></span>\n              <div class=\"flex w-full flex-col\">\n                <div class=\"flex items-center\">\n                  <div class=\"t-p-bold mr-2 min-w-fit\">\n                    {{ t('DetailsComponent.produkt') }}\n                  </div>\n                  <div class=\"group relative flex w-full flex-col\">\n                    <span\n                      (click)=\"openToolTip(!vm.openToolTip)\"\n                      class=\"ico--info ico--18 mr-2 cursor-pointer text-gray-400\"\n                    ></span>\n                    <helsana-tool-tip />\n                  </div>\n                </div>\n                <span class=\"t-label-normal\">{{\n                  getAVMProducts(provider)\n                }}</span>\n              </div>\n            </div>\n          </ng-container>\n          <!-- netzWwwHomepage -->\n          <ng-container *ngIf=\"provider.netzWwwHomepage\">\n            <div class=\"my-2 flex\">\n              <span class=\"ico--rabatt ico--24\"></span>\n              <div>\n                <p class=\"t-p-bold\">\n                  {{ t('DetailsComponent.netzwerk') }}\n                </p>\n                <p>{{ provider.netzName }}</p>\n                <p>{{ provider.netzWwwHomepage }}</p>\n              </div>\n            </div>\n          </ng-container>\n          <!-- avmVertrag -->\n          <div >\n            <p class=\"flex py-2\">\n              <span class=\"ico--info-serif ico--24\"></span>\n              <span class=\"t-label-normal\">{{\n                t('DetailsComponent.avmVertrag')\n              }}</span>\n            </p>\n          </div>\n        </div>\n      </div>\n    </ng-template>\n\n    <ng-template #button>\n      <div\n        class=\"sticky bottom-0 z-30 w-full bg-white p-4\"\n        [ngClass]=\"{\n          'nova-shadow-top border-t  border-gray-200': isScrollable(\n            vm.isDesktop ? 'hausarzt-details-scrollable' : 'overlay-scrollable'\n          )\n        }\"\n      >\n        <button\n          *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Doctor && vm.isOverlayMode\"\n          class=\"btn primary md:w-full\"\n          (click)=\"chooseProviderClicked()\"\n        >\n          {{ t('DetailsComponent.hausarztAuswaehlen') }}\n        </button>\n        <button\n          *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Provider\"\n          class=\"btn primary md:w-full\"\n          (click)=\"closeButtonClicked()\"\n        >\n          {{\n            vm.selectedLocationId\n              ? t('DetailsComponent.zurueck')\n              : t('DetailsComponent.schliessen')\n          }}\n        </button>\n      </div>\n    </ng-template>\n  </ng-container>\n</ng-container>\n", styles: [".details-with-icons span[class^=ico--]{margin-right:8px}.provider-details-desktop{font-family:AkkuratHelsanaTT Regular Web,Helvetica,Arial,sans-serif}\n"] }]
        }] });

const getMapMarkersCoordinates = (providers, lerbFinderType) => {
    return providers
        ? providers
            ?.filter((provider) => provider?.lat && provider?.lng)
            .map((provider) => ({
            type: lerbFinderType === LerbFinderMode.Doctor
                ? ProviderType.AVM_GROUP
                : getProviderTypeById(provider.field),
            lat: provider?.lat,
            lng: provider?.lng,
        }))
        : [];
};

const selectLocationCoordinates = createSelector(selectLocationProviders, selectLerbFinderMode, (locationProviders, lerbFinderType) => getMapMarkersCoordinates(locationProviders, lerbFinderType));
const selectLocationComponentVm = createSelector(selectLocationProviders, selectLocationCoordinates, selectLerbFinderMode, selectIsDesktop, (locationProviders, locationCoordinates, lerbFinderMode, isDesktop) => ({
    locationProviders,
    locationCoordinates,
    lerbFinderMode,
    isDesktop,
}));

let LocationViewComponent = class LocationViewComponent {
    constructor() {
        this.store = inject(Store);
        this.scrollingService = inject(ScrollingService);
        this.mapHeightDesktop = mapHeightDesktop;
        this.listWidthDesktop = listWidthDesktop;
        this.LerbFinderMode = LerbFinderMode;
        this.vm$ = this.store.select(selectLocationComponentVm);
        this.isDesktop = false;
    }
    ngOnInit() {
        this.vm$
            .pipe(untilDestroyed(this), tap((vm) => {
            this.isDesktop = vm.isDesktop;
        }))
            .subscribe();
        this.store.dispatch(onInit$2());
    }
    closeButtonClicked() {
        this.store.dispatch(backClicked());
    }
    async backClicked() {
        this.store.dispatch(backClicked());
        //For  AEM Overlay
        const isMobile = !this.isDesktop;
        const element = await this.scrollingService.isElementLoaded('hausarzt-results');
        if (element && isMobile) {
            this.scrollingService.setScrollEvent(ScrollingClickEvent.MobileOverlayBackClickedEvent, element);
        }
    }
    selectProvider(provider) {
        this.store.dispatch(selectProvider$1({ id: provider.id }));
    }
    openGoogleMaps(provider) {
        this.store.dispatch(openGoogleMapsClicked({ provider }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LocationViewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: LocationViewComponent, isStandalone: true, selector: "helsana-location-view", ngImport: i0, template: "<ng-container *rxLet=\"vm$; let vm\">\n  <ng-container *transloco=\"let t\">\n    <!--MOBILE-->\n    <div *ngIf=\"!vm.isDesktop && vm.locationProviders?.[0] as provider\" [ngClass]=\"{\n        'fixed w-full top-0 left-0 right-0 bottom-0 bg-white z-[999] overflow-x-auto': vm.lerbFinderMode === LerbFinderMode.Provider,\n    }\">\n      <div class=\"mb-2 p-4\">\n        <div class=\"flex items-center\" [ngClass]=\"{\n          'justify-end': vm.lerbFinderMode === LerbFinderMode.Provider,\n          'justify-between': vm.lerbFinderMode === LerbFinderMode.Doctor\n        }\">\n          <a class=\"link-back\" (click)=\"backClicked()\" *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Doctor\">\n            {{ t('LocationComponent.zurueckZuResultaten') }}\n          </a>\n          <button *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Provider\" class=\"close-x\" (click)=\"closeButtonClicked()\">\n            <div class=\"ico--close ico--20\"></div>\n          </button>\n        </div>\n        <ng-container [ngTemplateOutlet]=\"titleAndAddress\"\n          [ngTemplateOutletContext]=\"{ provider: provider }\"></ng-container>\n      </div>\n\n      <ng-container [ngTemplateOutlet]=\"mapWithButton\"\n        [ngTemplateOutletContext]=\"{ provider: provider }\"></ng-container>\n\n      <div class=\"w-full\">\n        <helsana-list (providerClicked)=\"selectProvider($event)\"></helsana-list>\n      </div>\n      <div class=\"w-full bg-white px-4 py-8\">\n        <button class=\"w-full btn primary\" (click)=\"backClicked()\">\n          {{ t('LocationComponent.schliessen') }}\n        </button>\n      </div>\n    </div>\n\n    <!--DESKTOP-->\n    <div *ngIf=\"vm.isDesktop && vm.locationProviders?.[0] as provider\" class=\"flex pb-4\">\n      <div class=\"flex flex-col\" [style.height]=\"mapHeightDesktop\" [style.min-width]=\"listWidthDesktop\">\n        <div class=\"shrink-0 bg-gray-100 p-4\">\n          <ng-container [ngTemplateOutlet]=\"titleAndAddress\"\n            [ngTemplateOutletContext]=\"{ provider: provider }\"></ng-container>\n        </div>\n        <div class=\"overflow-y-scroll\">\n          <helsana-list (providerClicked)=\"selectProvider($event)\"></helsana-list>\n        </div>\n      </div>\n      <div class=\"w-full\">\n        <ng-container [ngTemplateOutlet]=\"mapWithButton\"\n          [ngTemplateOutletContext]=\"{ provider: provider }\"></ng-container>\n      </div>\n    </div>\n\n    <!--TEMPLATES-->\n    <ng-template #titleAndAddress let-provider=\"provider\">\n      <h2 class=\"t-h2 lg:t-h4 mb-3 mt-8 lg:mt-0\">\n        {{ t('LocationComponent.standortuebersicht') }}\n      </h2>\n      <div class=\"flex\">\n        <span class=\"ico--location ico--24 mr-3 hidden lg:block\"></span>\n        <div>\n          <p>{{ provider.strasse }}</p>\n          <p>{{ provider.plz }} {{ provider.ort }}</p>\n        </div>\n      </div>\n    </ng-template>\n\n    <ng-template #mapWithButton let-provider=\"provider\">\n      <div class=\"relative\">\n        <helsana-google-maps [height]=\"vm.isDesktop ? mapHeightDesktop : '220px'\" [coordinates]=\"vm.locationCoordinates\"\n          [showZoomControl]=\"vm.isDesktop\" [gestureHandling]=\"false\"></helsana-google-maps>\n        <div class=\"absolute top-4 left-4 \" *ngIf=\"vm.isDesktop\">\n          <button data-testid=\"lerb-finder-details-openGoogleMaps\" class=\"btn black\" (click)=\"openGoogleMaps(provider)\">\n            <span class=\"ico--link-external ico--24 mr-3\"></span>\n            {{ t('DetailsComponent.openGoogleMaps') }}\n          </button>\n        </div>\n        <div class=\"absolute bottom-4 w-full p-4\" *ngIf=\"!vm.isDesktop\">\n          <button data-testid=\"lerb-finder-details-openGoogleMaps\" class=\"btn black\" (click)=\"openGoogleMaps(provider)\">\n            <span class=\"ico--link-external ico--24 mr-3\"></span>\n            {{ t('DetailsComponent.openGoogleMaps') }}\n          </button>\n        </div>\n      </div>\n    </ng-template>\n  </ng-container>\n</ng-container>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: GoogleMapsComponent, selector: "helsana-google-maps", inputs: ["height", "showZoomControl", "activateMarkerOnClick", "gestureHandling", "showAreaSearchButton", "isMapOverlayVisible", "isDesktop", "coordinates"], outputs: ["markerClicked", "markerHovered", "mapClicked", "mapUpdated"] }, { kind: "component", type: ListComponent, selector: "helsana-list", outputs: ["providerClicked"] }, { kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i2.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "ngmodule", type: LetModule }, { kind: "directive", type: i3.LetDirective, selector: "[rxLet]", inputs: ["rxLet", "rxLetStrategy", "rxLetComplete", "rxLetError", "rxLetSuspense", "rxLetContextTrigger", "rxLetCompleteTrigger", "rxLetErrorTrigger", "rxLetSuspenseTrigger", "rxLetNextTrigger", "rxLetRenderCallback", "rxLetParent", "rxLetPatchZone"], outputs: ["rendered"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
};
LocationViewComponent = __decorate([
    UntilDestroy()
], LocationViewComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LocationViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'helsana-location-view', standalone: true, imports: [
                        CommonModule,
                        GoogleMapsComponent,
                        ListComponent,
                        TranslocoModule,
                        LetModule,
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *rxLet=\"vm$; let vm\">\n  <ng-container *transloco=\"let t\">\n    <!--MOBILE-->\n    <div *ngIf=\"!vm.isDesktop && vm.locationProviders?.[0] as provider\" [ngClass]=\"{\n        'fixed w-full top-0 left-0 right-0 bottom-0 bg-white z-[999] overflow-x-auto': vm.lerbFinderMode === LerbFinderMode.Provider,\n    }\">\n      <div class=\"mb-2 p-4\">\n        <div class=\"flex items-center\" [ngClass]=\"{\n          'justify-end': vm.lerbFinderMode === LerbFinderMode.Provider,\n          'justify-between': vm.lerbFinderMode === LerbFinderMode.Doctor\n        }\">\n          <a class=\"link-back\" (click)=\"backClicked()\" *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Doctor\">\n            {{ t('LocationComponent.zurueckZuResultaten') }}\n          </a>\n          <button *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Provider\" class=\"close-x\" (click)=\"closeButtonClicked()\">\n            <div class=\"ico--close ico--20\"></div>\n          </button>\n        </div>\n        <ng-container [ngTemplateOutlet]=\"titleAndAddress\"\n          [ngTemplateOutletContext]=\"{ provider: provider }\"></ng-container>\n      </div>\n\n      <ng-container [ngTemplateOutlet]=\"mapWithButton\"\n        [ngTemplateOutletContext]=\"{ provider: provider }\"></ng-container>\n\n      <div class=\"w-full\">\n        <helsana-list (providerClicked)=\"selectProvider($event)\"></helsana-list>\n      </div>\n      <div class=\"w-full bg-white px-4 py-8\">\n        <button class=\"w-full btn primary\" (click)=\"backClicked()\">\n          {{ t('LocationComponent.schliessen') }}\n        </button>\n      </div>\n    </div>\n\n    <!--DESKTOP-->\n    <div *ngIf=\"vm.isDesktop && vm.locationProviders?.[0] as provider\" class=\"flex pb-4\">\n      <div class=\"flex flex-col\" [style.height]=\"mapHeightDesktop\" [style.min-width]=\"listWidthDesktop\">\n        <div class=\"shrink-0 bg-gray-100 p-4\">\n          <ng-container [ngTemplateOutlet]=\"titleAndAddress\"\n            [ngTemplateOutletContext]=\"{ provider: provider }\"></ng-container>\n        </div>\n        <div class=\"overflow-y-scroll\">\n          <helsana-list (providerClicked)=\"selectProvider($event)\"></helsana-list>\n        </div>\n      </div>\n      <div class=\"w-full\">\n        <ng-container [ngTemplateOutlet]=\"mapWithButton\"\n          [ngTemplateOutletContext]=\"{ provider: provider }\"></ng-container>\n      </div>\n    </div>\n\n    <!--TEMPLATES-->\n    <ng-template #titleAndAddress let-provider=\"provider\">\n      <h2 class=\"t-h2 lg:t-h4 mb-3 mt-8 lg:mt-0\">\n        {{ t('LocationComponent.standortuebersicht') }}\n      </h2>\n      <div class=\"flex\">\n        <span class=\"ico--location ico--24 mr-3 hidden lg:block\"></span>\n        <div>\n          <p>{{ provider.strasse }}</p>\n          <p>{{ provider.plz }} {{ provider.ort }}</p>\n        </div>\n      </div>\n    </ng-template>\n\n    <ng-template #mapWithButton let-provider=\"provider\">\n      <div class=\"relative\">\n        <helsana-google-maps [height]=\"vm.isDesktop ? mapHeightDesktop : '220px'\" [coordinates]=\"vm.locationCoordinates\"\n          [showZoomControl]=\"vm.isDesktop\" [gestureHandling]=\"false\"></helsana-google-maps>\n        <div class=\"absolute top-4 left-4 \" *ngIf=\"vm.isDesktop\">\n          <button data-testid=\"lerb-finder-details-openGoogleMaps\" class=\"btn black\" (click)=\"openGoogleMaps(provider)\">\n            <span class=\"ico--link-external ico--24 mr-3\"></span>\n            {{ t('DetailsComponent.openGoogleMaps') }}\n          </button>\n        </div>\n        <div class=\"absolute bottom-4 w-full p-4\" *ngIf=\"!vm.isDesktop\">\n          <button data-testid=\"lerb-finder-details-openGoogleMaps\" class=\"btn black\" (click)=\"openGoogleMaps(provider)\">\n            <span class=\"ico--link-external ico--24 mr-3\"></span>\n            {{ t('DetailsComponent.openGoogleMaps') }}\n          </button>\n        </div>\n      </div>\n    </ng-template>\n  </ng-container>\n</ng-container>\n" }]
        }] });

const selectMapPreviewComponentVm = createSelector(selectMapPreviewProviders, (mapPreviewProviders) => ({
    mapPreviewProviders,
}));

class MapPreviewPanelComponent {
    constructor() {
        this.store = inject(Store);
        this.vm$ = this.store.select(selectMapPreviewComponentVm);
        this.getProviderTypeTranslationByFieldNumber = getProviderTypeTranslationByFieldNumber;
    }
    mapPreviewClicked() {
        this.store.dispatch(mapPreviewClicked());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: MapPreviewPanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: MapPreviewPanelComponent, isStandalone: true, selector: "helsana-map-preview-panel", ngImport: i0, template: `
    <ng-container *transloco="let t">
      <ng-container *rxLet="vm$; let vm">
        <div
          *ngIf="vm.mapPreviewProviders?.length"
          class="helsana-shadow-top absolute bottom-0 h-fit w-full rounded-[5px] border-t border-t-gray-200 bg-white p-4"
        >
          <div
            class="flex cursor-pointer justify-between"
            (click)="mapPreviewClicked()"
            data-testid="lerb-finder-map-preview-clickable"
          >
            <div class="flex">
              <div class="ico--location ico--24 mr-4 mt-1"></div>
              <div>
                <div *ngIf="vm.mapPreviewProviders!.length === 1" class="mb-4">
                  <p class="t-h4">
                    {{ vm.mapPreviewProviders![0].vorname }}
                    {{ vm.mapPreviewProviders![0].name }}
                  </p>
                  <p class="t-label-normal">
                    {{
                      t(
                        getProviderTypeTranslationByFieldNumber(
                          vm.mapPreviewProviders![0].field
                        )
                      )
                    }}
                  </p>
                </div>
                <p>{{ vm.mapPreviewProviders![0].strasse }}</p>
                <p>
                  {{ vm.mapPreviewProviders![0].plz }}
                  {{ vm.mapPreviewProviders![0].ort }}
                </p>
              </div>
            </div>
            <div class="mt-4">
              <div class="ico--chevron-right ico--20"></div>
            </div>
          </div>

          <div
            *ngIf="vm.mapPreviewProviders!.length > 1"
            class="mt-2 flex rounded bg-gray-100 p-2"
          >
            <span class="ico--info-serif ico--24 mr-2"></span>
            {{ t('MapPreviewComponent.mehrereLeistungserbringer') }}
          </div>
        </div>
      </ng-container>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i2.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "ngmodule", type: LetModule }, { kind: "directive", type: i3.LetDirective, selector: "[rxLet]", inputs: ["rxLet", "rxLetStrategy", "rxLetComplete", "rxLetError", "rxLetSuspense", "rxLetContextTrigger", "rxLetCompleteTrigger", "rxLetErrorTrigger", "rxLetSuspenseTrigger", "rxLetNextTrigger", "rxLetRenderCallback", "rxLetParent", "rxLetPatchZone"], outputs: ["rendered"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: MapPreviewPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'helsana-map-preview-panel', standalone: true, imports: [CommonModule, TranslocoModule, LetModule], template: `
    <ng-container *transloco="let t">
      <ng-container *rxLet="vm$; let vm">
        <div
          *ngIf="vm.mapPreviewProviders?.length"
          class="helsana-shadow-top absolute bottom-0 h-fit w-full rounded-[5px] border-t border-t-gray-200 bg-white p-4"
        >
          <div
            class="flex cursor-pointer justify-between"
            (click)="mapPreviewClicked()"
            data-testid="lerb-finder-map-preview-clickable"
          >
            <div class="flex">
              <div class="ico--location ico--24 mr-4 mt-1"></div>
              <div>
                <div *ngIf="vm.mapPreviewProviders!.length === 1" class="mb-4">
                  <p class="t-h4">
                    {{ vm.mapPreviewProviders![0].vorname }}
                    {{ vm.mapPreviewProviders![0].name }}
                  </p>
                  <p class="t-label-normal">
                    {{
                      t(
                        getProviderTypeTranslationByFieldNumber(
                          vm.mapPreviewProviders![0].field
                        )
                      )
                    }}
                  </p>
                </div>
                <p>{{ vm.mapPreviewProviders![0].strasse }}</p>
                <p>
                  {{ vm.mapPreviewProviders![0].plz }}
                  {{ vm.mapPreviewProviders![0].ort }}
                </p>
              </div>
            </div>
            <div class="mt-4">
              <div class="ico--chevron-right ico--20"></div>
            </div>
          </div>

          <div
            *ngIf="vm.mapPreviewProviders!.length > 1"
            class="mt-2 flex rounded bg-gray-100 p-2"
          >
            <span class="ico--info-serif ico--24 mr-2"></span>
            {{ t('MapPreviewComponent.mehrereLeistungserbringer') }}
          </div>
        </div>
      </ng-container>
    </ng-container>
  `, changeDetection: ChangeDetectionStrategy.OnPush }]
        }] });

const selectQuickAccessFilterVm = createSelector(selectLerbFinderMode, selectSearchState, selectSearchResults, selectDetailsProvider, selectActiveProviderTypeName, selectActiveMethodName, selectSubmittedDoctorFilterForm, selectSubmittedProviderFilterForm, selectInputSearch, selectSelectedLocationId, selectSubmittedInput, selectIsDetailViewActive, (lerbFinderMode, searchState, searchResults, detailsProvider, activeProviderTypeName, activeMethodName, submittedDoctorFilterForm, submittedProviderFilterForm, inputSearch, selectedLocationId, submittedInput, isDetailViewActive) => {
    const searchSuccess = searchState === 'areaSuccess' ||
        searchState === 'locationSuccess' ||
        searchState === 'zipSuccess' ||
        searchState === 'providerSelectedViaInput';
    return {
        isQuickAccessFilterVisible: searchSuccess &&
            searchResults &&
            submittedInput &&
            !selectedLocationId &&
            !detailsProvider &&
            !isDetailViewActive,
        lerbFinderMode,
        activeMethodName,
        activeProviderTypeName,
        submittedDoctorFilterForm,
        submittedProviderFilterForm,
        input: inputSearch.input,
        submittedInput: searchState !== 'providerSelectedViaInput' ? submittedInput : undefined,
    };
});

let FilterChipComponent = class FilterChipComponent {
    constructor() {
        this.label = '';
        this.removeFilter = new EventEmitter();
    }
    closeIconClicked() {
        this.removeFilter.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: FilterChipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: FilterChipComponent, isStandalone: true, selector: "helsana-filter-chip", inputs: { label: "label" }, outputs: { removeFilter: "removeFilter" }, ngImport: i0, template: "<div\n  class=\"border-helsana filter-chip rounded-full border p-1 px-2\"\n>\n  <span>{{ label }}</span>\n  <i\n    (click)=\"closeIconClicked()\"\n    class=\"ico--close ico--12 mt-[1px] cursor-pointer\"\n  ></i>\n</div>\n", styles: [".filter-chip{max-width:180px;width:fit-content;display:inline-flex;justify-content:center;font-family:AkkuratHelsanaTT Regular Web,Helvetica,Arial,sans-serif}.filter-chip span{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: LetModule }] }); }
};
FilterChipComponent = __decorate([
    UntilDestroy()
], FilterChipComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: FilterChipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'helsana-filter-chip', standalone: true, imports: [CommonModule, LetModule], template: "<div\n  class=\"border-helsana filter-chip rounded-full border p-1 px-2\"\n>\n  <span>{{ label }}</span>\n  <i\n    (click)=\"closeIconClicked()\"\n    class=\"ico--close ico--12 mt-[1px] cursor-pointer\"\n  ></i>\n</div>\n", styles: [".filter-chip{max-width:180px;width:fit-content;display:inline-flex;justify-content:center;font-family:AkkuratHelsanaTT Regular Web,Helvetica,Arial,sans-serif}.filter-chip span{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}\n"] }]
        }], propDecorators: { label: [{
                type: Input
            }], removeFilter: [{
                type: Output
            }] } });

let QuickAccessFilterComponent = class QuickAccessFilterComponent {
    constructor() {
        this.store = inject(Store);
        this.scrollingService = inject(ScrollingService);
        this.LerbFinderMode = LerbFinderMode;
        this.vm$ = this.store.select(selectQuickAccessFilterVm);
    }
    removeAcceptPatientsFilter() {
        this.store.dispatch(removeAcceptPatientsButtonClicked({
            param: QuickAccessFilterParamEnum.acceptsNewPatients,
        }));
    }
    removeOnlyPediatriciansFilter() {
        this.store.dispatch(removeOnlyPediatriciansOnlyButtonClicked({
            param: QuickAccessFilterParamEnum.pediatriciansOnly,
        }));
    }
    removeProviderTypeFilter() {
        this.store.dispatch(removeProviderTypeIdButtonClicked({
            param: QuickAccessFilterParamEnum.providerTypeId,
        }));
    }
    removeProviderMethodFilter() {
        this.store.dispatch(removeMethodButtonClicked({
            param: QuickAccessFilterParamEnum.method,
        }));
    }
    async scrollToTopOfOverlay() {
        this.store.dispatch(adjustSearchButtonClicked());
        // For AEM Overlay
        const element = await this.scrollingService.isElementLoaded('overlay-scrollable');
        if (element) {
            this.scrollingService.setScrollEvent(ScrollingClickEvent.AdjustSearchButtonClickedEvent, element);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: QuickAccessFilterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: QuickAccessFilterComponent, isStandalone: true, selector: "helsana-quick-access-filter", ngImport: i0, template: "<ng-container *rxLet=\"vm$; let vm\">\n  <div *transloco=\"let t\">\n    <div *ngIf=\"vm.isQuickAccessFilterVisible\">\n      <div class=\"absolute right-0 z-10 m-4 rounded-md bg-white shadow\">\n        <div\n          *ngIf=\"vm.submittedInput\"\n          class=\"t-label-small flex flex-wrap gap-2 p-4\"\n          [style.width]=\"'227px'\"\n        >\n          <div class=\"bg-helsana rounded-full p-1 px-2 text-white\">\n            {{ vm.submittedInput }}\n          </div>\n\n          <ng-container *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Doctor\">\n            <helsana-filter-chip\n              *ngIf=\"vm.submittedDoctorFilterForm?.acceptsNewPatients\"\n              [label]=\"t('QuickAccessFilterComponent.nimmtPatientenAuf')\"\n              (removeFilter)=\"removeAcceptPatientsFilter()\"\n            ></helsana-filter-chip>\n\n            <helsana-filter-chip\n              *ngIf=\"vm.submittedDoctorFilterForm?.pediatriciansOnly\"\n              [label]=\"t('QuickAccessFilterComponent.nurKinderaerzte')\"\n              (removeFilter)=\"removeOnlyPediatriciansFilter()\"\n            ></helsana-filter-chip>\n          </ng-container>\n\n          <ng-container *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Provider\">\n            <helsana-filter-chip\n              *ngIf=\"vm.submittedProviderFilterForm?.providerTypeId\"\n              [label]=\"t(vm.activeProviderTypeName?.toString() || '')\"\n              (removeFilter)=\"removeProviderTypeFilter()\"\n            ></helsana-filter-chip>\n\n            <helsana-filter-chip\n              *ngIf=\"vm.submittedProviderFilterForm?.method\"\n              [label]=\"t(vm.activeMethodName?.toString() || '')\"\n              (removeFilter)=\"removeProviderMethodFilter()\"\n            ></helsana-filter-chip>\n          </ng-container>\n        </div>\n        <div\n          class=\"bottom-0 rounded-b-md bg-black text-white\"\n          [ngClass]=\"{ 'rounded-t-md': !vm.submittedInput }\"\n        >\n          <button\n            class=\"btn black t-label-normal py-2\"\n            (click)=\"scrollToTopOfOverlay()\"\n          >\n            <span class=\"ico--search ico--28 mr-3\"></span>\n            {{ t('QuickAccessFilterComponent.sucheAnpassen') }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-container>\n", styles: [".bg-helsana{background-color:#9a0941}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i2.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "ngmodule", type: LetModule }, { kind: "directive", type: i3.LetDirective, selector: "[rxLet]", inputs: ["rxLet", "rxLetStrategy", "rxLetComplete", "rxLetError", "rxLetSuspense", "rxLetContextTrigger", "rxLetCompleteTrigger", "rxLetErrorTrigger", "rxLetSuspenseTrigger", "rxLetNextTrigger", "rxLetRenderCallback", "rxLetParent", "rxLetPatchZone"], outputs: ["rendered"] }, { kind: "component", type: FilterChipComponent, selector: "helsana-filter-chip", inputs: ["label"], outputs: ["removeFilter"] }] }); }
};
QuickAccessFilterComponent = __decorate([
    UntilDestroy()
], QuickAccessFilterComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: QuickAccessFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'helsana-quick-access-filter', standalone: true, imports: [CommonModule, TranslocoModule, LetModule, FilterChipComponent], template: "<ng-container *rxLet=\"vm$; let vm\">\n  <div *transloco=\"let t\">\n    <div *ngIf=\"vm.isQuickAccessFilterVisible\">\n      <div class=\"absolute right-0 z-10 m-4 rounded-md bg-white shadow\">\n        <div\n          *ngIf=\"vm.submittedInput\"\n          class=\"t-label-small flex flex-wrap gap-2 p-4\"\n          [style.width]=\"'227px'\"\n        >\n          <div class=\"bg-helsana rounded-full p-1 px-2 text-white\">\n            {{ vm.submittedInput }}\n          </div>\n\n          <ng-container *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Doctor\">\n            <helsana-filter-chip\n              *ngIf=\"vm.submittedDoctorFilterForm?.acceptsNewPatients\"\n              [label]=\"t('QuickAccessFilterComponent.nimmtPatientenAuf')\"\n              (removeFilter)=\"removeAcceptPatientsFilter()\"\n            ></helsana-filter-chip>\n\n            <helsana-filter-chip\n              *ngIf=\"vm.submittedDoctorFilterForm?.pediatriciansOnly\"\n              [label]=\"t('QuickAccessFilterComponent.nurKinderaerzte')\"\n              (removeFilter)=\"removeOnlyPediatriciansFilter()\"\n            ></helsana-filter-chip>\n          </ng-container>\n\n          <ng-container *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Provider\">\n            <helsana-filter-chip\n              *ngIf=\"vm.submittedProviderFilterForm?.providerTypeId\"\n              [label]=\"t(vm.activeProviderTypeName?.toString() || '')\"\n              (removeFilter)=\"removeProviderTypeFilter()\"\n            ></helsana-filter-chip>\n\n            <helsana-filter-chip\n              *ngIf=\"vm.submittedProviderFilterForm?.method\"\n              [label]=\"t(vm.activeMethodName?.toString() || '')\"\n              (removeFilter)=\"removeProviderMethodFilter()\"\n            ></helsana-filter-chip>\n          </ng-container>\n        </div>\n        <div\n          class=\"bottom-0 rounded-b-md bg-black text-white\"\n          [ngClass]=\"{ 'rounded-t-md': !vm.submittedInput }\"\n        >\n          <button\n            class=\"btn black t-label-normal py-2\"\n            (click)=\"scrollToTopOfOverlay()\"\n          >\n            <span class=\"ico--search ico--28 mr-3\"></span>\n            {{ t('QuickAccessFilterComponent.sucheAnpassen') }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-container>\n", styles: [".bg-helsana{background-color:#9a0941}\n"] }]
        }] });

const selectProviderMethodOptions = createSelector(selectProviderFilterForm, ({ providerTypeId, methods }) => {
    if (providerTypeId === ProviderTypeId.ALL) {
        const methodSelection = methods.map((method) => ({
            label: method.text,
            value: method.id,
        }));
        methodSelection.unshift({
            label: 'ProviderFilterComponent.alleMethoden',
            value: 0,
        });
        return methodSelection;
    }
    const filteredMethodSelection = methods
        .filter((method) => method.typ === getProviderTypeById(providerTypeId))
        .map((method) => ({ label: method.text, value: method.id }));
    if (filteredMethodSelection.length > 0) {
        filteredMethodSelection.unshift({
            label: 'ProviderFilterComponent.alleMethoden',
            value: 0,
        });
    }
    return filteredMethodSelection;
});
const selectProviderFilterComponentVm = createSelector(selectProviderFilterForm, selectIsValidSearchInput, selectProviderMethodOptions, selectIsDirectSearchInput, ({ providerTypeId, method }, isValidSearchInput, methodOptions, directSearchInput) => {
    return {
        providerTypeId,
        providerTypeOptions,
        method,
        methodOptions,
        isValidSearchInput,
        directSearchInput,
    };
});

let ProviderFilterFormGroupComponent = class ProviderFilterFormGroupComponent {
    constructor() {
        this.store = inject(Store);
        this.vm$ = this.store.select(selectProviderFilterComponentVm);
        this.providerFilterFormGroup = new FormGroup({
            providerTypeId: new FormControl(ProviderTypeId.AVM_GROUP),
            method: new FormControl(0),
        });
    }
    ngOnInit() {
        this.store.dispatch(onInit());
        let initialVmEvent = true;
        this.vm$
            .pipe(untilDestroyed(this), map((vm) => {
            const providerTypeId = this.providerFilterFormGroup.get('providerTypeId')?.value;
            const method = this.providerFilterFormGroup.get('method')?.value;
            if (providerTypeId !== vm.providerTypeId) {
                this.providerFilterFormGroup
                    .get('providerTypeId')
                    ?.setValue(vm.providerTypeId);
            }
            if (method !== vm.method) {
                this.providerFilterFormGroup.get('method')?.setValue(vm.method);
            }
            vm.isValidSearchInput && !vm.directSearchInput
                ? this.providerFilterFormGroup?.enable({ emitEvent: false })
                : this.providerFilterFormGroup?.disable({ emitEvent: false });
            // Listen to control changes only when controls have already been initialized with vm values
            if (initialVmEvent) {
                this.subscribeToProviderTypeDropdownChanges();
                this.subscribeToMethodDropdownChanges();
                initialVmEvent = false;
            }
            if (vm.methodOptions.length < 1 ||
                !vm.isValidSearchInput ||
                vm.directSearchInput) {
                this.providerFilterFormGroup
                    .get('method')
                    ?.disable({ emitEvent: false });
            }
            else if (vm.methodOptions.length > 0 &&
                vm.isValidSearchInput &&
                !vm.directSearchInput) {
                this.providerFilterFormGroup
                    .get('method')
                    ?.enable({ emitEvent: false });
            }
        }))
            .subscribe();
    }
    subscribeToProviderTypeDropdownChanges() {
        this.providerFilterFormGroup
            .get('providerTypeId')
            ?.valueChanges.pipe(untilDestroyed(this), distinctUntilChanged(), filter((providerType) => providerType !== null), tap((providerType) => {
            this.store.dispatch(providerTypeFilterChanged({
                providerType,
            }));
        }))
            .subscribe();
    }
    subscribeToMethodDropdownChanges() {
        this.providerFilterFormGroup
            .get('method')
            ?.valueChanges.pipe(untilDestroyed(this), distinctUntilChanged(), filter((method) => method !== null), tap((method) => {
            this.store.dispatch(methodFilterChanged({ method }));
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ProviderFilterFormGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: ProviderFilterFormGroupComponent, isStandalone: true, selector: "helsana-provider-filter-form-group", ngImport: i0, template: `
    <div
      style="border: 1px solid #949494; padding: 16px 16px 0px 16px; border-radius: 2px;"
    >
      <div *rxLet="vm$; let vm">
        <div *transloco="let t">
          <form
            [formGroup]="providerFilterFormGroup"
            class="flex flex-col gap-4 lg:flex-row "
          >
            <!-- TODO Malvin [disabled]="true" -->
            <shared-maps-ui-select
              class="mt-2 lg:basis-3/6"
              [label]="t('ProviderFilterComponent.leistungserbringerWaehlen')"
              [control]="providerFilterFormGroup.controls.providerTypeId"
              [slim]="true"
              [options]="vm.providerTypeOptions"
            >
            </shared-maps-ui-select>

            <shared-maps-ui-select
              class="mt-2 lg:basis-3/6"
              [withSearchField]="true"
              [label]="t('ProviderFilterComponent.methodeKursWaehlen')"
              [control]="providerFilterFormGroup.controls.method"
              [slim]="true"
              [options]="vm.methodOptions"
              [noOptionsPlaceholder]="
                t('ProviderFilterComponent.keineMethoden')
              "
            >
            </shared-maps-ui-select>
          </form>
        </div>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "component", type: UiSelectComponent, selector: "shared-maps-ui-select", inputs: ["options", "withSearchField", "floatLabel", "noOptionsPlaceholder"] }, { kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i2.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: LetModule }, { kind: "directive", type: i3.LetDirective, selector: "[rxLet]", inputs: ["rxLet", "rxLetStrategy", "rxLetComplete", "rxLetError", "rxLetSuspense", "rxLetContextTrigger", "rxLetCompleteTrigger", "rxLetErrorTrigger", "rxLetSuspenseTrigger", "rxLetNextTrigger", "rxLetRenderCallback", "rxLetParent", "rxLetPatchZone"], outputs: ["rendered"] }] }); }
};
ProviderFilterFormGroupComponent = __decorate([
    UntilDestroy()
], ProviderFilterFormGroupComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ProviderFilterFormGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'helsana-provider-filter-form-group',
                    standalone: true,
                    imports: [UiSelectComponent, TranslocoModule, ReactiveFormsModule, LetModule],
                    template: `
    <div
      style="border: 1px solid #949494; padding: 16px 16px 0px 16px; border-radius: 2px;"
    >
      <div *rxLet="vm$; let vm">
        <div *transloco="let t">
          <form
            [formGroup]="providerFilterFormGroup"
            class="flex flex-col gap-4 lg:flex-row "
          >
            <!-- TODO Malvin [disabled]="true" -->
            <shared-maps-ui-select
              class="mt-2 lg:basis-3/6"
              [label]="t('ProviderFilterComponent.leistungserbringerWaehlen')"
              [control]="providerFilterFormGroup.controls.providerTypeId"
              [slim]="true"
              [options]="vm.providerTypeOptions"
            >
            </shared-maps-ui-select>

            <shared-maps-ui-select
              class="mt-2 lg:basis-3/6"
              [withSearchField]="true"
              [label]="t('ProviderFilterComponent.methodeKursWaehlen')"
              [control]="providerFilterFormGroup.controls.method"
              [slim]="true"
              [options]="vm.methodOptions"
              [noOptionsPlaceholder]="
                t('ProviderFilterComponent.keineMethoden')
              "
            >
            </shared-maps-ui-select>
          </form>
        </div>
      </div>
    </div>
  `,
                }]
        }] });

const selectPrintViewComponentVm = createSelector(selectLerbFinderMode, selectAvmProduct, selectListProvidersByAvm, selectInputSearch, selectActiveMethodName, selectActiveProviderTypeName, selectSearchState, selectSubmittedProviderFilterForm, selectSubmittedDoctorFilterForm, (lerbFinderMode, avmProduct, searchResults, inputSearch, activeMethodName, activeProviderTypeName, searchState, submittedProviderFilterForm, submittedDoctorFilterForm) => ({
    lerbFinderMode,
    avmProduct,
    searchResults,
    inputSearch,
    activeMethodName,
    activeProviderTypeName,
    hasDoctors: !!searchResults?.some((provider) => provider.field === ProviderTypeId.AVM_PEDIA ||
        provider.field === ProviderTypeId.AVM_GROUP),
    searchSuccess: searchState === 'areaSuccess' ||
        searchState === 'locationSuccess' ||
        searchState === 'zipSuccess',
    submittedProviderFilterForm,
    submittedDoctorFilterForm,
}));

class PrintViewComponent {
    constructor() {
        this.store = inject(Store);
        this.translocoService = inject(TranslocoService);
        this.isStatusEqual = isStatusEqual;
        this.getAcceptPatientCodeByProduct = getAcceptPatientCodeByProduct;
        this.ProviderType = ProviderType;
        this.LerbFinderMode = LerbFinderMode;
        this.vm$ = this.store.select(selectPrintViewComponentVm);
    }
    getTranslatedCategory(fieldType) {
        switch (fieldType) {
            case ProviderTypeId.AVM_OTHER:
                return this.translocoService.translate('PrintViewComponent.gruppenpraxis');
            case ProviderTypeId.AVM_PEDIA:
                return this.translocoService.translate('PrintViewComponent.kinderarzt');
            case ProviderTypeId.PSY:
                return this.translocoService.translate('PrintViewComponent.psychotherapeuten');
            case ProviderTypeId.EMR:
                return this.translocoService.translate('PrintViewComponent.komplementärmedizin');
            case ProviderTypeId.FIT:
                return this.translocoService.translate('PrintViewComponent.fitness');
            case ProviderTypeId.KUR:
                return this.translocoService.translate('PrintViewComponent.kursleiter');
            default:
                return '';
        }
    }
    isDoctorType(type) {
        return (type === ProviderTypeId.AVM_GROUP ||
            type === ProviderTypeId.AVM_OTHER ||
            type === ProviderTypeId.AVM_PEDIA);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: PrintViewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: PrintViewComponent, isStandalone: true, selector: "helsana-print-view", ngImport: i0, template: "<ng-container *rxLet=\"vm$; let vm\">\n  <div class=\"search-meta\" *transloco=\"let t\">\n    <div class=\"mb-5\">\n      <h2 class=\"t-lead\">\n        <span *ngIf=\"vm.inputSearch.state === 'zipSelected'\">{{\n          t('PrintViewComponent.plz')\n        }}</span>\n        {{ vm.inputSearch.input }}:\n        {{ vm.searchResults?.length ?? 0 }}\n        {{ t('PrintViewComponent.ergebnisse') }}\n      </h2>\n    </div>\n    <div *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Doctor\" class=\"mb-5\">\n      <h3 class=\"t-p-normal\">\n        {{ t('PrintViewComponent.krankenversicherer') }}: Helsana\n      </h3>\n    </div>\n    <div *ngIf=\"vm.searchSuccess\">\n      <h3 class=\"t-p-normal\">\n        {{ t('PrintViewComponent.filter') }}:\n        <span *ngIf=\"vm.submittedDoctorFilterForm.acceptsNewPatients\">\n          {{ t('PrintViewComponent.nimmtPatientenAuf') }}\n        </span>\n        <span *ngIf=\"vm.submittedDoctorFilterForm.pediatriciansOnly\">\n          {{ t('PrintViewComponent.nurKinderaerzte') }}\n        </span>\n        <span *ngIf=\"vm.submittedProviderFilterForm.providerTypeId && vm.activeProviderTypeName\">\n          {{ t(vm.activeProviderTypeName) }}\n          <span *ngIf=\"vm.submittedProviderFilterForm.method\">,</span>\n        </span>\n        <span *ngIf=\"vm.submittedProviderFilterForm.method\">\n          {{ vm.activeMethodName }}\n        </span>\n      </h3>\n    </div>\n    <div\n      *ngIf=\"vm.hasDoctors\"\n      class=\"admission-legend\"\n    >\n      <span class=\"flex items-center space-x-1\">\n        <i class=\"ico--tick ico--12 leading-3\"></i>\n        <p class=\"t-label-normal\">\n          {{ t('PrintViewComponent.nimmtPatientenAuf') }}\n        </p>\n      </span>\n      <span class=\"flex items-center space-x-1\">\n        <i class=\"ico--close ico--12 leading-3\"></i>\n        <p class=\"t-label-normal\">\n          {{ t('PrintViewComponent.nimmtKeinePatientenAuf') }}\n        </p>\n      </span>\n      <span class=\"flex items-center space-x-1\">\n        <i class=\"ico--info ico--12 leading-3\"></i>\n        <p class=\"t-label-normal\">\n          {{ t('PrintViewComponent.abspracheMitArzt') }}\n        </p>\n      </span>\n    </div>\n  </div>\n  <table *transloco=\"let t\" aria-describedby=\"Lerb-Finder Print View\">\n    <thead>\n      <tr>\n        <th *ngIf=\"vm.hasDoctors\"></th>\n        <th class=\"name-column\">{{ t('PrintViewComponent.name') }}</th>\n        <th *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Provider\">\n          {{ t('PrintViewComponent.kategorie') }}\n        </th>\n        <th class=\"street-column\">{{ t('PrintViewComponent.strasse') }}</th>\n        <th class=\"zip-column\">{{ t('PrintViewComponent.plz') }}</th>\n        <th>{{ t('PrintViewComponent.ort') }}</th>\n        <th class=\"phone-column\">{{ t('PrintViewComponent.phone') }}</th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr *ngFor=\"let provider of vm.searchResults\">\n        <td *ngIf=\"vm.hasDoctors\">\n          <ng-container *ngIf=\"isDoctorType(provider.field)\">\n            <ng-container\n              *ngIf=\"\n                      (vm.lerbFinderMode === LerbFinderMode.Provider && isStatusEqual(provider) && (provider?.aufnahme === '1' || provider?.aufnahme === 'Y')) ||\n                      vm.lerbFinderMode === LerbFinderMode.Doctor && (getAcceptPatientCodeByProduct(provider, vm.avmProduct) === '1' || getAcceptPatientCodeByProduct(provider, vm.avmProduct) === 'Y');\n                    then nimmtPatientenAuf, else nachAbspracheMitArzt\"\n            >\n            </ng-container>\n          </ng-container>\n          <ng-template #nimmtPatientenAuf>\n            <i class=\"ico--tick ico--12\"></i>\n          </ng-template>\n          <ng-template #nachAbspracheMitArzt>\n            <i class=\"ico--info ico--12\"></i>\n          </ng-template>\n        </td>\n        <td>{{ provider.vorname + ' ' + provider.name }}</td>\n        <td *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Provider\">\n          {{ getTranslatedCategory(provider.field) }}\n        </td>\n        <td>{{ provider.strasse }}</td>\n        <td>{{ provider.plz }}</td>\n        <td>{{ provider.ort }}</td>\n        <td>{{ provider.telefon }}</td>\n      </tr>\n    </tbody>\n  </table>\n</ng-container>\n", styles: ["table{border-collapse:collapse;overflow-y:auto;max-width:100%;width:100%}th{text-align:left;border-bottom:1px solid #707070;--font-family-base: \"AkkuratHelsanaTT Bold Web\", Helvetica, Arial, sans-serif}td,th{padding:8px}td{border-bottom:1px solid #e0e0e0}table tr:last-child td{border-bottom:none}table>tr,table th{vertical-align:bottom}.search-meta{padding:5px;margin-top:10px;border-bottom:1px solid #c0c0c0}.zip-column{width:7rem}.phone-column{min-width:15rem}.admission-legend{display:flex}.admission-legend span{margin-right:10px;font-size:var(--font-size-extra-small)}.table-lead{font-size:var(--font-size-large)}@media screen and (min-width: 1024px){table{overflow-y:unset}}@media print{table{empty-cells:hide;font-size:1rem}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i2.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "ngmodule", type: LetModule }, { kind: "directive", type: i3.LetDirective, selector: "[rxLet]", inputs: ["rxLet", "rxLetStrategy", "rxLetComplete", "rxLetError", "rxLetSuspense", "rxLetContextTrigger", "rxLetCompleteTrigger", "rxLetErrorTrigger", "rxLetSuspenseTrigger", "rxLetNextTrigger", "rxLetRenderCallback", "rxLetParent", "rxLetPatchZone"], outputs: ["rendered"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: PrintViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'helsana-print-view', standalone: true, imports: [CommonModule, TranslocoModule, LetModule], encapsulation: ViewEncapsulation.Emulated, changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *rxLet=\"vm$; let vm\">\n  <div class=\"search-meta\" *transloco=\"let t\">\n    <div class=\"mb-5\">\n      <h2 class=\"t-lead\">\n        <span *ngIf=\"vm.inputSearch.state === 'zipSelected'\">{{\n          t('PrintViewComponent.plz')\n        }}</span>\n        {{ vm.inputSearch.input }}:\n        {{ vm.searchResults?.length ?? 0 }}\n        {{ t('PrintViewComponent.ergebnisse') }}\n      </h2>\n    </div>\n    <div *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Doctor\" class=\"mb-5\">\n      <h3 class=\"t-p-normal\">\n        {{ t('PrintViewComponent.krankenversicherer') }}: Helsana\n      </h3>\n    </div>\n    <div *ngIf=\"vm.searchSuccess\">\n      <h3 class=\"t-p-normal\">\n        {{ t('PrintViewComponent.filter') }}:\n        <span *ngIf=\"vm.submittedDoctorFilterForm.acceptsNewPatients\">\n          {{ t('PrintViewComponent.nimmtPatientenAuf') }}\n        </span>\n        <span *ngIf=\"vm.submittedDoctorFilterForm.pediatriciansOnly\">\n          {{ t('PrintViewComponent.nurKinderaerzte') }}\n        </span>\n        <span *ngIf=\"vm.submittedProviderFilterForm.providerTypeId && vm.activeProviderTypeName\">\n          {{ t(vm.activeProviderTypeName) }}\n          <span *ngIf=\"vm.submittedProviderFilterForm.method\">,</span>\n        </span>\n        <span *ngIf=\"vm.submittedProviderFilterForm.method\">\n          {{ vm.activeMethodName }}\n        </span>\n      </h3>\n    </div>\n    <div\n      *ngIf=\"vm.hasDoctors\"\n      class=\"admission-legend\"\n    >\n      <span class=\"flex items-center space-x-1\">\n        <i class=\"ico--tick ico--12 leading-3\"></i>\n        <p class=\"t-label-normal\">\n          {{ t('PrintViewComponent.nimmtPatientenAuf') }}\n        </p>\n      </span>\n      <span class=\"flex items-center space-x-1\">\n        <i class=\"ico--close ico--12 leading-3\"></i>\n        <p class=\"t-label-normal\">\n          {{ t('PrintViewComponent.nimmtKeinePatientenAuf') }}\n        </p>\n      </span>\n      <span class=\"flex items-center space-x-1\">\n        <i class=\"ico--info ico--12 leading-3\"></i>\n        <p class=\"t-label-normal\">\n          {{ t('PrintViewComponent.abspracheMitArzt') }}\n        </p>\n      </span>\n    </div>\n  </div>\n  <table *transloco=\"let t\" aria-describedby=\"Lerb-Finder Print View\">\n    <thead>\n      <tr>\n        <th *ngIf=\"vm.hasDoctors\"></th>\n        <th class=\"name-column\">{{ t('PrintViewComponent.name') }}</th>\n        <th *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Provider\">\n          {{ t('PrintViewComponent.kategorie') }}\n        </th>\n        <th class=\"street-column\">{{ t('PrintViewComponent.strasse') }}</th>\n        <th class=\"zip-column\">{{ t('PrintViewComponent.plz') }}</th>\n        <th>{{ t('PrintViewComponent.ort') }}</th>\n        <th class=\"phone-column\">{{ t('PrintViewComponent.phone') }}</th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr *ngFor=\"let provider of vm.searchResults\">\n        <td *ngIf=\"vm.hasDoctors\">\n          <ng-container *ngIf=\"isDoctorType(provider.field)\">\n            <ng-container\n              *ngIf=\"\n                      (vm.lerbFinderMode === LerbFinderMode.Provider && isStatusEqual(provider) && (provider?.aufnahme === '1' || provider?.aufnahme === 'Y')) ||\n                      vm.lerbFinderMode === LerbFinderMode.Doctor && (getAcceptPatientCodeByProduct(provider, vm.avmProduct) === '1' || getAcceptPatientCodeByProduct(provider, vm.avmProduct) === 'Y');\n                    then nimmtPatientenAuf, else nachAbspracheMitArzt\"\n            >\n            </ng-container>\n          </ng-container>\n          <ng-template #nimmtPatientenAuf>\n            <i class=\"ico--tick ico--12\"></i>\n          </ng-template>\n          <ng-template #nachAbspracheMitArzt>\n            <i class=\"ico--info ico--12\"></i>\n          </ng-template>\n        </td>\n        <td>{{ provider.vorname + ' ' + provider.name }}</td>\n        <td *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Provider\">\n          {{ getTranslatedCategory(provider.field) }}\n        </td>\n        <td>{{ provider.strasse }}</td>\n        <td>{{ provider.plz }}</td>\n        <td>{{ provider.ort }}</td>\n        <td>{{ provider.telefon }}</td>\n      </tr>\n    </tbody>\n  </table>\n</ng-container>\n", styles: ["table{border-collapse:collapse;overflow-y:auto;max-width:100%;width:100%}th{text-align:left;border-bottom:1px solid #707070;--font-family-base: \"AkkuratHelsanaTT Bold Web\", Helvetica, Arial, sans-serif}td,th{padding:8px}td{border-bottom:1px solid #e0e0e0}table tr:last-child td{border-bottom:none}table>tr,table th{vertical-align:bottom}.search-meta{padding:5px;margin-top:10px;border-bottom:1px solid #c0c0c0}.zip-column{width:7rem}.phone-column{min-width:15rem}.admission-legend{display:flex}.admission-legend span{margin-right:10px;font-size:var(--font-size-extra-small)}.table-lead{font-size:var(--font-size-large)}@media screen and (min-width: 1024px){table{overflow-y:unset}}@media print{table{empty-cells:hide;font-size:1rem}}\n"] }]
        }] });

const selectInputSearchState = createSelector(selectInputSearch, (inputSearch) => inputSearch.state);
const selectInputSearchInput = createSelector(selectInputSearch, (inputSearch) => inputSearch.input);
const selectInputSearchSelectedLerb = createSelector(selectInputSearch, (inputSearch) => inputSearch.selectedLerb);
const selectInputSearchSelectedZip = createSelector(selectInputSearch, (inputSearch) => inputSearch.selectedZip);
const selectInputSearchResults = createSelector(selectInputSearch, (inputSearch) => inputSearch.results);

const selectListCoordinates = createSelector(selectListProvidersByAvm, selectLerbFinderMode, (searchResults, lerbFinderType) => getMapMarkersCoordinates(searchResults, lerbFinderType));
// TODO Malvin now - what is needed, what not?
const selectSearchComponentVm = createSelector(selectLerbFinderMode, selectIsDesktop, selectInputSearchState, selectSearchState, selectDetailsBackToken, selectListProvidersByAvm, selectProvidersInViewport, selectDetailsProvider, selectLocationProviders, selectSelectedResultTab, selectListCoordinates, selectIsLocationActive, selectHoveredLocationId, selectSubmittedInput, selectMapUpdate, selectArea, selectIsOverlayMode, selectIsLoading, selectIsDirectSearchInput, (lerbFinderMode, isDesktop, inputSearchState, searchState, detailsBackToken, searchResults, providersInViewport, detailsProvider, locationProviders, selectedResultTab, listCoordinates, isCurrentUserLocationActive, hoveredLocationId, submittedInput, mapUpdate, area, isOverlayMode, isLoading, isDirectSearchInput) => {
    const searchSuccess = searchState === 'areaSuccess' ||
        searchState === 'locationSuccess' ||
        searchState === 'zipSuccess';
    return {
        searchResults,
        detailsProvider,
        locationProviders,
        selectedResultTab,
        providersInViewport,
        listCoordinates,
        isDesktop,
        detailsBackToken,
        lerbFinderMode,
        showMap: Boolean(!locationProviders?.length && !detailsProvider),
        showLocation: Boolean(locationProviders?.length && !detailsProvider),
        showDetails: Boolean(detailsProvider),
        isCurrentUserLocationActive,
        hoveredLocationId,
        isSearchButtonActive: inputSearchState === 'area' ||
            inputSearchState === 'adjust' ||
            inputSearchState === 'location' ||
            inputSearchState === 'zipSelected' ||
            inputSearchState === 'lerbSelected',
        isSearchResetButtonActive: inputSearchState === 'area' ||
            inputSearchState === 'adjust' ||
            inputSearchState === 'location' ||
            inputSearchState === 'providerSuccess' ||
            inputSearchState === 'providerFailure' ||
            inputSearchState === 'doctorSuccess' ||
            inputSearchState === 'doctorFailure' ||
            inputSearchState === 'lerbSelected' ||
            inputSearchState === 'zipSelected',
        isAdjustSearchButtonVisible: searchSuccess,
        isMapOverlayVisible: searchState === 'init',
        mapUpdate,
        searchSuccess,
        isSearchButtonClicked: !!submittedInput,
        hideAreaSearchButton: area.hideAreaSearchButton,
        isOverlayMode,
        isLoading,
        isDirectSearchInput,
    };
});

const selectLocationToken = createSelector(selectIsLocationActive, selectIsActivatingLocation, (isLocationActive, isActivatingLocation) => isLocationActive
    ? 'GeoLocationComponentSelector.aktuellerStandortWirdVerwendet'
    : isActivatingLocation
        ? 'GeoLocationComponentSelector.aktuellerStandortWirdGeladen'
        : 'GeoLocationComponentSelector.aktuellerStandortVerwenden');
const selectGeoLocationComponentVm = createSelector(selectIsLocationActive, selectLocation, selectIsActivatingLocation, selectLocationToken, (isLocationActive, location, isActivatingLocation, locationToken) => ({
    isLocationActive,
    isActivatingLocation,
    location,
    locationToken,
    checkboxColor: isLocationActive || isActivatingLocation ? colors.helsana : colors.black,
}));

class SpinnerComponent {
    constructor() {
        this.isVisible = true;
        this.diameter = '24';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: SpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: SpinnerComponent, isStandalone: true, selector: "helsana-spinner", inputs: { isVisible: "isVisible", diameter: "diameter" }, ngImport: i0, template: `
    <mat-spinner diameter="{{ diameter }}" *ngIf="isVisible"></mat-spinner>
  `, isInline: true, styles: ["helsana-spinner .mat-mdc-progress-spinner .mdc-circular-progress__determinate-circle,helsana-spinner .mat-mdc-progress-spinner .mdc-circular-progress__indeterminate-circle-graphic{stroke:#9a0941}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: MatProgressSpinnerModule }, { kind: "component", type: i2$3.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "mode", "value", "diameter", "strokeWidth"], exportAs: ["matProgressSpinner"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: SpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'helsana-spinner', imports: [CommonModule, MatProgressSpinnerModule], standalone: true, template: `
    <mat-spinner diameter="{{ diameter }}" *ngIf="isVisible"></mat-spinner>
  `, encapsulation: ViewEncapsulation.None, styles: ["helsana-spinner .mat-mdc-progress-spinner .mdc-circular-progress__determinate-circle,helsana-spinner .mat-mdc-progress-spinner .mdc-circular-progress__indeterminate-circle-graphic{stroke:#9a0941}\n"] }]
        }], propDecorators: { isVisible: [{
                type: Input
            }], diameter: [{
                type: Input
            }] } });

let GeoLocationFormControlButtonComponent = class GeoLocationFormControlButtonComponent {
    constructor() {
        this.store = inject(Store);
        this.vm$ = this.store.select(selectGeoLocationComponentVm);
        this.geoLocationFormGroup = new FormGroup({
            isLocationActive: new FormControl(false),
        });
    }
    ngOnInit() {
        this.vm$
            .pipe(untilDestroyed(this), map((vm) => this.geoLocationFormGroup
            .get('isLocationActive')
            ?.setValue(vm.isLocationActive, { emitEvent: false })))
            .subscribe();
        this.geoLocationFormGroup.valueChanges
            .pipe(untilDestroyed(this), tap(({ isLocationActive }) => this.store.dispatch(isLocationActiveCheckboxChanged({
            isLocationActive: !!isLocationActive,
        }))))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: GeoLocationFormControlButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: GeoLocationFormControlButtonComponent, isStandalone: true, selector: "helsana-geo-location-form-control-button", ngImport: i0, template: `
    <ng-container *rxLet="vm$; let vm">
      <form [formGroup]="geoLocationFormGroup">
        <shared-maps-ui-checkbox
          class="hls-ui-checkbox"
          *transloco="let t"
          [slim]="true"
          [fullWidth]="false"
          [label]="t(vm.locationToken)"
          [control]="geoLocationFormGroup.controls.isLocationActive"
        >
          <span matPrefix class="mx-2" [style.color]="vm.checkboxColor">
            <div class="prefix">
              <i *ngIf="!vm.isActivatingLocation" class="ico--ziel ico--24"></i>
              <helsana-spinner
                [isVisible]="vm.isActivatingLocation"
                [diameter]="'24'"
              ></helsana-spinner>
            </div>
          </span>
        </shared-maps-ui-checkbox>
      </form>
    </ng-container>
  `, isInline: true, styles: ["helsana-geo-location-form-control-button input[type=checkbox],helsana-geo-location-form-control-button .mdc-checkbox{-webkit-appearance:none;appearance:none;background-color:#fff;margin:0;display:none}helsana-geo-location-form-control-button .mdc-form-field label{display:flex;flex-direction:row-reverse;justify-content:flex-end;margin-top:0}helsana-geo-location-form-control-button .hls-ui-checkbox{display:block;margin-bottom:16px}helsana-geo-location-form-control-button .ico--24{display:block}helsana-geo-location-form-control-button .mat-mdc-progress-spinner .mdc-circular-progress__determinate-circle,helsana-geo-location-form-control-button .mat-mdc-progress-spinner .mdc-circular-progress__indeterminate-circle-graphic{stroke:#9a0941}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: UiCheckboxComponent, selector: "shared-maps-ui-checkbox", inputs: ["fullWidth", "id"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i2.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "ngmodule", type: LetModule }, { kind: "directive", type: i3.LetDirective, selector: "[rxLet]", inputs: ["rxLet", "rxLetStrategy", "rxLetComplete", "rxLetError", "rxLetSuspense", "rxLetContextTrigger", "rxLetCompleteTrigger", "rxLetErrorTrigger", "rxLetSuspenseTrigger", "rxLetNextTrigger", "rxLetRenderCallback", "rxLetParent", "rxLetPatchZone"], outputs: ["rendered"] }, { kind: "component", type: SpinnerComponent, selector: "helsana-spinner", inputs: ["isVisible", "diameter"] }], encapsulation: i0.ViewEncapsulation.None }); }
};
GeoLocationFormControlButtonComponent = __decorate([
    UntilDestroy()
], GeoLocationFormControlButtonComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: GeoLocationFormControlButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'helsana-geo-location-form-control-button', imports: [
                        CommonModule,
                        UiCheckboxComponent,
                        ReactiveFormsModule,
                        TranslocoModule,
                        LetModule,
                        SpinnerComponent,
                    ], standalone: true, template: `
    <ng-container *rxLet="vm$; let vm">
      <form [formGroup]="geoLocationFormGroup">
        <shared-maps-ui-checkbox
          class="hls-ui-checkbox"
          *transloco="let t"
          [slim]="true"
          [fullWidth]="false"
          [label]="t(vm.locationToken)"
          [control]="geoLocationFormGroup.controls.isLocationActive"
        >
          <span matPrefix class="mx-2" [style.color]="vm.checkboxColor">
            <div class="prefix">
              <i *ngIf="!vm.isActivatingLocation" class="ico--ziel ico--24"></i>
              <helsana-spinner
                [isVisible]="vm.isActivatingLocation"
                [diameter]="'24'"
              ></helsana-spinner>
            </div>
          </span>
        </shared-maps-ui-checkbox>
      </form>
    </ng-container>
  `, encapsulation: ViewEncapsulation.None, styles: ["helsana-geo-location-form-control-button input[type=checkbox],helsana-geo-location-form-control-button .mdc-checkbox{-webkit-appearance:none;appearance:none;background-color:#fff;margin:0;display:none}helsana-geo-location-form-control-button .mdc-form-field label{display:flex;flex-direction:row-reverse;justify-content:flex-end;margin-top:0}helsana-geo-location-form-control-button .hls-ui-checkbox{display:block;margin-bottom:16px}helsana-geo-location-form-control-button .ico--24{display:block}helsana-geo-location-form-control-button .mat-mdc-progress-spinner .mdc-circular-progress__determinate-circle,helsana-geo-location-form-control-button .mat-mdc-progress-spinner .mdc-circular-progress__indeterminate-circle-graphic{stroke:#9a0941}\n"] }]
        }] });

const selectDoctorFilterComponentVm = createSelector(selectDoctorFilterForm, selectIsValidSearchInput, selectIsDirectSearchInput, (doctorFilterForm, isValidSearchInput, directSearchInput) => ({
    acceptsNewPatients: doctorFilterForm.acceptsNewPatients,
    pediatriciansOnly: doctorFilterForm.pediatriciansOnly,
    isValidSearchInput,
    directSearchInput
}));

let DoctorFilterFormGroupComponent = class DoctorFilterFormGroupComponent {
    constructor() {
        this.store = inject(Store);
        this.vm$ = this.store.select(selectDoctorFilterComponentVm);
        this.doctorFilterFormGroup = new FormGroup({
            pediatriciansOnly: new FormControl(false),
            acceptsNewPatients: new FormControl(false),
        });
    }
    ngOnInit() {
        let initialVmEvent = true;
        this.vm$
            .pipe(untilDestroyed(this), tap((vm) => {
            this.doctorFilterFormGroup
                .get('pediatriciansOnly')
                ?.setValue(vm.pediatriciansOnly, {
                emitEvent: false,
            });
            this.doctorFilterFormGroup
                .get('acceptsNewPatients')
                ?.setValue(vm.acceptsNewPatients, {
                emitEvent: false,
            });
            vm.isValidSearchInput && !vm.directSearchInput
                ? this.doctorFilterFormGroup.enable({ emitEvent: false })
                : this.doctorFilterFormGroup.disable({ emitEvent: false });
            // Listen to control changes only when controls have already been initialized with vm values
            if (initialVmEvent) {
                this.subscribeToPediatriciansOnlyCheckboxChanges();
                this.subscribeToAcceptNewPatientsCheckboxChanges();
                initialVmEvent = false;
            }
        }))
            .subscribe();
    }
    subscribeToPediatriciansOnlyCheckboxChanges() {
        this.doctorFilterFormGroup
            .get('pediatriciansOnly')
            ?.valueChanges.pipe(untilDestroyed(this), tap((pediatriciansOnly) => this.store.dispatch(pediatriciansOnlyCheckboxChanged({
            pediatriciansOnly,
        }))))
            .subscribe();
    }
    subscribeToAcceptNewPatientsCheckboxChanges() {
        this.doctorFilterFormGroup
            .get('acceptsNewPatients')
            ?.valueChanges.pipe(untilDestroyed(this), tap((acceptsNewPatients) => this.store.dispatch(acceptsNewPatiensCheckboxChanged({
            acceptsNewPatients,
        }))))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: DoctorFilterFormGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: DoctorFilterFormGroupComponent, isStandalone: true, selector: "helsana-doctor-filter-form-group", ngImport: i0, template: "<div\n*transloco=\"let t\"\nclass=\"mt-2 rounded border border-gray-300 px-4 pb-2 pt-4\"\n>\n<div class=\"t-label-normal mb-3\">\n  {{ t('SearchComponent.filter') }}\n</div>\n\n<form [formGroup]=\"doctorFilterFormGroup\" class=\"flex flex-col\">\n  <shared-maps-ui-checkbox\n    data-testid=\"lerb-finder-search-acceptsNewPatients\"\n    [control]=\"doctorFilterFormGroup.controls.acceptsNewPatients\"\n    [label]=\"t('SearchComponent.acceptsNewPatients')\"\n  ></shared-maps-ui-checkbox>\n  <shared-maps-ui-checkbox\n    data-testid=\"lerb-finder-search-pediatriciansOnly\"\n    [control]=\"doctorFilterFormGroup.controls.pediatriciansOnly\"\n    [label]=\"t('SearchComponent.pediatriciansOnly')\"\n  ></shared-maps-ui-checkbox>\n</form>\n</div>\n", dependencies: [{ kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i2.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "component", type: UiCheckboxComponent, selector: "shared-maps-ui-checkbox", inputs: ["fullWidth", "id"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }] }); }
};
DoctorFilterFormGroupComponent = __decorate([
    UntilDestroy()
], DoctorFilterFormGroupComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: DoctorFilterFormGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'helsana-doctor-filter-form-group', standalone: true, imports: [NgIf, TranslocoModule, UiCheckboxComponent, ReactiveFormsModule], template: "<div\n*transloco=\"let t\"\nclass=\"mt-2 rounded border border-gray-300 px-4 pb-2 pt-4\"\n>\n<div class=\"t-label-normal mb-3\">\n  {{ t('SearchComponent.filter') }}\n</div>\n\n<form [formGroup]=\"doctorFilterFormGroup\" class=\"flex flex-col\">\n  <shared-maps-ui-checkbox\n    data-testid=\"lerb-finder-search-acceptsNewPatients\"\n    [control]=\"doctorFilterFormGroup.controls.acceptsNewPatients\"\n    [label]=\"t('SearchComponent.acceptsNewPatients')\"\n  ></shared-maps-ui-checkbox>\n  <shared-maps-ui-checkbox\n    data-testid=\"lerb-finder-search-pediatriciansOnly\"\n    [control]=\"doctorFilterFormGroup.controls.pediatriciansOnly\"\n    [label]=\"t('SearchComponent.pediatriciansOnly')\"\n  ></shared-maps-ui-checkbox>\n</form>\n</div>\n" }]
        }] });

const selectInputSearchComponentVm = createSelector(selectInputSearch, selectIsDesktop, ({ input, results, state, adjustSearch, initTimestamp }, isDesktop) => ({
    input,
    results: (results?.['results']?.map(getInputOption)) || [],
    adjustSearch,
    state,
    initTimestamp,
    isDesktop,
}));

let InputOptionFormGroupComponent = class InputOptionFormGroupComponent {
    constructor() {
        this.store = inject(Store);
        this.vm$ = this.store.select(selectInputSearchComponentVm);
        this.focus = false;
        this.inputControl = new FormControl(null);
        this.control = new FormControl(null);
    }
    ngOnInit() {
        let initialVmEvent = true;
        this.vm$
            .pipe(untilDestroyed(this), tap((vm) => {
            this.inputControl.setValue(vm.input, { emitEvent: false });
            // Listen to control changes only when controls have already been initialized with vm values
            if (initialVmEvent) {
                this.subscibeToInputChanges();
                initialVmEvent = false;
                if (vm.isDesktop) {
                    this.focus = true;
                    // workaround for Angular vs Lit focus onload issue
                    this.focusInput(1000);
                }
            }
            else {
                // don't set focus when adjust search was clicked
                const isNotAdjustSearch = !vm.adjustSearch;
                // init state is set only onload and if reset search button is clicked. In this case here reset search was clicked,
                // as the initialVMEvent is already false
                const isNotMobileViewInitState = !vm.isDesktop
                    ? vm.state !== 'init'
                    : true;
                this.focus = isNotAdjustSearch && isNotMobileViewInitState;
            }
        }))
            .subscribe();
    }
    subscibeToInputChanges() {
        this.inputControl.valueChanges
            .pipe(untilDestroyed(this), isTypeFilter, tap((input) => {
            this.store.dispatch(userChangedInput({ input }));
            if (typeof input === 'string')
                return;
            this.vm$.pipe(take(1)).subscribe((vm) => {
                if (vm.isDesktop || (!vm.isDesktop && isZipLocation(input))) {
                    timer(0).subscribe(() => this.autocomplete?.inputElement.nativeElement.blur());
                }
            });
        }))
            .subscribe();
    }
    inputResetButtonClicked() {
        this.store.dispatch(inputResetButtonClicked());
        this.focusInput(0);
    }
    focusInput(timeout) {
        timer(timeout).subscribe(() => {
            this.autocomplete?.inputElement.nativeElement.focus();
            this.autocomplete?.inputAutoComplete?.openPanel();
        });
    }
    blurAutocomplete() {
        this.focus = false;
        this.store.dispatch(blurAutocomplete());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: InputOptionFormGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: InputOptionFormGroupComponent, isStandalone: true, selector: "helsana-input-option-form-group", viewQueries: [{ propertyName: "autocomplete", first: true, predicate: UiAutocompleteComponent, descendants: true }], ngImport: i0, template: `
    <ng-container *rxLet="vm$; let vm">
      <input [formControl]="control" [attr.aria-label]="'Autocomplete Input'" />
      <div #toggleBlur></div>
      <form *transloco="let t">
        <shared-maps-ui-autocomplete
          #autocomplete
          data-testid="lerb-finder-search-searchInput"
          [control]="inputControl"
          [label]="t('SearchComponent.plzOrtName')"
          [options]="vm.results"
          [focus]="(vm.state === 'init' || vm.adjustSearch) && focus"
          (blurred)="blurAutocomplete()"
        >
          <div class="suffix">
            <i
              *ngIf="inputControl.value"
              (click)="inputResetButtonClicked()"
              class="ico--close ico--24 mr-2 cursor-pointer"
            >
            </i>
            <i class="ico--search ico--24"> </i>
          </div>
        </shared-maps-ui-autocomplete>
      </form>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i2.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "ngmodule", type: LetModule }, { kind: "directive", type: i3.LetDirective, selector: "[rxLet]", inputs: ["rxLet", "rxLetStrategy", "rxLetComplete", "rxLetError", "rxLetSuspense", "rxLetContextTrigger", "rxLetCompleteTrigger", "rxLetErrorTrigger", "rxLetSuspenseTrigger", "rxLetNextTrigger", "rxLetRenderCallback", "rxLetParent", "rxLetPatchZone"], outputs: ["rendered"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: UiAutocompleteComponent, selector: "shared-maps-ui-autocomplete", inputs: ["options", "focus", "hasDivide"], outputs: ["blurred", "optionSelected"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
};
InputOptionFormGroupComponent = __decorate([
    UntilDestroy()
], InputOptionFormGroupComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: InputOptionFormGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'helsana-input-option-form-group',
                    standalone: true,
                    imports: [
                        TranslocoModule,
                        LetModule,
                        ReactiveFormsModule,
                        UiAutocompleteComponent,
                        NgIf,
                    ],
                    template: `
    <ng-container *rxLet="vm$; let vm">
      <input [formControl]="control" [attr.aria-label]="'Autocomplete Input'" />
      <div #toggleBlur></div>
      <form *transloco="let t">
        <shared-maps-ui-autocomplete
          #autocomplete
          data-testid="lerb-finder-search-searchInput"
          [control]="inputControl"
          [label]="t('SearchComponent.plzOrtName')"
          [options]="vm.results"
          [focus]="(vm.state === 'init' || vm.adjustSearch) && focus"
          (blurred)="blurAutocomplete()"
        >
          <div class="suffix">
            <i
              *ngIf="inputControl.value"
              (click)="inputResetButtonClicked()"
              class="ico--close ico--24 mr-2 cursor-pointer"
            >
            </i>
            <i class="ico--search ico--24"> </i>
          </div>
        </shared-maps-ui-autocomplete>
      </form>
    </ng-container>
  `,
                }]
        }], propDecorators: { autocomplete: [{
                type: ViewChild,
                args: [UiAutocompleteComponent]
            }] } });

class ObserveVisibilityDirective {
    constructor() {
        this.debounceTime = 0;
        this.threshold = 1; // threshold property indicates at what percentage the callback should be executed
        this.isContinuous = false;
        this.intersecting = new EventEmitter();
        this.elementRef = inject(ElementRef);
        this.subject$ = new Subject();
        this.options = {
            rootMargin: '0px',
            threshold: 0,
        };
    }
    ngOnInit() {
        this.createObserver();
    }
    ngAfterViewInit() {
        this.startObservingElements();
    }
    ngOnDestroy() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = undefined;
        }
        this.subject$.next(null);
        this.subject$.complete();
    }
    createObserver() {
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (this.isEntryIntersecting(entry)) {
                    this.subject$.next({ entry, observer: this.observer });
                }
            });
        }, { ...this.options, threshold: this.threshold });
    }
    startObservingElements() {
        if (!this.observer) {
            return;
        }
        this.observer.observe(this.elementRef.nativeElement);
        this.subject$
            .pipe(delay(this.debounceTime), filter(Boolean))
            .subscribe(({ entry, observer }) => {
            const { isIntersecting } = entry;
            if (!this.isContinuous) {
                observer.disconnect();
            }
            this.intersecting.emit({ isIntersecting });
        });
    }
    isEntryIntersecting(entry) {
        return entry.isIntersecting || entry.intersectionRatio > 0;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ObserveVisibilityDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.3", type: ObserveVisibilityDirective, isStandalone: true, selector: "[helsanaObserveVisibility]", inputs: { debounceTime: "debounceTime", threshold: "threshold", isContinuous: "isContinuous" }, outputs: { intersecting: "intersecting" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: ObserveVisibilityDirective, decorators: [{
            type: Directive,
            args: [{
                    standalone: true,
                    selector: '[helsanaObserveVisibility]',
                }]
        }], propDecorators: { debounceTime: [{
                type: Input
            }], threshold: [{
                type: Input
            }], isContinuous: [{
                type: Input
            }], intersecting: [{
                type: Output
            }] } });

let LerbFinderSearchComponent = class LerbFinderSearchComponent {
    constructor(elRef) {
        this.elRef = elRef;
        this.store = inject(Store);
        this.scrollingService = inject(ScrollingService);
        this.LerbFinderMode = LerbFinderMode;
        this.activeFirstOptionSelectionLabel = '';
        this.resultsId = 'hausarzt-results';
        this.adjustSearchButtonId = 'adjust-search-button';
        this.mapHeightDesktop = mapHeightDesktop;
        this.listWidthDesktop = listWidthDesktop;
        this.mapHeightMobile = mapHeightMobile;
        this.mapHeightMobileWithAdjustSearchButton = mapHeightMobileWithAdjustSearchButton;
        this.maxWidth = '1024px';
        this.maxWidthForm = '676px';
        this.isMobile = false;
        this.intersection = { isIntersecting: false };
        this.isDirectSearchInput = false;
        this.vm$ = this.store.select(selectSearchComponentVm);
    }
    ngOnInit() {
        this.store.dispatch(onInit$4());
        this.rootNode = this.getRootNode();
        if (this.rootNode) {
            this.scrollingService.rootNode = this.rootNode;
        }
        this.vm$
            .pipe(untilDestroyed(this), tap((vm) => {
            this.isDirectSearchInput = vm.isDirectSearchInput;
            this.isMobile = !vm.isDesktop;
            this.mapHeight = this.getMapHeight(vm.isDesktop, vm.isAdjustSearchButtonVisible);
        }))
            .subscribe();
    }
    ngOnDestroy() {
        this.store.dispatch(onDestroy());
    }
    closeButtonClicked() {
        this.store.dispatch(overlayCloseButtonClicked());
    }
    selectProvider(id) {
        this.store.dispatch(selectProvider$2({ id }));
    }
    intersectionChanged($event) {
        this.intersection = $event;
    }
    async searchButtonClicked(isSearchButtonActive) {
        const { isIntersecting } = this.intersection;
        if (!isSearchButtonActive || this.isDirectSearchInput)
            return;
        this.store.dispatch(searchButtonClicked({
            isIntersecting: this.isMobile ? false : isIntersecting,
        }));
        const element = await this.scrollingService.isElementLoaded('hausarzt-results');
        if (element) {
            this.scrollingService.setScrollEvent(ScrollingClickEvent.SearchButtonClickedEvent, element);
        }
    }
    async adjustSearchButtonClicked() {
        this.store.dispatch(adjustSearchButtonClicked$1());
        const element = await this.scrollingService.isElementLoaded('overlay-scrollable');
        if (element) {
            this.scrollingService.setScrollEvent(ScrollingClickEvent.AdjustSearchButtonClickedEvent, element);
        }
    }
    // !! Google Maps Component
    // !! /////////////////////
    mapClicked() {
        this.store.dispatch(mapClicked());
    }
    mapMarkerClicked(marker) {
        const coordinates = this.getCoordinates(marker);
        if (coordinates) {
            this.store.dispatch(mapMarkerClicked({ coordinates }));
        }
    }
    markerHovered(marker) {
        if (!marker) {
            this.store.dispatch(mapMarkerHovered({ coordinates: null }));
            return;
        }
        const coordinates = this.getCoordinates(marker);
        if (coordinates) {
            this.store.dispatch(mapMarkerHovered({ coordinates }));
        }
    }
    mapUpdated(mapUpdate) {
        this.store.dispatch(mapUpdated({ mapUpdate }));
    }
    overlayCloseButtonClicked() {
        this.store.dispatch(overlayCloseButtonClicked());
    }
    resetButtonClicked(isSearchResetButtonActive) {
        if (!isSearchResetButtonActive)
            return;
        this.store.dispatch(resetSearchFields());
    }
    selectResultTab(tab) {
        this.store.dispatch(selectResultTab({ tab }));
    }
    detailsBackClicked(id) {
        this.store.dispatch(detailsBackClicked({ id }));
    }
    locationBackClicked() {
        this.store.dispatch(locationBackClicked());
    }
    getRootNode() {
        // Needed for AEM integration as shadow root is used there. Fallback is document
        return (this.elRef.nativeElement.getRootNode()?.host?.shadowRoot ||
            document);
    }
    getCoordinates(marker) {
        const lat = marker.getPosition()?.lat();
        const lng = marker.getPosition()?.lng();
        return lat && lng ? { lat, lng } : null;
    }
    getMapHeight(isDesktop, adjustSearchButtonActive) {
        if (isDesktop) {
            return this.mapHeightDesktop;
        }
        else {
            return adjustSearchButtonActive
                ? this.mapHeightMobileWithAdjustSearchButton
                : this.mapHeightMobile;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LerbFinderSearchComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: LerbFinderSearchComponent, isStandalone: true, selector: "helsana-lerb-finder-search", inputs: { activeFirstOptionSelectionLabel: "activeFirstOptionSelectionLabel" }, viewQueries: [{ propertyName: "googleMapsComponent", first: true, predicate: GoogleMapsComponent, descendants: true }], ngImport: i0, template: "<ng-container *rxLet=\"vm$; let vm\">\n  <ng-container *ngIf=\"vm.providersInViewport\">\n    <helsana-print-view />\n  </ng-container>\n  <div *transloco=\"let t\">\n    <shared-maps-ui-overlay-header\n      *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Doctor && vm.isOverlayMode\"\n      class=\"block w-full\"\n      [ngClass]=\"{ 'p-4': !vm.isDesktop, 'pb-4': vm.isDesktop }\"\n      [title]=\"t('SearchComponent.title')\"\n      (closeEvent)=\"overlayCloseButtonClicked()\"\n    ></shared-maps-ui-overlay-header>\n    <div\n      class=\"m-auto pb-4\"\n      [ngClass]=\"{ 'pl-4': !vm.isDesktop, 'pr-4': !vm.isDesktop }\"\n      [style.max-width]=\"maxWidth\"\n      id=\"overlay-scrollable\"\n    >\n      <div [style.max-width]=\"maxWidthForm\">\n        <helsana-input-option-form-group class=\"mt-6\" />\n        <helsana-geo-location-form-control-button />\n        <helsana-doctor-filter-form-group\n          *ngIf=\"vm.lerbFinderMode === 'Doctor'\"\n        />\n        <helsana-provider-filter-form-group\n          *ngIf=\"vm.lerbFinderMode === 'Provider'\"\n        />\n\n        <div class=\"mt-10 md:mb-6 md:mt-10 md:flex\">\n          <button\n            class=\"btn primary\"\n            [ngClass]=\"{ disabled: !vm.isSearchButtonActive }\"\n            (click)=\"searchButtonClicked(vm.isSearchButtonActive)\"\n          >\n            {{ t('SearchComponent.suchen') }}\n          </button>\n\n          <button\n            data-testid=\"lerb-finder-search-reset\"\n            class=\"btn reset my-4 flex justify-center gap-2 leading-7 md:my-auto md:ml-4 md:inline-flex md:w-fit\"\n            [ngClass]=\"{\n              'text-gray-400': !vm.isSearchResetButtonActive,\n              'cursor-pointer': vm.isSearchResetButtonActive,\n              'cursor-default': !vm.isSearchResetButtonActive,\n              'disabled': !vm.isSearchResetButtonActive,\n            }\"\n            (click)=\"resetButtonClicked(vm.isSearchResetButtonActive)\"\n          >\n            <span class=\"ico--reload ico--28\"></span>\n            {{ t('SearchComponent.sucheZuruecksetzen') }}\n          </button>\n        </div>\n      </div>\n    </div>\n\n    <div\n      id=\"{{ resultsId }}\"\n      helsanaObserveVisibility\n      [threshold]=\"0.5\"\n      [isContinuous]=\"vm.isDesktop\"\n      (intersecting)=\"intersectionChanged($event)\"\n    >\n      <ng-container>\n        <!-- Desktop-->\n        <div *ngIf=\"vm.isDesktop\">\n          <div\n            *ngIf=\"vm.isLoading\"\n            class=\"spinner mt-14 flex flex-col items-center justify-center\"\n          >\n            <helsana-spinner\n              [isVisible]=\"vm.isLoading\"\n              [diameter]=\"'56'\"\n            ></helsana-spinner>\n          </div>\n          <div *ngIf=\"!vm.isLoading\" class=\"flex border-t border-gray-300\">\n            <div\n              class=\"t-label-bold helsana-shadow-bottom border-r border-gray-300 p-5\"\n              [style.min-width]=\"listWidthDesktop\"\n            >\n              <span *ngIf=\"vm.showMap && vm.providersInViewport\">\n                <ng-container *ngTemplateOutlet=\"ergebnisse\"></ng-container>\n              </span>\n\n              <span *ngIf=\"vm.showDetails\">\n                <a\n                  class=\"link-back\"\n                  (click)=\"detailsBackClicked(vm.detailsProvider?.id)\"\n                  >{{ t(vm.detailsBackToken) }}</a\n                >\n              </span>\n              <span *ngIf=\"vm.showLocation\">\n                <a class=\"link-back\" (click)=\"locationBackClicked()\">{{\n                  t('SearchComponent.zurueckZuResultaten')\n                }}</a>\n              </span>\n            </div>\n          </div>\n          <div class=\"relative\" *ngIf=\"!vm.isLoading\">\n            <ng-container *ngTemplateOutlet=\"mapOverlay\"></ng-container>\n            <ng-container *ngTemplateOutlet=\"desktopFilter\"></ng-container>\n          </div>\n\n          <div class=\"flex\" *ngIf=\"vm.showMap && !vm.isLoading\">\n            <div\n              *ngIf=\"!vm.isMapOverlayVisible\"\n              id=\"hausarzt-list-desktop\"\n              class=\"relative overflow-y-scroll\"\n              [style.height]=\"mapHeight\"\n              [style.min-width]=\"listWidthDesktop\"\n              [style.max-width]=\"listWidthDesktop\"\n            >\n              <div\n                *ngIf=\"!vm.isLoading && vm.providersInViewport?.length === 0\"\n                class=\"p-5\"\n              >\n                {{ t('SearchComponent.keineErgebnisse') }}\n              </div>\n              <helsana-list\n                *ngIf=\"!vm.isLoading && vm.providersInViewport?.length\"\n                (providerClicked)=\"selectProvider($event.id)\"\n              ></helsana-list>\n            </div>\n\n            <helsana-google-maps\n              *ngIf=\"mapHeight\"\n              [height]=\"mapHeight\"\n              [activateMarkerOnClick]=\"true\"\n              [coordinates]=\"vm.listCoordinates || []\"\n              (markerClicked)=\"mapMarkerClicked($event)\"\n              (mapClicked)=\"mapClicked()\"\n              (markerHovered)=\"markerHovered($event)\"\n              (mapUpdated)=\"mapUpdated($event)\"\n              [showAreaSearchButton]=\"true\"\n              [isMapOverlayVisible]=\"vm.isMapOverlayVisible\"\n              [isDesktop]=\"vm.isDesktop\"\n            ></helsana-google-maps>\n          </div>\n\n          <helsana-location-view\n            *ngIf=\"vm.showLocation\"\n          ></helsana-location-view>\n          <helsana-details-view *ngIf=\"vm.showDetails\"></helsana-details-view>\n        </div>\n\n        <!-- Tablet & Mobile-->\n        <div *ngIf=\"!vm.isDesktop\" class=\"w-full\">\n          <div class=\"flex border-t border-gray-300\">\n            <div\n              class=\"t-label-bold flex flex-grow self-stretch border-gray-300 p-5\"\n            >\n              <ng-container *ngTemplateOutlet=\"ergebnisse\"></ng-container>\n            </div>\n            <div\n              class=\"flex flex-grow-0 cursor-pointer self-stretch border-x border-gray-300 p-4\"\n              [ngClass]=\"{\n                'border-b-4 border-b-black': vm.selectedResultTab === 'map'\n              }\"\n              (click)=\"selectResultTab('map')\"\n            >\n              {{ t('SearchComponent.karte') }}\n            </div>\n            <div\n              class=\"flex flex-grow-0 self-stretch p-4\"\n              [ngClass]=\"{\n                'text-gray-400': !vm.searchSuccess,\n                'cursor-pointer': vm.searchSuccess,\n                'border-b-4 border-b-black': vm.selectedResultTab === 'list'\n              }\"\n              (click)=\"vm.searchSuccess && selectResultTab('list')\"\n            >\n              {{ t('SearchComponent.liste') }}\n            </div>\n          </div>\n          <div\n            id=\"adjust-search-button\"\n            *ngIf=\"vm.isAdjustSearchButtonVisible\"\n            class=\"border-t border-gray-300 p-4 text-center\"\n          >\n            <button class=\"btn black\" (click)=\"adjustSearchButtonClicked()\">\n              <span class=\"ico--search ico--24 mr-3\"></span>\n              {{ t('SearchComponent.sucheAnpassen') }}\n            </button>\n          </div>\n\n          <div [hidden]=\"vm.selectedResultTab !== 'map'\" class=\"relative\">\n            <ng-container *ngTemplateOutlet=\"mapOverlay\"></ng-container>\n            <helsana-google-maps\n              *ngIf=\"mapHeight\"\n              [height]=\"mapHeight\"\n              [activateMarkerOnClick]=\"true\"\n              [coordinates]=\"vm.listCoordinates || []\"\n              (markerClicked)=\"mapMarkerClicked($event)\"\n              (mapClicked)=\"mapClicked()\"\n              (mapUpdated)=\"mapUpdated($event)\"\n              [showAreaSearchButton]=\"true\"\n              [isMapOverlayVisible]=\"vm.isMapOverlayVisible\"\n              [isDesktop]=\"vm.isDesktop\"\n            ></helsana-google-maps>\n\n            <helsana-map-preview-panel></helsana-map-preview-panel>\n          </div>\n\n          <div\n            *ngIf=\"vm.selectedResultTab === 'list'\"\n            class=\"h-[90vh] min-h-[300px] w-full overflow-y-scroll border-t border-gray-300\"\n          >\n            <div class=\"p-4\" *ngIf=\"vm.searchResults === null\">\n              {{ t('SearchComponent.sucheHinweis') }}\n            </div>\n\n            <ng-container *ngIf=\"vm.providersInViewport\">\n              <div class=\"p-4\" *ngIf=\"vm.providersInViewport.length === 0\">\n                {{ t('SearchComponent.keineErgebnisse') }}\n              </div>\n              <helsana-list\n                (providerClicked)=\"selectProvider($event.id)\"\n              ></helsana-list>\n            </ng-container>\n          </div>\n        </div>\n      </ng-container>\n    </div>\n\n    <!--Templates-->\n    <ng-template #mapOverlay>\n      <div\n        class=\"absolute z-10 w-full\"\n        [style.height]=\"mapHeight\"\n        *ngIf=\"vm.isMapOverlayVisible\"\n      >\n        <div\n          class=\"flex h-full items-center justify-center bg-black bg-opacity-60\"\n        >\n          <div class=\"p-8 text-center text-white\">\n            <div class=\"ico--search ico--52 mb-4\"></div>\n            <div class=\"t-h2\">\n              {{ t('SearchComponent.sucheHinweis') }}\n            </div>\n          </div>\n        </div>\n      </div>\n    </ng-template>\n\n    <ng-template #ergebnisse>\n      {{ vm.providersInViewport?.length || 0 }}\n      {{\n        vm.providersInViewport?.length !== 1\n          ? t('SearchComponent.ergebnisse')\n          : t('SearchComponent.ergebnis')\n      }}\n    </ng-template>\n\n    <ng-template #desktopFilter>\n      <helsana-quick-access-filter></helsana-quick-access-filter>\n    </ng-template>\n  </div>\n</ng-container>\n", styles: ["@media print{helsana-print-view+div{display:none}}@media screen{helsana-print-view{display:none}.preview-panel{position:absolute;bottom:0;left:0;width:100%}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: UiOverlayHeaderComponent, selector: "shared-maps-ui-overlay-header", inputs: ["title"], outputs: ["closeEvent"] }, { kind: "ngmodule", type: TranslocoModule }, { kind: "directive", type: i2.TranslocoDirective, selector: "[transloco]", inputs: ["transloco", "translocoParams", "translocoScope", "translocoRead", "translocoLang", "translocoLoadingTpl"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "component", type: GoogleMapsComponent, selector: "helsana-google-maps", inputs: ["height", "showZoomControl", "activateMarkerOnClick", "gestureHandling", "showAreaSearchButton", "isMapOverlayVisible", "isDesktop", "coordinates"], outputs: ["markerClicked", "markerHovered", "mapClicked", "mapUpdated"] }, { kind: "ngmodule", type: LetModule }, { kind: "directive", type: i3.LetDirective, selector: "[rxLet]", inputs: ["rxLet", "rxLetStrategy", "rxLetComplete", "rxLetError", "rxLetSuspense", "rxLetContextTrigger", "rxLetCompleteTrigger", "rxLetErrorTrigger", "rxLetSuspenseTrigger", "rxLetNextTrigger", "rxLetRenderCallback", "rxLetParent", "rxLetPatchZone"], outputs: ["rendered"] }, { kind: "component", type: ListComponent, selector: "helsana-list", outputs: ["providerClicked"] }, { kind: "component", type: DetailsViewComponent, selector: "helsana-details-view" }, { kind: "component", type: LocationViewComponent, selector: "helsana-location-view" }, { kind: "component", type: MapPreviewPanelComponent, selector: "helsana-map-preview-panel" }, { kind: "component", type: ProviderFilterFormGroupComponent, selector: "helsana-provider-filter-form-group" }, { kind: "component", type: QuickAccessFilterComponent, selector: "helsana-quick-access-filter" }, { kind: "component", type: PrintViewComponent, selector: "helsana-print-view" }, { kind: "directive", type: ObserveVisibilityDirective, selector: "[helsanaObserveVisibility]", inputs: ["debounceTime", "threshold", "isContinuous"], outputs: ["intersecting"] }, { kind: "component", type: GeoLocationFormControlButtonComponent, selector: "helsana-geo-location-form-control-button" }, { kind: "component", type: DoctorFilterFormGroupComponent, selector: "helsana-doctor-filter-form-group" }, { kind: "component", type: InputOptionFormGroupComponent, selector: "helsana-input-option-form-group" }, { kind: "component", type: SpinnerComponent, selector: "helsana-spinner", inputs: ["isVisible", "diameter"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
};
LerbFinderSearchComponent = __decorate([
    UntilDestroy(),
    __metadata("design:paramtypes", [ElementRef])
], LerbFinderSearchComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: LerbFinderSearchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'helsana-lerb-finder-search', standalone: true, imports: [
                        CommonModule,
                        UiOverlayHeaderComponent,
                        TranslocoModule,
                        ReactiveFormsModule,
                        GoogleMapsComponent,
                        LetModule,
                        ListComponent,
                        DetailsViewComponent,
                        LocationViewComponent,
                        MapPreviewPanelComponent,
                        ProviderFilterFormGroupComponent,
                        QuickAccessFilterComponent,
                        PrintViewComponent,
                        ObserveVisibilityDirective,
                        GeoLocationFormControlButtonComponent,
                        DoctorFilterFormGroupComponent,
                        InputOptionFormGroupComponent,
                        SpinnerComponent,
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *rxLet=\"vm$; let vm\">\n  <ng-container *ngIf=\"vm.providersInViewport\">\n    <helsana-print-view />\n  </ng-container>\n  <div *transloco=\"let t\">\n    <shared-maps-ui-overlay-header\n      *ngIf=\"vm.lerbFinderMode === LerbFinderMode.Doctor && vm.isOverlayMode\"\n      class=\"block w-full\"\n      [ngClass]=\"{ 'p-4': !vm.isDesktop, 'pb-4': vm.isDesktop }\"\n      [title]=\"t('SearchComponent.title')\"\n      (closeEvent)=\"overlayCloseButtonClicked()\"\n    ></shared-maps-ui-overlay-header>\n    <div\n      class=\"m-auto pb-4\"\n      [ngClass]=\"{ 'pl-4': !vm.isDesktop, 'pr-4': !vm.isDesktop }\"\n      [style.max-width]=\"maxWidth\"\n      id=\"overlay-scrollable\"\n    >\n      <div [style.max-width]=\"maxWidthForm\">\n        <helsana-input-option-form-group class=\"mt-6\" />\n        <helsana-geo-location-form-control-button />\n        <helsana-doctor-filter-form-group\n          *ngIf=\"vm.lerbFinderMode === 'Doctor'\"\n        />\n        <helsana-provider-filter-form-group\n          *ngIf=\"vm.lerbFinderMode === 'Provider'\"\n        />\n\n        <div class=\"mt-10 md:mb-6 md:mt-10 md:flex\">\n          <button\n            class=\"btn primary\"\n            [ngClass]=\"{ disabled: !vm.isSearchButtonActive }\"\n            (click)=\"searchButtonClicked(vm.isSearchButtonActive)\"\n          >\n            {{ t('SearchComponent.suchen') }}\n          </button>\n\n          <button\n            data-testid=\"lerb-finder-search-reset\"\n            class=\"btn reset my-4 flex justify-center gap-2 leading-7 md:my-auto md:ml-4 md:inline-flex md:w-fit\"\n            [ngClass]=\"{\n              'text-gray-400': !vm.isSearchResetButtonActive,\n              'cursor-pointer': vm.isSearchResetButtonActive,\n              'cursor-default': !vm.isSearchResetButtonActive,\n              'disabled': !vm.isSearchResetButtonActive,\n            }\"\n            (click)=\"resetButtonClicked(vm.isSearchResetButtonActive)\"\n          >\n            <span class=\"ico--reload ico--28\"></span>\n            {{ t('SearchComponent.sucheZuruecksetzen') }}\n          </button>\n        </div>\n      </div>\n    </div>\n\n    <div\n      id=\"{{ resultsId }}\"\n      helsanaObserveVisibility\n      [threshold]=\"0.5\"\n      [isContinuous]=\"vm.isDesktop\"\n      (intersecting)=\"intersectionChanged($event)\"\n    >\n      <ng-container>\n        <!-- Desktop-->\n        <div *ngIf=\"vm.isDesktop\">\n          <div\n            *ngIf=\"vm.isLoading\"\n            class=\"spinner mt-14 flex flex-col items-center justify-center\"\n          >\n            <helsana-spinner\n              [isVisible]=\"vm.isLoading\"\n              [diameter]=\"'56'\"\n            ></helsana-spinner>\n          </div>\n          <div *ngIf=\"!vm.isLoading\" class=\"flex border-t border-gray-300\">\n            <div\n              class=\"t-label-bold helsana-shadow-bottom border-r border-gray-300 p-5\"\n              [style.min-width]=\"listWidthDesktop\"\n            >\n              <span *ngIf=\"vm.showMap && vm.providersInViewport\">\n                <ng-container *ngTemplateOutlet=\"ergebnisse\"></ng-container>\n              </span>\n\n              <span *ngIf=\"vm.showDetails\">\n                <a\n                  class=\"link-back\"\n                  (click)=\"detailsBackClicked(vm.detailsProvider?.id)\"\n                  >{{ t(vm.detailsBackToken) }}</a\n                >\n              </span>\n              <span *ngIf=\"vm.showLocation\">\n                <a class=\"link-back\" (click)=\"locationBackClicked()\">{{\n                  t('SearchComponent.zurueckZuResultaten')\n                }}</a>\n              </span>\n            </div>\n          </div>\n          <div class=\"relative\" *ngIf=\"!vm.isLoading\">\n            <ng-container *ngTemplateOutlet=\"mapOverlay\"></ng-container>\n            <ng-container *ngTemplateOutlet=\"desktopFilter\"></ng-container>\n          </div>\n\n          <div class=\"flex\" *ngIf=\"vm.showMap && !vm.isLoading\">\n            <div\n              *ngIf=\"!vm.isMapOverlayVisible\"\n              id=\"hausarzt-list-desktop\"\n              class=\"relative overflow-y-scroll\"\n              [style.height]=\"mapHeight\"\n              [style.min-width]=\"listWidthDesktop\"\n              [style.max-width]=\"listWidthDesktop\"\n            >\n              <div\n                *ngIf=\"!vm.isLoading && vm.providersInViewport?.length === 0\"\n                class=\"p-5\"\n              >\n                {{ t('SearchComponent.keineErgebnisse') }}\n              </div>\n              <helsana-list\n                *ngIf=\"!vm.isLoading && vm.providersInViewport?.length\"\n                (providerClicked)=\"selectProvider($event.id)\"\n              ></helsana-list>\n            </div>\n\n            <helsana-google-maps\n              *ngIf=\"mapHeight\"\n              [height]=\"mapHeight\"\n              [activateMarkerOnClick]=\"true\"\n              [coordinates]=\"vm.listCoordinates || []\"\n              (markerClicked)=\"mapMarkerClicked($event)\"\n              (mapClicked)=\"mapClicked()\"\n              (markerHovered)=\"markerHovered($event)\"\n              (mapUpdated)=\"mapUpdated($event)\"\n              [showAreaSearchButton]=\"true\"\n              [isMapOverlayVisible]=\"vm.isMapOverlayVisible\"\n              [isDesktop]=\"vm.isDesktop\"\n            ></helsana-google-maps>\n          </div>\n\n          <helsana-location-view\n            *ngIf=\"vm.showLocation\"\n          ></helsana-location-view>\n          <helsana-details-view *ngIf=\"vm.showDetails\"></helsana-details-view>\n        </div>\n\n        <!-- Tablet & Mobile-->\n        <div *ngIf=\"!vm.isDesktop\" class=\"w-full\">\n          <div class=\"flex border-t border-gray-300\">\n            <div\n              class=\"t-label-bold flex flex-grow self-stretch border-gray-300 p-5\"\n            >\n              <ng-container *ngTemplateOutlet=\"ergebnisse\"></ng-container>\n            </div>\n            <div\n              class=\"flex flex-grow-0 cursor-pointer self-stretch border-x border-gray-300 p-4\"\n              [ngClass]=\"{\n                'border-b-4 border-b-black': vm.selectedResultTab === 'map'\n              }\"\n              (click)=\"selectResultTab('map')\"\n            >\n              {{ t('SearchComponent.karte') }}\n            </div>\n            <div\n              class=\"flex flex-grow-0 self-stretch p-4\"\n              [ngClass]=\"{\n                'text-gray-400': !vm.searchSuccess,\n                'cursor-pointer': vm.searchSuccess,\n                'border-b-4 border-b-black': vm.selectedResultTab === 'list'\n              }\"\n              (click)=\"vm.searchSuccess && selectResultTab('list')\"\n            >\n              {{ t('SearchComponent.liste') }}\n            </div>\n          </div>\n          <div\n            id=\"adjust-search-button\"\n            *ngIf=\"vm.isAdjustSearchButtonVisible\"\n            class=\"border-t border-gray-300 p-4 text-center\"\n          >\n            <button class=\"btn black\" (click)=\"adjustSearchButtonClicked()\">\n              <span class=\"ico--search ico--24 mr-3\"></span>\n              {{ t('SearchComponent.sucheAnpassen') }}\n            </button>\n          </div>\n\n          <div [hidden]=\"vm.selectedResultTab !== 'map'\" class=\"relative\">\n            <ng-container *ngTemplateOutlet=\"mapOverlay\"></ng-container>\n            <helsana-google-maps\n              *ngIf=\"mapHeight\"\n              [height]=\"mapHeight\"\n              [activateMarkerOnClick]=\"true\"\n              [coordinates]=\"vm.listCoordinates || []\"\n              (markerClicked)=\"mapMarkerClicked($event)\"\n              (mapClicked)=\"mapClicked()\"\n              (mapUpdated)=\"mapUpdated($event)\"\n              [showAreaSearchButton]=\"true\"\n              [isMapOverlayVisible]=\"vm.isMapOverlayVisible\"\n              [isDesktop]=\"vm.isDesktop\"\n            ></helsana-google-maps>\n\n            <helsana-map-preview-panel></helsana-map-preview-panel>\n          </div>\n\n          <div\n            *ngIf=\"vm.selectedResultTab === 'list'\"\n            class=\"h-[90vh] min-h-[300px] w-full overflow-y-scroll border-t border-gray-300\"\n          >\n            <div class=\"p-4\" *ngIf=\"vm.searchResults === null\">\n              {{ t('SearchComponent.sucheHinweis') }}\n            </div>\n\n            <ng-container *ngIf=\"vm.providersInViewport\">\n              <div class=\"p-4\" *ngIf=\"vm.providersInViewport.length === 0\">\n                {{ t('SearchComponent.keineErgebnisse') }}\n              </div>\n              <helsana-list\n                (providerClicked)=\"selectProvider($event.id)\"\n              ></helsana-list>\n            </ng-container>\n          </div>\n        </div>\n      </ng-container>\n    </div>\n\n    <!--Templates-->\n    <ng-template #mapOverlay>\n      <div\n        class=\"absolute z-10 w-full\"\n        [style.height]=\"mapHeight\"\n        *ngIf=\"vm.isMapOverlayVisible\"\n      >\n        <div\n          class=\"flex h-full items-center justify-center bg-black bg-opacity-60\"\n        >\n          <div class=\"p-8 text-center text-white\">\n            <div class=\"ico--search ico--52 mb-4\"></div>\n            <div class=\"t-h2\">\n              {{ t('SearchComponent.sucheHinweis') }}\n            </div>\n          </div>\n        </div>\n      </div>\n    </ng-template>\n\n    <ng-template #ergebnisse>\n      {{ vm.providersInViewport?.length || 0 }}\n      {{\n        vm.providersInViewport?.length !== 1\n          ? t('SearchComponent.ergebnisse')\n          : t('SearchComponent.ergebnis')\n      }}\n    </ng-template>\n\n    <ng-template #desktopFilter>\n      <helsana-quick-access-filter></helsana-quick-access-filter>\n    </ng-template>\n  </div>\n</ng-container>\n", styles: ["@media print{helsana-print-view+div{display:none}}@media screen{helsana-print-view{display:none}.preview-panel{position:absolute;bottom:0;left:0;width:100%}}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { googleMapsComponent: [{
                type: ViewChild,
                args: [GoogleMapsComponent]
            }], activeFirstOptionSelectionLabel: [{
                type: Input
            }] } });

const lerbFinderRoutes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: SEARCH,
    },
    {
        path: SEARCH,
        component: LerbFinderSearchComponent,
    },
    {
        path: DETAILS,
        component: DetailsViewComponent,
    },
    {
        path: LOCATION,
        component: LocationViewComponent,
    },
];

function provideLerbFinder() {
    return makeEnvironmentProviders([
        provideRouter([
            {
                path: '',
                component: ShellComponent,
                children: lerbFinderRoutes,
            },
        ]),
        importProvidersFrom(TranslocoModule),
        provideHttpClient(withJsonpSupport()),
        provideAnimations(),
        importProvidersFrom(I18nModule.forRoot()),
        provideStore({ router: routerReducer }),
        provideRouterStore(),
        provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
        provideState(lerbFinderFeature),
        provideEffects([LerbFinderEffects]),
    ]);
}

/**
 * Generated bundle index. Do not edit.
 */

export { AVMProduct, HostEnvironment, Language, LerbFinderComponent, LerbFinderMode, MAX_SEARCH_RESULTS, ProviderCategory, ProviderType, ProviderTypeId, QuickAccessFilterParamEnum, ScrollingClickEvent, avmProductName, avmRabatte, desktopBreakpoint, getAcceptPatientCodeByProduct, getConcatenatedProducts, getFormattedInput, getInputOption, getProviderTypeById, getProviderTypeByNum, getProviderTypeIdByProviderType, isAVMDiscount16Item, isDoctor, isDoctorItem, isFlexmed, isFlexmedItem, isSearchLerb, isStatusEqual, isZipLocation, lerbFinderRoutes, listWidthDesktop, mapHeightDesktop, mapHeightMobile, mapHeightMobileWithAdjustSearchButton, mobileBreakpoint, provideLerbFinder, tabletBreakpoint };
